import { ExperimentationProject } from '@thoughtspot/experimentation';
import _ from 'lodash';
const userActionTypes = {
    TEST: {
        name: 'test',
        tags: [],
    },
    TEST_EXPERIMENTATION: {
        name: 'test-experimentation',
        tags: [],
        shouldSendEventToExperimentationService: true,
        experimentationProject: ExperimentationProject.TEST_PROJECT1,
    },
    CHANGED_CHART_TYPE: {
        name: 'changed-chart-type',
        tags: ['chart', 'chart-config'],
    },
    CHART_MAX_DATA_POINTS: {
        name: 'chart-max-data-points',
        tags: ['chart', 'chart-config'],
    },
    TABLE_THEME: { name: 'table-theme', tags: ['table'] },
    TABLE_CONTENT_DENSITY: { name: 'table-content-density', tags: ['table'] },
    TABLE_TEXT_WRAP: { name: 'table-text-wrap', tags: ['table'] },
    TABLE_FOOTER: { name: 'table-footer', tags: ['table'] },
    COLUMN_SUMMARY: { name: 'column-summary', tags: ['table'] },
    CUSTOM_CHART_DATA_QUERY: {
        name: 'custom-chart-data-query',
        tags: ['custom-chart'],
    },
    UPDATE_CUSTOM_VISUAL_PROPS: {
        name: 'update-custom-visual-props',
        tags: ['custom-chart'],
    },
    UPDATE_TML_FROM_VIZ: {
        name: 'update-tml-from-viz',
        tags: ['custom-chart'],
    },
    AXIS_MENU_SORT_SELECTED: {
        name: 'axis-menu-sort-selected',
        tags: ['chart', 'chart-config'],
    },
    AXIS_MENU_TIME_BUCKET: {
        name: 'axis-time-bucket',
        tags: ['chart', 'chart-config'],
    },
    CLICK_AXIS_CARET_ICON: {
        name: 'click-axis-caret-icon',
        tags: ['chart'],
    },
    REMOVE_OR_MOVE_TO_NOT_VISUALIZED: {
        name: 'remove-or-move-to-not-visualized',
        tags: ['table', 'chart'],
    },
    NUMBER_FORMAT_CATEGORY: {
        name: 'number-format-category',
        tags: ['table', 'chart'],
    },
    NUMBER_FORMAT_UNIT: {
        name: 'number-format-unit',
        tags: ['table', 'chart'],
    },
    NUMBER_FORMAT_NEGATIVE_VALUES: {
        name: 'number-format-negative-values',
        tags: ['table', 'chart'],
    },
    SAVE_COLUMN_CONDITIONAL_FORMATTING: {
        name: 'save-column-conditional-formatting',
        tags: ['table', 'chart'],
    },
    SAVE_GRADIENT_FORMATTING: {
        name: 'save-gradient-formatting',
        tags: ['chart'],
    },
    EDIT_COLUMN: {
        name: 'edit-column',
        tags: ['table', 'chart'],
    },
    COLUMN_DISPLAY_SUMMARY: {
        name: 'column-display-summary',
        tags: ['table'],
    },
    COLUMN_RENAMED: {
        name: 'column-renamed',
        tags: ['table', 'chart'],
    },
    CLICK_HEADER_ELLIPSIS: {
        name: 'click-header-ellipsis',
        tags: ['table'],
    },
    COLUMN_HEADER_SORT_SELECTED: {
        name: 'column-header-sort-selected',
        tags: ['table'],
    },
    COLUMN_HEADER_TEXT_WRAP: {
        name: 'column-header-text-wrap',
        tags: ['table'],
    },
    COLUMN_HEADER_RENAME: {
        name: 'column-header-rename',
        tags: ['table'],
    },
    COLUMN_HEADER_RENAME_COMPLETE: {
        name: 'column-header-rename-complete',
        tags: ['table'],
    },
    COLUMN_HEADER_REMOVE: {
        name: 'column-header-remove',
        tags: ['table'],
    },
    COLUMN_HEADER_TIME_BUCKET: {
        name: 'column-header-time-bucket',
        tags: ['table'],
    },
    CLICK_AUTO_COMPLETE: { name: 'click-auto-complete', tags: ['search'] },
    CLICK_PIN_ICON: { name: 'click-pin-icon', tags: ['pinboard'] },
    COPY_TO_CLIPBOARD: { name: 'copy-to-clipboard', tags: ['table'] },
    DRILL_DOWN: { name: 'drill-down', tags: ['table', 'chart'] },
    CLICK_CREATE_PINBOARD_BUTTON: {
        name: 'click-create-pinboard-button',
        tags: ['pinboard'],
    },
    ADD_VIZ_TO_EXISTING_PINBOARD: {
        name: 'add-viz-to-existing-pinboard',
        tags: ['pinboard'],
    },
    ADD_VIZ_TO_NEW_PINBOARD: {
        name: 'add-viz-to-new-pinboard',
        tags: ['pinboard'],
    },
    ADD_VIZ_TO_PINBOARD: { name: 'add-viz-to-pinboard', tags: ['pinboard'] },
    DELETE_VIZ_FROM_PINBOARD: {
        name: 'delete-viz',
        tags: ['pinboard'],
    },
    FIRST_PIN_EXPERIENCE_BUTTON_CLICKED: {
        name: 'firstPinExperienceButtonClicked',
        shouldSendEventToExperimentationService: true,
        experimentationProject: ExperimentationProject.LEGACY_PINS_FLOW,
    },
    CREATE_PINBOARD: { name: 'create-pinboard', tags: ['pinboard'] },
    CREATE_LABEL: { name: 'create-label', tags: [] },
    DELETE_LABELS: { name: 'delete-labels', tags: [] },
    DELETE_METADATA_ITEMS: { name: 'delete-metadata-items', tags: [] },
    DELETE_PINBOARDS: { name: 'delete-pinboards', tags: ['pinboard'] },
    DELETE_PINBOARD: { name: 'delete-pinboard', tags: ['pinboard'] },
    DELETE_ANSWERS: { name: 'delete-answers', tags: ['answer'] },
    DELETE_ANSWER: { name: 'delete-answer', tags: ['answer'] },
    DELETE_TABLES: { name: 'delete-tables', tags: ['table'] },
    CREATE_RELATED_LINK: { name: 'create-related-link', tags: [] },
    UPDATE_RELATED_LINK: { name: 'update-related-link', tags: [] },
    DELETE_RELATED_LINK: { name: 'delete-related-link', tags: [] },
    TABLE_ADD_JOIN_BTN: { name: 'table-add-join', tags: [] },
    FROM_WORKSHEET_ADD_JOIN_BTN: { name: 'from-worksheet-add-join', tags: [] },
    FROM_MODAL_ADD_JOIN_BTN: { name: 'from-modal-add-join', tags: [] },
    FROM_VIEW_ADD_JOIN_BTN: { name: 'from-view-add-join', tags: [] },
    FROM_SQL_VIEW_ADD_JOIN_BTN: { name: 'from-sql-view-add-join', tags: [] },
    EDIT_JOIN_BTN: { name: 'edit-join-btn', tags: [] },
    DELETE_JOIN_BTN: { name: 'delete-join-btn', tags: [] },
    CREATE_RELATIONSHIP: {
        name: 'create-relationship',
        tags: ['create', 'relationship'],
    },
    UPDATE_RELATIONSHIP: { name: 'update-relationship', tags: [] },
    DELETE_RELATIONSHIP: { name: 'delete-relationship', tags: [] },
    RELATIONSHIP_ERROR: { name: 'relationship-error', tags: [] },
    FETCH_RELATED_LINK_DETAILS: {
        name: 'fetch-related-link-details',
        tags: [],
    },
    FETCH_EXCEL_DATA: { name: 'fetch-excel-data', tags: ['table'] },
    FETCH_RELATIONSHIP: { name: 'fetch-relationship', tags: [] },
    FETCH_INITIAL_JOIN_CREATION_DETAILS: {
        name: 'inital-join-creation-details',
        tags: [],
    },
    FETCH_TABLE_DETAILS: { name: 'fetch-table-details', tags: ['table'] },
    FETCH_TABLES_DETAILS: { name: 'fetch-tables-details', tags: ['table'] },
    FETCH_DATA_SOURCES_DETAILS: {
        name: 'fetch-data-sources-details',
        tags: [],
    },
    FETCH_DATA_SOURCE_DETAILS: { name: 'fetch-data-source-details', tags: [] },
    FETCH_METADATA_DETAILS: { name: 'fetch-metadata-details', tags: [] },
    FETCH_ANSWER_DETAILS: { name: 'fetch-answer-details', tags: ['answer'] },
    RENDER_RESULT: { name: 'render-result', tags: ['answer'] },
    FETCH_PINBOARD_DETAILS: {
        name: 'fetch-pinboard-details',
        tags: ['pinboard'],
    },
    FETCH_WORKSHEET_DETAILS: {
        name: 'fetch-worksheet-details',
        tags: ['worksheet'],
    },
    FETCH_DATA_EVENT: {
        name: 'data-fetch-event',
        tags: ['answer'],
    },
    SAVE_VIEW_MODEL: { name: 'save-view-model', tags: ['view'] },
    SAVE_TABLE_MODEL: { name: 'save-table-model', tags: ['table'] },
    SAVE_VIZ_CONTEXT: { name: 'save-viz-context', tags: [] },
    SAVE_ANSWER_MODEL: { name: 'save-answer-model', tags: ['save', 'answer'] },
    SAVE_PINBOARD_MODEL: {
        name: 'save-pinboard-model',
        tags: ['save', 'pinboard'],
    },
    SAVE_WORKSHEET_MODEL: { name: 'save-worksheet-model', tags: ['worksheet'] },
    SAVE_AS_ANSWER_MODEL: { name: 'save-as-answer-model', tags: ['answer'] },
    SAVE_AS_PINBOARD_MODEL: {
        name: 'save-as-pinboard-model',
        tags: ['pinboard'],
    },
    SAVE_AS_WORKSHEET_MODEL: {
        name: 'save-as-worksheet-model',
        tags: ['worksheet'],
    },
    CLONE_WORKSHEET: {
        name: 'clone-worksheet',
        tags: ['worksheet'],
    },
    MODEL_EDIT: {
        name: 'model-edit',
        tags: [],
    },
    SAVE_WORKSHEET: {
        name: 'save-worksheet',
        tags: ['worksheet'],
    },
    PARAM_EDIT_DIALOG_OPEN: {
        name: 'param-edit-dialog-open',
    },
    PARAM_EDIT_DIALOG_SAVE: {
        name: 'param-edit-dialog-save',
        tags: ['save'],
    },
    PARAM_EDIT_DIALOG_SAVE_FAIL: {
        name: 'param-edit-dialog-save-fail',
    },
    PARAM_EDIT_DIALOG_CANCEL: {
        name: 'param-edit-dialog-cancel',
    },
    PARAM_DELETE: {
        name: 'param-delete',
    },
    PARAM_OVERRIDE_DIALOG_OPEN: {
        name: 'param-override-dialog-open',
    },
    PARAM_OVERRIDE_DIALOG_SAVE: {
        name: 'param-override-dialog-save',
        tags: ['save'],
    },
    PARAM_OVERRIDE_DIALOG_SAVE_FAIL: {
        name: 'param-override-dialog-save-fail',
    },
    PARAM_OVERRIDE_DIALOG_CANCEL: {
        name: 'param-override-dialog-cancel',
    },
    PARAM_OVERRIDE_DIALOG_RESET: {
        name: 'param-override-dialog-reset',
    },
    COHORT_EDIT_OPEN: {
        name: 'cohort-edit-open',
    },
    COHORT_SAVE: {
        name: 'cohort-save',
        tags: ['save'],
    },
    COHORT_SAVE_FAIL: {
        name: 'cohort-save-fail',
    },
    COHORT_EDIT_CANCEL: {
        name: 'cohort-edit-cancel',
    },
    COHORT_ADD_AS_FILTER: {
        name: 'cohort-add-as-filter',
    },
    COHORT_DELETE: {
        name: 'cohort-delete',
    },
    COHORT_EDIT_STARTED: {
        name: 'cohort-edit-started',
    },
    COHORT_EDIT_TML_STARTED: {
        name: 'cohort-edit-tml-started',
    },
    ADD_COHORT_FROM_LEFT_PANEL_TO_SEARCH: {
        name: 'add-cohort-from-left-panel-to-search',
    },
    CREATE_OBJECT_FROM_LEFT_PANEL_STARTED: {
        name: 'create-object-from-left-panel-stated',
    },
    OBJECT_CREATION_FINISHED: {
        name: 'object-creation-finished',
    },
    SAVE_TAG: { name: 'save-tag', tags: [] },
    ASSIGN_TAG: { name: 'assign-tag', tags: [] },
    UNASSIGN_TAG: { name: 'unassign-tag', tags: [] },
    ADD_FAVORITE: { name: 'add-favorite', tags: [] },
    DELETE_FAVORITE: { name: 'delete-favorite', tags: [] },
    ADD_SUBSCRIPTION: { name: 'add-subscription', tags: [] },
    DELETE_SUBSCRIPTION: { name: 'delete-subscription', tags: [] },
    UPDATE_SUBSCRIPTION: { name: 'update-subscription', tags: [] },
    EXPORT_OBJECTS: { name: 'export-objects', tags: [] },
    IMPORT_OBJECTS: { name: 'import-objects', tags: [] },
    FETCH_METADATA_LIST: { name: 'fetch-metadata-list', tags: [] },
    FETCH_TABLE_LIST: {
        name: 'fetch-table-list',
        tags: ['table', 'list', 'fetch'],
    },
    FETCH_RELATIONSHIP_LIST: { name: 'fetch-relationship-list', tags: [] },
    FETCH_ANSWER_LIST: { name: 'fetch-answer-list', tags: ['answer'] },
    FETCH_PINBOARD_LIST: { name: 'fetch-pinboard-list', tags: ['pinboard'] },
    FETCH_WORKSHEET_LIST: { name: 'fetch-worksheet-list', tags: ['worksheet'] },
    FETCH_VIEW_LIST: { name: 'fetch-aggr-worksheet-list', tags: ['view'] },
    FETCH_IMPORTED_DATA_LIST: { name: 'fetch-imported-data-list', tags: [] },
    FETCH_SYSTEM_TABLE_LIST: {
        name: 'fetch-system-table-list',
        tags: ['table'],
    },
    FETCH_DB_VIEW_LIST: { name: 'fetch-db-view-list', tags: [] },
    FETCH_DATA_SOURCE_LIST: { name: 'fetch-data-source-list', tags: [] },
    FETCH_COLUMN_LIST: { name: 'fetch-column-list', tags: [] },
    FETCH_EMBRACE_CONNECTION_LIST: {
        name: 'fetch-embrace-connection-list',
        tags: [],
    },
    FETCH_TAG_LIST: { name: 'fetch-tag-list', tags: [] },
    LOAD_ANSWER: { name: 'load-answer', tags: ['answer'] },
    LOAD_ANSWER_FAILURE: { name: 'load-answer-failure', tags: ['answer'] },
    REDIRECTED_TO_PINBOARD: {
        name: 'redirected-to-pinboard',
        tags: ['pinboard'],
    },
    LOAD_PINBOARD: { name: 'load-pinboard', tags: ['pinboard'] },
    PINBOARD_LOADING_STARTED: {
        name: 'pinboard-loading-started',
        tags: ['pinboard'],
    },
    PINBOARD_CONTENT_LOADING_STARTED: {
        name: 'pinboard-content-loading-started',
        tags: ['pinboard'],
    },
    PINBOARD_RENDER_COMPLETE: {
        name: 'pinboard-render-complete',
        tags: ['pinboard'],
    },
    PINBOARD_VIZ_LOADING_STARTED: {
        name: 'pinboard-viz-loading-started',
        tags: ['pinboard'],
    },
    PINBOARD_VIZ_RENDER_COMPLETE: {
        name: 'pinboard-viz-render-complete',
        tags: ['pinboard'],
    },
    PINBOARD_VIZ_QUERY_TIME_TAKEN_CDW: {
        name: 'queryTimeTakenCDW',
        tags: ['pinboard'],
    },
    LOAD_PINBOARD_SESSION_API_STARTED: {
        name: 'load-pinboard-session-api-started',
        tags: ['pinboard'],
    },
    LOAD_PINBOARD_SESSION_API_COMPLETE: {
        name: 'load-pinboard-session-api-complete',
        tags: ['pinboard'],
    },
    PINBOARD_FIRST_LOAD_CONTEXT_BOOK_STARTED: {
        name: 'pinboard-first-load-context-book-started',
        tags: ['pinboard'],
    },
    PINBOARD_LOAD_CONTEXT_BOOK_STARTED: {
        name: 'pinboard-load-context-book-started',
        tags: ['pinboard'],
    },
    PINBOARD_LOAD_CONTEXT_BOOK_COMPLETE: {
        name: 'pinboard-load-context-book-complete',
        tags: ['pinboard'],
    },
    PINBOARD_PERF_METRICS: {
        name: 'pinboard-perf-metrics',
        tags: ['pinboard'],
    },
    FETCH_ANSWER: { name: 'fetch-answer', tags: ['fetch', 'answer', 'ad-hoc'] },
    FETCH_SAVED_ANSWER: {
        name: 'fetch-saved-answer',
        tags: ['fetch', 'answer', 'saved'],
    },
    FETCH_ANSWER_FILTER: {
        name: 'fetch-answer-filter',
        tags: ['fetch', 'answer', 'filter'],
    },
    FETCH_PINBOARD: { name: 'fetch-pinboard', tags: ['fetch', 'pinboard'] },
    FETCH_WORKSHEET: { name: 'fetch-worksheet', tags: ['fetch', 'worksheet'] },
    FETCH_LEAF_LEVEL_DATA: { name: 'fetch-leaf-level-data', tags: [] },
    FETCH_PINBOARD_AS_PDF: {
        name: 'fetch-pinboard-as-pdf',
        tags: ['pinboard'],
    },
    EDITED_PINBOARD_TITLE: {
        name: 'edited-pinboard-title',
        tags: ['pinboard'],
    },
    EDITED_PINBOARD_DESCRIPTION: {
        name: 'edited-pinboard-description',
        tags: ['pinboard'],
    },
    FETCH_ANSWER_AS_PNG: { name: 'fetch-answer-as-png', tags: ['answer'] },
    FETCH_VIZ_DATA: { name: 'fetch-viz-data', tags: [] },
    FETCH_VIZS_DATA: { name: 'fetch-vizs-data', tags: [] },
    FETCH_CHART_DATA: { name: 'fetch-chart-data', tags: [] },
    EDIT_CHART_CONFIG: { name: 'edit-chart-config', tags: [] },
    FETCH_TABLE_DATA: { name: 'fetch-table-data', tags: ['table'] },
    UPLOAD_TRANSLATIONS: { name: 'upload-translations', tags: [] },
    DELETE_TRANSLATIONS: { name: 'delete-translations', tags: [] },
    DOWNLOAD_TRANSLATIONS: { name: 'download-translations', tags: [] },
    FETCH_WORKSHEET_DATA: { name: 'fetch-worksheet-data', tags: ['worksheet'] },
    FETCH_FILTER_DATA: { name: 'fetch-filter-data', tags: [] },
    UPDATE_HEADLINE_DATA: { name: 'update-headline-data', tags: [] },
    FETCH_NATURAL_QUERY: { name: 'fetch-natural-query', tags: [] },
    CREATE_WORKSHEET: { name: 'create-worksheet', tags: ['worksheet'] },
    UPDATE_WORKSHEET: { name: 'update-worksheet', tags: ['worksheet'] },
    CREATE_ANSWER: { name: 'create-answer', tags: ['answer'] },
    UPDATE_ANSWER: { name: 'update-answer', tags: ['answer'] },
    UPDATE_PINBOARD: { name: 'update-pinboard', tags: ['pinboard'] },
    CREATE_VIEW: { name: 'create-view', tags: ['view'] },
    UPDATE_VIEW: { name: 'update-view', tags: ['view'] },
    DEMATERIALIZE_VIEW: { name: 'dematerialize-view', tags: ['view'] },
    VIEW_MATERIALIZATION_STATUS: {
        name: 'view-materialization-status',
        tags: ['view'],
    },
    REFRESH_MATERIALIZED_VIEW: {
        name: 'refresh-materialized-view',
        tags: ['view'],
    },
    MATERIALIZE_VIEW: { name: 'materialize-view', tags: ['view'] },
    UPDATE_MATERIALIZE_VIEW: {
        name: 'update-materialize-view',
        tags: ['view'],
    },
    GET_MATERIALIZE_SCHEDULE: {
        name: 'get-materialize-status',
        tags: ['view'],
    },
    ADD_MATERIALIZE_SCHEDULE: {
        name: 'add-materialize-status',
        tags: ['view'],
    },
    DELETE_MATERIALIZE_SCHEDULE: {
        name: 'delete-materialize-status',
        tags: ['view'],
    },
    PAUSE_MATERIALIZE_SCHEDULE: {
        name: 'pause-materialize-status',
        tags: ['view'],
    },
    RESUME_MATERIALIZE_SCHEDULE: {
        name: 'resume-materialize-status',
        tags: ['view'],
    },
    UPDATE_MATERIALIZE_SCHEDULE: {
        name: 'update-materialize-status',
        tags: ['view'],
    },
    FETCH_ANSWER_VIEW: {
        name: 'fetch-answer-agg-worksheet',
        tags: ['fetch', 'view'],
    },
    FETCH_TABLE_DEPENDENTS: { name: 'fetch-table-dependents', tags: ['table'] },
    FETCH_COLUMN_DEPENDENTS: { name: 'fetch-column-dependents', tags: [] },
    FETCH_INCOMPLETE_LIST: { name: 'fetch-incomplete-list', tags: [] },
    CREATE_FORMULA: { name: 'create-formula', tags: ['create', 'formula'] },
    ANSWER_TITLE_EDIT: { name: 'edited-answer-title', tags: [] },
    ANSWER_DESCRIPTION_EDIT: { name: 'edited-answer-description', tags: [] },
    SAVE_TITLE_DESCRIPTION: { name: 'save-title-description', tags: [] },
    UPDATE_FORMULA: { name: 'update-formula', tags: [] },
    CLICK_SPOTIQ_TAB: { name: 'click-spotiq-tab', tags: ['spotiq'] },
    SAVE_SPOTIQ_INSIGHT_PINBOARD: {
        name: 'save-spotiq-insight-pinboard',
        tags: ['save', 'spotiq', 'insight', 'pinboard'],
    },
    LOAD_SPOTIQ_INSIGHT_TAB: {
        name: 'load-spotiq-insight-tab',
        tags: [],
    },
    KPI_CHANGE_ANALYSIS_BUTTON_CLICK: {
        name: 'kpi-change-analysis-button-click',
        tags: [],
    },
    TAKE_ME_TO_ANALYSIS_BUTTON_CLICK: {
        name: 'take-me-to-analysis-button-click',
        tags: [],
    },
    CUSTOMIZE_ANALYSIS_CLICK: {
        name: 'customize-analysis-click',
        tags: [],
    },
    COPY_AND_EDIT_PINBOARD_VIZ: {
        name: 'copy-and-edit-pinboard-viz',
    },
    COPY_PINBOARD: {
        name: 'copy-pinboard',
        tags: ['pinboard'],
    },
    COPY_AND_EDIT_ANSWER: {
        name: 'copy-and-edit-answer',
        tags: ['answer'],
    },
    DOWNLOAD_PINBOARD_VIZ: {
        name: 'download-pinboard-viz',
        tags: ['download', 'pinboard'],
    },
    DOWNLOAD_SPOTIQ_INSIGHT_PINBOARD: {
        name: 'download-spotiq-insight-pinboard',
        tags: ['download', 'spotiq', 'insight', 'pinboard'],
    },
    PRESENT_PINBOARD: {
        name: 'present-pinboard',
        tags: ['present', 'pinboard'],
    },
    PRESENT_SPOTIQ_INSIGHT_PINBOARD: {
        name: 'present-spotiq-insight-pinboard',
        tags: ['present', 'spotiq', 'insight', 'pinboard'],
    },
    PRESENT_KEY_PRESS: {
        name: 'present-key-press',
        tags: ['present', 'pinboard', 'key-press'],
    },
    REQUEST_VERIFICATION: {
        name: 'request-verification-pinboard',
        tags: ['request', 'verification', 'pinboard'],
    },
    REMOVE_VERIFICATION: {
        name: 'remove-pinboard',
        tags: ['remove', 'verification', 'pinboard'],
    },
    SCHEDULE_PINBOARD: {
        name: 'schedule-pinboard',
        tags: ['schedule', 'pinboard'],
    },
    SCHEDULE_SHOW_ADVANCED_SETTINGS: {
        name: 'schedule-show-advanced-settings',
        tags: ['schedule', 'pinboard'],
    },
    SCHEDULE_EDIT: {
        name: 'schedule-edit',
        tags: ['schedule', 'pinboard'],
    },
    SCHEDULE_VIEW_RUN_HISTORY: {
        name: 'schedule-view-run-history',
        tags: ['schedule', 'pinboard'],
    },
    SCHEDULE_DELETE: {
        name: 'schedule-delete',
        tags: ['schedule', 'pinboard'],
    },
    SCHEDULE_DELETED: {
        name: 'schedule-deleted',
        tags: ['schedule', 'pinboard'],
    },
    SCHEDULE_PAUSE_OR_RESUME: {
        name: 'schedule-pause-or-resume',
        tags: ['schedule', 'pinboard'],
    },
    OPEN_SPOTIQ_INSIGHT_PINBOARD: {
        name: 'open-spotiq-insight-pinboard',
        tags: ['open', 'spotiq', 'insight', 'pinboard'],
    },
    OPEN_CUSTOM_R_VISUALIZATION: {
        name: 'open-custom-r-visualization',
        tags: ['open', 'custom-r'],
    },
    OPEN_SPOTIQ_JOB: { name: 'open-spotiq-job', tags: ['spotiq', 'job'] },
    OPEN_SPOTIQ_INFOCARD_PINBOARD: {
        name: 'open-spotiq-infocard-pinboard',
        tags: ['open', 'spotiq', 'infocard', 'pinboard'],
    },
    OPEN_SPOTIQ_INFOCARD_INSIGHT: {
        name: 'open-spotiq-infocard-insight',
        tags: ['open', 'spotiq', 'infocard', 'insight'],
    },
    OPEN_CUSTOM_R_INFOCARD: {
        name: 'open-custom-r-infocard',
        tags: ['open', 'custom-r', 'infocard'],
    },
    TRIAL_EXPIRY_MESSAGE_SEEN: {
        name: 'trial-expiry-message-seen',
        tags: [],
    },
    TRIAL_EXPIRY_MESSAGE_CLICKED: {
        name: 'trial-expiry-message-clicked',
        tags: [],
    },
    TEAM_REACTIVATE_SUBSCRIPTION_MESSAGE_CLICKED: {
        name: 'team-reactivate-subscription-message-clicked',
        tags: [],
    },
    TEAM_LEFT_PANEL: {
        name: 'team-left-panel',
        tags: [],
    },
    TEAM_FEATURE_HIGHLIGHT_CLICK: {
        name: 'team-feature-highlight-click',
        tags: [],
    },
    TEAM_FEATURE_HIGHLIGHT_SEEN: {
        name: 'team-feature-highlight-seen',
        tags: [],
    },
    TEAM_DEACTIVATE_USER: {
        name: 'team-deactivate-user',
        tags: [],
    },
    TEAM_DELETE_USER: {
        name: 'team-delete-user',
        tags: [],
    },
    TEAM_RESEND_INVITATION: {
        name: 'team-resend-invitation',
        tags: [],
    },
    CONTACT_US_FREE_TRIAL_UPGRADE: {
        name: 'contact-us-free-trial-upgrade',
        tags: ['contact-us', 'free-trial'],
    },
    TEAM_PRICING_EXPIRED_ENTRY: {
        name: 'team-pricing-expired-entry',
        tags: ['free-trial'],
    },
    CREATE_SPOTIQ_INSTANT_INSIGHTS: {
        name: 'create-spotiq-instant-insights',
        tags: ['create', 'spotiq', 'instant', 'insights'],
    },
    CREATE_SPOTIQ_RELATED_QUERIES: {
        name: 'create-spotiq-related-queries',
        tags: ['create', 'spotiq', 'related-queries'],
    },
    CREATE_SPOTIQ_INSTANT_TABLE_INSIGHTS: {
        name: 'create-spotiq-instant-table-insights',
        tags: ['create', 'spotiq', 'instant', 'table', 'insights'],
    },
    CREATE_SPOTIQ_PINBOARD_EXECUTIVE_SUMMARY: {
        name: 'create-spotiq-pinboard-executive-summary',
        tags: ['create', 'spotiq', 'pinboard', 'executive', 'summary'],
    },
    CREATE_SPOTIQ_USER_HOMEPAGE_INSIGHTS: {
        name: 'create-spotiq-user-homepage-insights',
        tags: ['create', 'spotiq', 'homepage', 'instant', 'insights'],
    },
    CLICK_SPOTIQ_INSTANT_INSIGHTS: {
        name: 'click-spotiq-instant-insights',
        tags: ['click', 'spotiq', 'instant', 'insights'],
    },
    SHOW_MORE_SPOTIQ_INSTANT_INSIGHTS: {
        name: 'show-more-spotiq-instant-insights',
        tags: ['show-more', 'spotiq', 'instant', 'insights'],
    },
    ANSWER_VERSION_SWITCH: {
        name: 'answer-version-switch',
        tags: ['user-preference', 'answer'],
    },
    CLICK_SPOTIQ_USER_PREFERENCE_EXCLUDE_NULL: {
        name: 'click-spotiq-user-preference-exclude-null',
        tags: ['click', 'spotiq', 'user-preference', 'exclude-null'],
    },
    CLICK_SPOTIQ_USER_PREFERENCE_EMAIL_ON_SUCCESS: {
        name: 'click-spotiq-user-preference-email-on-success',
        tags: ['click', 'spotiq', 'user-preference', 'email-on-success'],
    },
    CLICK_SPOTIQ_USER_PREFERENCE_EMAIL_ON_FAILURE: {
        name: 'click-spotiq-user-preference-email-on-failure',
        tags: ['click', 'spotiq', 'user-preference', 'email-on-failure'],
    },
    CLICK_SPOTIQ_USER_PREFERENCE_EMAIL_PDF: {
        name: 'click-spotiq-user-preference-email-pdf',
        tags: ['click', 'spotiq', 'user-preference', 'email-pdf'],
    },
    CLICK_SPOTIQ_USER_PREFERENCE_EXCLUDE_ZERO_MEASURE: {
        name: 'click-spotiq-user-preference-exclude-zero-measure',
        tags: ['click', 'spotiq', 'user-preference', 'exclude-zero-measure'],
    },
    CLICK_SPOTIQ_USER_PREFERENCE_AUTOTUNE_DATE_BOUNDARY: {
        name: 'click-spotiq-user-preference-autotune-date-boundary',
        tags: ['click', 'spotiq', 'user-preference', 'autotune-date-boundary'],
    },
    SAVE_SPOTIQ_PREFERENCES: {
        name: 'save-spotiq-preferences',
        tags: ['spotiq', 'user-preference'],
    },
    SUBMIT_LIKE_FEEDBACK: {
        name: 'submit-like-feedback',
        tags: ['submit', 'like', 'feedback'],
    },
    SUBMIT_DISLIKE_FEEDBACK: {
        name: 'submit-dislike-feedback',
        tags: ['submit', 'dislike', 'feedback'],
    },
    CLICK_DISLIKE_FEEDBACK: {
        name: 'click-dislike-feedback',
        tags: ['dislike', 'feedback'],
    },
    CREATE_SPOTIQ_ANALYSIS: {
        name: 'create-spotiq-analysis',
        tags: ['spotiq'],
    },
    INVOKE_SPOTIQ_ANALYSIS: {
        name: 'invoke-spotiq-analysis',
        tags: ['spotiq'],
    },
    SPOTIQ_CONFIG_LOAD: {
        name: 'spotiq-config-load',
        tags: ['spotiq'],
    },
    SPOTIQ_MODAL_ANALYSIS_SELECTED: {
        name: 'spotiq-modal-analysis-selected',
        tags: ['spotiq'],
    },
    SPOTIQ_MODAL_CONFIG_VIEWED: {
        name: 'spotiq-modal-config-viewed',
        tags: ['spotiq'],
    },
    SPOTIQ_MODAL_CUSTOMISE_PARAMETERS_VIEWED: {
        name: 'spotiq-modal-customise-parameters-viewed',
        tags: ['spotiq'],
    },
    CREATE_SPOTIQ_ANALYSIS_FROM_DISLIKE: {
        name: 'create-spotiq-analysis-from-dislike',
        tags: ['spotiq'],
    },
    SCHEDULE_SPOTIQ_ANALYSIS: {
        name: 'schedule-spotiq-analysis',
        tags: ['schedule', 'spotiq'],
    },
    OPEN_SPOTIQ_INSTANT_INSIGHT: {
        name: 'open-spotiq-instant-insight',
        tags: ['open', 'spotiq', 'instant-insight'],
    },
    OPEN_SPOTIQ_RELATED_QUERY: {
        name: 'open-spotiq-related-query',
        tags: ['open', 'spotiq', 'related-queries'],
    },
    SPOTIQ_FOLLOW_MGMT_SUBSCRIPTION_CLICKED: {
        name: 'spotiq_follow_mgmt_subscription_clicked',
    },
    SPOTIQ_FOLLOW_SUBSCRIPTION_HOME_PAGE_CARD_CLICKED: {
        name: 'spotiq_follow_subscription_home_page_card_clicked',
    },
    SPOTIQ_FOLLOW_SUBSCRIPTION_HOME_PAGE_CARD_PINBOARD_LINK_CLICK: {
        name: 'spotiq_follow_subscription_home_page_card_pinboard_link_clicked',
    },
    WATCH_DETAIL_SNAPSHOT_DATA_FETCH_FAILED: {
        name: 'watch_detail_snapshot_data_fetch_failed',
    },
    WATCH_DETAIL_SNAPSHOT_METADATA_FETCH_FAILED: {
        name: 'watch_snapshot_metadata_fetch_failed',
    },
    CREATE_SPOTIQ_WATCH: {
        name: 'create-spotiq-watch',
        tags: ['spotiq', 'watch'],
    },
    SPOTIQ_FOLLOW_SUBSCRIBE: { name: 'spotiq_follow_subscribe' },
    SPOTIQ_FOLLOW_ADD_OTHERS: { name: 'spotiq_follow_add_others' },
    SPOTIQ_FOLLOW_SUBSCRIBE_AND_ADD_OTHERS: {
        name: 'spotiq_follow_subscribe_and_add_others',
    },
    SPOTIQ_FOLLOW_OPEN_SUBSCRIBE_DIALOG: {
        name: 'spotiq_follow_open_subscribe_dialog',
    },
    SPOTIQ_FOLLOW_SUBSCRIBE_DIALOG_RADIO_BTN_CLICK: {
        name: 'spotiq_follow_subscribe_dialog_radio_btn_click',
    },
    SPOTIQ_FOLLOW_SUBSCRIBE_DIALOG_ADD_MESSAGE_CLICK: {
        name: 'spotiq_follow_subscribe_dialog_add_message_click',
    },
    SPOTIQ_FOLLOW_SUBSCRIBE_DIALOG_USER_ADDED_WITH_WARNING: {
        name: 'spotiq_follow_subscribe_dialog_user_added_with_warning',
    },
    SPOTIQ_FOLLOW_LIST_PAGE_VISITED_FROM_EMAIL: {
        name: 'spotiq_follow_list_page_visited_from_email',
    },
    SPOTIQ_FOLLOW_DETAIL_PAGE_SWITCH_MODE: {
        name: 'spotiq_follow_detail_page_switch_mode',
    },
    SPOTIQ_FOLLOW_CLICK_DATE_RANGE: { name: 'spotiq_follow_click_date_range' },
    SPOTIQ_FOLLOW_CHART_DRAG: { name: 'spotiq_follow_chart_drag' },
    SPOTIQ_FOLLOW_CHART_POINT_CLICKED: {
        name: 'spotiq_follow_chart_point_clicked',
    },
    SPOTIQ_FOLLOW_RENAME_FOLLOW: { name: 'spotiq_follow_rename_follow' },
    SPOTIQ_FOLLOW_SEE_PINBOARD: { name: 'spotiq_follow_see_pinboard' },
    OPEN_SPOTIQ_FOLLOW_DETAIL_PAGE: { name: 'open_spotiq_follow_detail_page' },
    OPEN_SPOTIQ_WATCH: {
        name: 'create-spotiq-watch',
        tags: ['spotiq', 'watch'],
    },
    CLICK_SPOTIQ_WATCH_ANALYSIS: {
        name: 'click-spotiq-watch-analysis',
        tags: ['spotiq', 'watch'],
    },
    SPOTIQ_FOLLOW_UNSUBSCRIBE: { name: 'spotiq_follow_unsubscribe' },
    CLICK_CORTEX_ANOMALY: {
        name: 'click_cortex_anomaly',
        tags: ['spotiq', 'cortex', 'kpi'],
    },
    DETECTING_ANOMALY: {
        name: 'detecting_anomaly',
        tags: ['spotiq', 'cortex', 'kpi'],
    },
    CORTEX_LOAD: {
        name: 'cortex_load',
        tags: ['spotiq', 'cortex', 'kpi'],
    },
    PINBOARD_CLUSTER_VIZ_VIEWED: { name: 'pinboard_cluster_viz_viewed' },
    EDIT_PINBOARD_VIZ: { name: 'edit_pinboard_viz' },
    FETCH_MEM_CACHE_STATS: { name: 'fetch-mem-cache-stats', tags: [] },
    CLEAR_MEM_CACHE: { name: 'clear-mem-cache', tags: [] },
    SEARCH_MEM_CACHE: { name: 'search-mem-cache', tags: [] },
    FETCH_LOGGERS: { name: 'fetch-loggers', tags: [] },
    SET_LOG_LEVEL: { name: 'set-log-level', tags: [] },
    GET_DEBUG_INFO: { name: 'get-debug-info', tags: [] },
    FETCH_R_TEMPLATE_LIST: {
        name: 'fetch-r-template-list',
        tags: ['fetch', 'r-template', 'list'],
    },
    FETCH_TABLE_PERMISSIONS: {
        name: 'fetch-table-permissions',
        tags: ['table'],
    },
    FETCH_ANSWER_PERMISSIONS: {
        name: 'fetch-answer-permissions',
        tags: ['answer'],
    },
    FETCH_PINBOARD_PERMISSIONS: {
        name: 'fetch-pinboard-permissions',
        tags: ['pinboard'],
    },
    FETCH_METADATA_PERMISSIONS: {
        name: 'fetch-metadata-permissions',
        tags: [],
    },
    CACHE_DATA: { name: 'cache-data', tags: [] },
    READ_COLUMNS: { name: 'read-columns', tags: [] },
    READ_KEYS: { name: 'read-keys', tags: [] },
    READ_RELATIONSHIPS: { name: 'read-relationships', tags: [] },
    LOAD_DATA: { name: 'load-data', tags: [] },
    CREATE_TABLE: { name: 'create-table', tags: ['table'] },
    FETCH_DATA_ROWS: { name: 'fetch-data-rows', tags: [] },
    DELETE_FILES: { name: 'delete-files', tags: [] },
    ABORT_CREATE_TABLE: { name: 'abort-create-table', tags: ['table'] },
    FETCH_SCHEMA: { name: 'fetch-schema', tags: [] },
    FETCH_TABLE_MODELS: { name: 'fetch-table-models', tags: ['table'] },
    FETCH_SAMPLE_VALUES: { name: 'fetch-sample-values', tags: [] },
    PARSE_SQL: { name: 'parse-sql', tags: [] },
    EXECUTE_SQL: { name: 'execute-sql', tags: [] },
    FETCH_USERS_LIST: { name: 'fetch-users-list', tags: [] },
    FETCH_GROUPS_LIST: { name: 'fetch-groups-list', tags: [] },
    FETCH_JOB_LIST: { name: 'fetch-jobs-list', tags: [] },
    FETCH_ROLES_LIST: { name: 'fetch-roles-list', tags: [] },
    FETCH_USERS_AND_GROUPS_LIST: {
        name: 'fetch-users-and-groups-list',
        tags: [],
    },
    CREATE_USER: { name: 'create-user', tags: [] },
    ADD_USER_CLICKED: { name: 'add-user-clicked', tags: [] },
    CREATE_JOB: { name: 'create-job', tags: [] },
    CREATE_GROUP: { name: 'create-group', tags: [] },
    CREATE_ROLE: { name: 'create-role', tags: [] },
    UPDATE_USER_CLICKED: { name: 'update-user-clicked', tags: [] },
    UPDATE_USER: { name: 'update-user', tags: [] },
    UPDATE_JOB: { name: 'update-job', tags: [] },
    UPDATE_USERS: { name: 'update-users', tags: [] },
    UPDATE_GROUP: { name: 'update-group', tags: [] },
    UPDATE_PASSWORD: { name: 'update-password', tags: [] },
    UPDATE_ROLE: { name: 'update-role', tags: [] },
    DELETE_USERS: { name: 'delete-users', tags: [] },
    DELETE_GROUPS: { name: 'delete-groups', tags: [] },
    DELETE_ROLE: { name: 'delete-role', tags: [] },
    DELETE_JOB: { name: 'delete-job', tags: [] },
    PAUSE_JOB: { name: 'pause-job', tags: [] },
    RESUME_JOB: { name: 'resume-job', tags: [] },
    ASSIGN_USERS_TO_GROUPS: { name: 'assign-users-to-groups', tags: [] },
    ASSIGN_USERS_TO_ORG: { name: 'assign-users-to-org', tags: [] },
    RESEND_ACTIVATION_EMAIL: { name: 'resend-activation-email', tags: [] },
    SSO_LOGIN_REDIRECT: { name: 'sso-login-redirect', tags: [] },
    SSO_LOGIN_AUTO_REDIRECT: { name: 'sso-login-auto-redirect', tags: [] },
    SAML_LOGIN_REDIRECT: { name: 'saml-login-redirect', tags: [] },
    SAML_LOGIN_AUTO_REDIRECT: { name: 'saml-login-auto-redirect', tags: [] },
    LOGIN_FAILURE: { name: 'login-failure', tags: [] },
    OKTA_ACCOUNT_ACTIVATION_VERIFY: {
        name: 'okta-account-activation-verify',
        tags: [],
    },
    OKTA_ACCOUNT_ACTIVATION_VERIFY_FAILURE: {
        name: 'okta-account-activation-verify-failure',
        tags: [],
    },
    OKTA_ACCOUNT_ACTIVATION_FAILURE: {
        name: 'okta-account-activation-failure',
        tags: [],
    },
    FORGOT_PASSWORD: {
        name: 'forgot-password',
        tags: [],
    },
    OKTA_EMAIL_FACTOR_ENABLED: {
        name: 'okta-email-factor-enabled',
        tags: [],
    },
    OKTA_EMAIL_FACTOR_DISABLED: {
        name: 'okta-email-factor-disbaled',
        tags: [],
    },
    OKTA_PUSH_FACTOR_ENABLED: {
        name: 'okta-push-factor-enabled',
        tags: [],
    },
    OKTA_PUSH_FACTOR_DISABLED: {
        name: 'okta-push-factor-disabled',
        tags: [],
    },
    OKTA_OTP_FACTOR_ENABLED: {
        name: 'okta-otp-factor-enabled',
        tags: [],
    },
    OKTA_OTP_FACTOR_DISABLED: {
        name: 'okta-otp-factor-disabled',
        tags: [],
    },
    GOOGLE_OTP_FACTOR_ENABLED: {
        name: 'google-otp-factor-enabled',
        tags: [],
    },
    GOOGLE_OTP_FACTOR_DISABLED: {
        name: 'google-otp-factor-disabled',
        tags: [],
    },
    FORGOT_PASSWORD_FAILURE: { name: 'forgot-password-failure', tags: [] },
    ASSIGN_PRINCIPALS_TO_ROLES: {
        name: 'assign-principals-to-roles',
        tags: [],
    },
    ASSIGN_GROUPS_TO_GROUP: { name: 'assign-groups-to-group', tags: [] },
    GET_SESSION_INFO: { name: 'get-session-info', tags: [] },
    LOGIN: { name: 'login', tags: [] },
    LOGOUT: { name: 'logout', tags: [] },
    SAVE_CLIENT_STATE: { name: 'save-client-state', tags: [] },
    FETCH_DATA_SOURCE_TYPES: { name: 'fetch-data-source-types', tags: [] },
    FETCH_DATA_SOURCE_SAMPLE_VALUES: {
        name: 'fetch-data-source-sample-values',
        tags: [],
    },
    FETCH_QV_SPEC: { name: 'fetch-qv-spec', tags: [] },
    FETCH_COLUMN_STATISTICS: { name: 'fetch-column-statistics', tags: [] },
    ADD_SEARCH_DATA_SOURCE: { name: 'add-search-data-source', tags: [] },
    CUSTOM_COLUMN_GROUPS_LOADED_IN_LEFT_PANEL: {
        name: 'custom-column-groups-loaded-in-left-panel',
        tags: ['left-panel'],
    },
    ADD_COLUMN_FROM_LEFT_PANEL_TO_SEARCH: {
        name: 'add-column-from-left-panel-to-search',
        tags: ['left-panel'],
    },
    ADD_FORMULA_FROM_LEFT_PANEL_TO_SEARCH: {
        name: 'add-formula-from-left-panel-to-search',
        tags: ['left-panel'],
    },
    CLICK_ON_DATA_PANEL_ITEM: {
        name: 'click-on-data-panel-item',
        tags: ['left-panel'],
    },
    REMOVE_COLUMN_FROM_LEFT_PANEL: {
        name: 'remove-column-from-left-panel',
        tags: ['left-panel'],
    },
    CLICK_ON_ADD_FORMULA: {
        name: 'click-on-add-formula',
        tags: ['left-panel'],
    },
    CLICK_ON_VIEW_SWITCHER: {
        name: 'click-on-view-switcher',
        tags: ['left-panel'],
    },
    DATA_PANEL_SEARCH: {
        name: 'data-panel-search',
        tags: ['left-panel'],
    },
    NO_POPULAR_COLUMNS_AVAILABLE: {
        name: 'no-popular-columns-available',
        tags: ['left-panel'],
    },
    DELETE_DATA_SOURCE: { name: 'delete-data-source', tags: [] },
    DATA_SOURCE_EXECUTE_DDL: { name: 'data-source-execute-ddl', tags: [] },
    DATA_SOURCE_UPDATE_SCHEDULE: {
        name: 'data-source-update-schedule',
        tags: [],
    },
    DATA_SOURCE_DELETE_SCHEDULE: {
        name: 'data-source-delete-schedule',
        tags: [],
    },
    DATA_SOURCE_RELOAD_TASKS: { name: 'data-source-reload-tasks', tags: [] },
    DATA_SOURCE_STOP_TASKS: { name: 'data-source-stop-tasks', tags: [] },
    DATA_SOURCE_GET_CREATE_DDL: {
        name: 'data-source-get-created-ddl',
        tags: [],
    },
    DATA_SOURCE_SCHEDULE_VALIDATION: {
        name: 'data-source-schedule-validation',
        tags: [],
    },
    LOAD_FROM_DATA_SOURCE: { name: 'load-from-data-source', tags: [] },
    EXPRESSION_VALIDATION: { name: 'expression-validation', tags: [] },
    DATA_SOURCE_CREATE_CONNECTION: {
        name: 'data-source-create-connection',
        tags: [],
    },
    DATA_SOURCE_DELETE_CONNECTION: {
        name: 'data-source-delete-connection',
        tags: [],
    },
    DATA_SOURCE_EDIT_CONNECTION: {
        name: 'data-source-edit-connection',
        tags: [],
    },
    CREATE_DATA_SOURCE: { name: 'create-data-source', tags: [] },
    CONNECT_TO_DATA_SOURCE: { name: 'connect-to-data-source', tags: [] },
    GET_DATA_SOURCE_CONN_FIELD_LIST: {
        name: 'get-data-source-conn-field-list',
        tags: [],
    },
    GET_DATA_SOURCE_CONNECTION_LIST: {
        name: 'get-data-source-connection-list',
        tags: [],
    },
    GET_DATA_SOURCE_CONNECTION_ATTRIBUTES: {
        name: 'get-data-source-connection-attributes',
        tags: [],
    },
    GET_DATA_SOURCE_CONNECTIONS: {
        name: 'get-data-source-connections',
        tags: [],
    },
    GET_DATA_SOURCE_CONFIG: { name: 'get-data-source-config', tags: [] },
    FETCH_LOGIN_CONFIG: { name: 'fetch-login-config', tags: [] },
    FETCH_SLACK_CONFIG: { name: 'fetch-slack-config', tags: [] },
    HEALTH_CHECK: { name: 'health-check', tags: [] },
    HELP_PORTAL_TOKEN: { name: 'help-portal-token', tags: [] },
    HELP_PORTAL_RELEASE_NAME: { name: 'help-portal-release-name', tags: [] },
    FETCH_PROFILE_PIC: { name: 'fetch-profile-pic', tags: [] },
    UPLOAD_PROFILE_PIC: { name: 'upload-profile-pic', tags: [] },
    UPLOAD_FILE: { name: 'upload-file', tags: [] },
    UPLOAD_USER_DATA: { name: 'upload-user-data', tags: [] },
    UPGRADE_ANSWER: { name: 'upgrade-answer', tags: ['answer'] },
    SEND_LOGS_TO_SERVER: { name: 'send-logs-to-server', tags: [] },
    SIGN_IN: { name: 'sign-in-clicked', tags: [] },
    SIGN_UP: { name: 'sign-up-clicked', tags: [] },
    SOCIAL_SIGN_IN: { name: 'social-login', tags: [] },
    SOCIAL_SIGN_IN_ERROR: { name: 'social-login-error', tags: [] },
    FETCH_RELATIONSHIP_DEPENDENTS: {
        name: 'fetch-relationship-dependents',
        tags: [],
    },
    UPDATE_RLS_RULE: { name: 'update-rls-rule', tags: [] },
    DELETE_RLS_RULE: { name: 'delete-rls-rule', tags: [] },
    REPORT_PROBLEM: { name: 'report-problem', tags: [] },
    SHARE_OBJECT: { name: 'share-object', tags: [] },
    CLICK_SHARE_MENU_ITEM: { name: 'click-share-menu-item', tags: [] },
    COPY_LINK_SHARE_OBJECT: { name: 'copy-link-share-object', tags: [] },
    SUBMIT_SAGE_FEEDBACK: { name: 'submit-sage-feedback', tags: [] },
    REFRESH_CONTEXT_GUIDS: { name: 'refresh-context-guids', tags: [] },
    EMPTY_SAGE_FOCUS: { name: 'empty-sage-focus', tags: [] },
    SAGE_SEARCH: { name: 'sage-search', tags: ['search'] },
    SAGE_QUERY_CHANGED: {
        name: 'sage-query-changed',
        tags: ['search'],
    },
    SAGE_BAR_QUERY_FIRED: {
        name: 'sage-bar-query-fired',
        tags: ['search'],
    },
    SAGE_BAR_COMPLETIONS_DISPLAYED: {
        name: 'sage-bar-completions-displayed',
        tags: ['search'],
    },
    SAGE_BAR_QUERY_EDITED: {
        name: 'sage-bar-query-edited',
        tags: ['search'],
    },
    SAGE_BAR_COMPLETION_SELECTED: {
        name: 'sage-bar-completion-selected',
        tags: ['search'],
    },
    FORMULA_QUERY_CHANGED: {
        name: 'formula-query-changed',
        tags: ['formula'],
    },
    FORMULA_COMPLETIONS_DISPLAYED: {
        name: 'formula-completions-displayed',
        tags: ['formula'],
    },
    FORMULA_QUERY_EDITED: {
        name: 'formula-query-edited',
        tags: ['formula'],
    },
    FORMULA_COMPLETION_SELECTED: {
        name: 'formula-completion-selected',
        tags: ['formula'],
    },
    FORMULA_SAVED: {
        name: 'formula-saved',
        tags: ['formula'],
    },
    FORMULA_BEGIN_EDITING: {
        name: 'formula-begin-editing',
        tags: ['formula'],
    },
    FORMULA_DELETED: {
        name: 'formula-deleted',
        tags: ['formula'],
    },
    FORMULA_EDITOR_HELP_ITEM_CLICKED: {
        name: 'formula-editor-help-item-clicked',
        tags: ['formula'],
    },
    FORMULA_EDITOR_NEWLINE_SHORTCUT_PRESSED: {
        name: 'formula-editor-newline-shortcut-pressed',
        tags: ['formula'],
    },
    FAILURE_ALERT: { name: 'failure-alert', tags: ['failure', 'alert'] },
    CREATE_SPOTIQ_AUTO_ANALYZE: {
        name: 'create-spotiq-auto-analyze',
        tags: ['create', 'spotiq', 'auto-analyze'],
    },
    CREATE_SPOTIQ_ANOMALY_EXPLANATION_ANALYZE: {
        name: 'create-spotiq-anomaly-explanation-analyze',
        tags: ['create', 'spotiq', 'anomaly-explanation-analyze'],
    },
    CREATE_SPOTIQ_CUSTOM_ANALYZE: {
        name: 'create-spotiq-custom-analyze',
        tags: ['create', 'spotiq', 'custom-analyze'],
    },
    CREATE_CUSTOM_R_SPOTIQ_ANALYZE: {
        name: 'create-custom-r-spotiq-analyze',
        tags: ['create', 'custom-r', 'spotiq'],
    },
    CREATE_CUSTOM_R_SEARCH_PAGE: {
        name: 'create-custom-r-search-page',
        tags: ['create', 'custom-r', 'search-page'],
    },
    CREATE_R_TEMPLATE: {
        name: 'create-r-template',
        tags: ['create', 'r-template'],
    },
    LOAD_R_TEMPLATE: { name: 'load-r-template', tags: ['load', 'r-template'] },
    UPDATE_R_TEMPLATE: {
        name: 'update-r-template',
        tags: ['update', 'r-template'],
    },
    DELETE_R_TEMPLATE: {
        name: 'delete-r-template',
        tags: ['delete', 'r-template'],
    },
    INDEX_PAGE_KPI: { name: 'index-page-kpi', tags: [] },
    CLICK: { name: 'user-click', tags: [] },
    RIGHT_CLICK: { name: 'user-right-click', tags: [] },
    DOUBLE_CLICK: { name: 'user-double-click', tags: [] },
    ENLITE_RESULT_IMPRESSION: { name: 'enlite-result-impression', tags: [] },
    ENLITE_RESULT_FEEDBACK: { name: 'enlite-result-feedback', tags: [] },
    ENLITE_REFINEMENT: { name: 'enlite-refinement', tags: [] },
    ENLITE_TEACH: { name: 'enlite-teach', tags: [] },
    AUTOCOMPLETE_PROCESS_COMPLETIONS: {
        name: 'autocomplete-process-completions',
        tags: [],
    },
    AUTOCOMPLETE_SELECT_COMPLETION: {
        name: 'autocomplete-select-completion',
        tags: [],
    },
    EXPLORE_OPEN: { name: 'explore-open', tags: [] },
    EXPLORE_CLOSE: { name: 'explore-close', tags: [] },
    EXPLORE_FILTER: { name: 'explore-filter', tags: [] },
    EXPLORE_ADD: { name: 'explore-add', tags: [] },
    EXPLORE_REPLACE: { name: 'explore-replace', tags: [] },
    EXPLORE_COMPARE: { name: 'explore-compare', tags: [] },
    EXPLORE_FOLLOWUP_IMPRESSION: {
        name: 'explore-followup-impression',
        tags: [],
    },
    EXPLORE_FOLLOWUP_SUBMIT: { name: 'explore-followup-submit', tags: [] },
    EXPLORE_CONSTRAINED_SEARCH_CLICK: {
        name: 'explore-constrained-search-click',
        tags: [],
    },
    EXPLORE_CONSTRAINED_SEARCH_SUBMIT: {
        name: 'explore-constrained-search-submit',
        tags: [],
    },
    EXPLORE_ADHOC_SUGGESTION_CLICK: {
        name: 'explore-adhoc-suggestion-click',
        tags: [],
    },
    EXPLORE_ADHOC_SUGGESTION_SUBMIT: {
        name: 'explore-adhoc-suggestion-submit',
        tags: [],
    },
    PINBOARD_CHANGE_TILE_SIZE: {
        name: 'pinboard-change-tile-size',
        tags: [],
    },
    REQUEST_RESET_PASSWORD_FAILURE: {
        name: 'request-reset-password-failure',
        tags: [],
    },
    REST_PASSWORD_FAILURE: { name: 'reset-password-failure', tags: [] },
    ACCOUNT_ACTIVATION_FAILURE: {
        name: 'account-activation-failure',
        tags: [],
    },
    OKTA_ACCOUNT_ACTIVATION: {
        name: 'okta-account-activation',
        tags: [],
    },
    HIGH_CARDINALITY_POPUP: {
        name: 'high-cardinality-popup',
        tags: ['chart', 'chart-config'],
        actionParams: {
            choice: { CANCEL: 'cancel', RENDER_ALL: 'render all' },
        },
    },
    LOAD_DATA_FROM_EXTERNAL_TABLE: {
        name: 'load-data-from-external-table',
        tags: [],
    },
    GET_LOGICAL_TABLE_SCHEDULE: {
        name: 'get-logical-table-status',
        tags: ['view'],
    },
    ADD_LOGICAL_TABLE_SCHEDULE: {
        name: 'add-logical-table-status',
        tags: ['view'],
    },
    EMBRACE_TABLE_SYNC_DETAILS: {
        name: 'embrace-table-sync-details',
        tags: [],
    },
    SYNC_TABLE: { name: 'sync-table', tags: [] },
    EMBRACE_BULK_SYNC_TABLE: {
        name: 'embrace-embrace-bulk-sync-table',
        tags: [],
    },
    EMBRACE_UNSYNC_TABLE: { name: 'embrace-unsync-table', tags: [] },
    EMBRACE_SCHEDULE_TABLE: { name: 'embrace-schedule-table', tags: [] },
    EMBRACE_OPEN_REMOVE_SCHEDULE_DIALOG: {
        name: 'embrace-open-remove-schedule-dialog',
        tags: [],
    },
    EMBRACE_REMOVE_TABLE_SCHEDULE: {
        name: 'embrace-remove-table-schedule',
        tags: [],
    },
    EMBRACE_OPEN_SYNC_NOW_DIALOG: {
        name: 'embrace-open-sync-now-dialog',
        tags: [],
    },
    EMBRACE_OPEN_SCHEDULE_DIALOG: {
        name: 'embrace-open-schedule-dialog',
        tags: [],
    },
    EMBRACE_OPEN_UNSYNC_DIALOG: {
        name: 'embrace-open-unsync-dialog',
        tags: [],
    },
    EMBRACE_VIEW_CONNECTION_LIST: {
        name: 'embrace-view-connection-list',
        tags: [],
    },
    EMBRACE_VIEW_CONNECTION_DETAIL: {
        name: 'embrace-view-connection-detail',
        tags: [],
    },
    EMBRACE_EDIT_CONNECTION_START: {
        name: 'embrace-edit-connection-start',
        tags: [],
    },
    EMBRACE_SEARCH_METADATA: { name: 'embrace-search-metadata', tags: [] },
    EMBRACE_CONNECTION_SELECTED_TABLE_TAB: {
        name: 'embrace-connection-selected-table-tab',
        tags: [],
    },
    EMBRACE_REMAPPING_START: { name: 'embrace-remapping-start', tags: [] },
    EMBRACE_REMAPPING_DOWNLOAD_FILE: {
        name: 'embrace-remapping-download-file',
        tags: [],
    },
    EMBRACE_NEW_CONNECTION: { name: 'embrace-new-connection', tags: [] },
    EMBRACE_NEW_CONNECTION_FAIL: {
        name: 'embrace-new-connection-fail',
        tags: [],
    },
    EMBRACE_CREATE_CONNECTION: { name: 'embrace-create-connection', tags: [] },
    EMBRACE_EDIT_CONNECTION: { name: 'embrace-edit-connection', tags: [] },
    EMBRACE_EDIT_CONNECTION_FAIL: {
        name: 'embrace-edit-connection-fail',
        tags: [],
    },
    EMBRACE_DELETE_CONNECTION: { name: 'embrace-delete-connection', tags: [] },
    EMBRACE_DELETE_CONNECTION_SUCCESS: {
        name: 'embrace-delete-connection-success',
        tags: [],
    },
    EMBRACE_DELETE_CONNECTION_FAIL: {
        name: 'embrace-delete-connection-fail',
        tags: [],
    },
    EMBRACE_SHARE_CONNECTION_BUTTON_CLICKED: {
        name: 'embrace-share-connection-button-clicked',
        tags: [],
    },
    EMBRACE_SHARE_CONNECTION_SUCCESS: {
        name: 'embrace-share-connection-success',
        tags: ['grant-access'],
    },
    EMBRACE_SHARE_CONNECTION_FAILURE: {
        name: 'embrace-share-connection-failure',
        tags: [],
    },
    EMBRACE_UNSHARE_CONNECTION_SUCCESS: {
        name: 'embrace-unshare-connection-success',
        tags: ['revoke-access'],
    },
    EMBRACE_UNSHARE_CONNECTION_FAILURE: {
        name: 'embrace-unshare-connection-failure',
        tags: [],
    },
    EMBRACE_EDIT_TABLES_START_FOR_SHARED_CONN: {
        name: 'embrace-edit-tables-start-by-sharee',
        tags: ['shared-connection', 'action-by-sharee'],
    },
    EMBRACE_VIEW_CONNECTION_TABLE_DETAIL: {
        name: 'embrace-view-connection-table-detail',
        tags: [],
    },
    EMBRACE_FETCH_CONNECTION_METADATA_FAILURE: {
        name: 'embrace-fetch-connection-metadata-failure',
        tags: [],
    },
    EMBRACE_FETCH_COLUMN_SAMPLE_DATA_FAILURE: {
        name: 'embrace-fetch-column-sample-data-failure',
        tags: [],
    },
    EMBRACE_NEW_CONNECTION_START: {
        name: 'embrace-new-connection-start',
        tags: [],
    },
    EMBRACE_CONNECTION_CHECKBOX_CHECKED: {
        name: 'embrace-connection-checkbox-checked',
        tags: [],
    },
    EMBRACE_CONNECTION_CHECKBOX_UNCHECKED: {
        name: 'embrace-connection-checkbox-unchecked',
        tags: [],
    },
    EMBRACE_CONNECTION_SELECTION_CHANGED: {
        name: 'embrace-connection-selection-changed',
        tags: [],
    },
    EMBRACE_OPEN_CHOOSE_CONNECTION_TYPE_PAGE: {
        name: 'embrace-open-choose-connection-type-page',
        tags: [],
    },
    EMBRACE_OPEN_CHOOSE_CONNECTION_CREDENTIALS_PAGE: {
        name: 'embrace-open-choose-connection-credentials-page',
        tags: [],
    },
    EMBRACE_OPEN_CHOOSE_CONNECTION_METADATA_PAGE: {
        name: 'embrace-open-choose-connection-metadata-page',
        tags: [],
    },
    EMBRACE_OPEN_CONNECTION_TYPE_PAGE: {
        name: 'embrace-open-connection-type-page',
        tags: [],
    },
    EMBRACE_OPEN_CONNECTION_CREDENTIALS_PAGE: {
        name: 'embrace-open-connection-credentials-page',
        tags: [],
    },
    EMBRACE_OPEN_CONNECTION_METADATA_PAGE: {
        name: 'embrace-open-connection-metadata-page',
        tags: [],
    },
    EMBRACE_CLICK_CANCEL_CONNECTION_FLOW: {
        name: 'embrace-click-cancel-connection-flow',
        tags: [],
    },
    EMBRACE_CONNECTION_FLOW_ABORT: {
        name: 'embrace-connection-flow-abort',
        tags: [],
    },
    EMBRACE_CONNECTION_DETAILS: {
        name: 'embrace-connection-details',
        tags: [],
    },
    EMBRACE_NEW_CONNECTION_CONFIRM: {
        name: 'embrace-new-connection-confirm',
        tags: [],
    },
    EMBRACE_EDIT_CONNECTION_CONFIRM: {
        name: 'embrace-edit-connection-confirm',
        tags: [],
    },
    EMBRACE_LIST_CONNECTION_DEPENDENTS: {
        name: 'embrace-list-connection-dependents',
        tags: [],
    },
    EMBRACE_NO_PREFERRED_CONNECTION_CARD_CLICKED: {
        name: 'embrace-no-preferred-connection-card',
        tags: [],
    },
    EMBRACE_SELECT_CONNECTION_TYPE: {
        name: 'embrace-select-connection-type',
    },
    EMBRACE_NEW_CONFIGURATION_SUBMIT: {
        name: 'embrace-new-configuration-submit',
    },
    EMBRACE_NEW_CONFIGURATION_FAIL: {
        name: 'embrace-new-configuration-fail',
    },
    EMBRACE_NEW_CONFIGURATION_SUCCESS: {
        name: 'embrace-new-configuration-success',
    },
    DELETE_EMBRACE_TABLES: { name: 'delete-embrace-tables', tags: [] },
    EMBRACE_DELETE_TABLES_SUCCESS: {
        name: 'embrace-delete-tables-success',
        tags: [],
    },
    EMBRACE_DELETE_TABLES_FAIL: {
        name: 'embrace-delete-tables-fail',
        tags: [],
    },
    EMBRACE_TOGGLE_LIVE_LOCAL: { name: 'embrace-toggle-live-local', tags: [] },
    EMBRACE_CONNECTION_FEEDBACK: {
        name: 'embrace-connection-feedback',
        tags: [],
    },
    EMBRACE_FREE_TRIAL_ACTIVATION: {
        name: 'embrace-free-trial-activation',
        tags: [],
    },
    EMBRACE_PARTNER_CONNECT_INTEGRATION: {
        name: 'embrace-partner-connect-integration',
        tags: [],
    },
    EMBRACE_PARTNER_CONNECT_CHECK: {
        name: 'embrace-partner-connect-check',
        tags: [],
    },
    EMBRACE_FILE_UPLOAD: { name: 'embrace-file-upload', tags: [] },
    EMBRACE_OAUTH_LOGIN_START: { name: 'embrace-oauth-login-start' },
    EMBRACE_OAUTH_LOGIN_FAIL: { name: 'embrace-oauth-login-fail' },
    EMBRACE_OAUTH_LOGIN_SUCCESS: { name: 'embrace-oauth-login-success' },
    EMBRACE_VALIDATE_CONNECTION_SUCCESS: {
        name: 'embrace-validate-connection-success',
    },
    EMBRACE_VALIDATE_CONNECTION_CLICK: {
        name: 'embrace-validate-connection-click',
    },
    EMBRACE_VALIDATE_CONNECTION_FAILED: {
        name: 'embrace-validate-connection-failed',
    },
    EMBRACE_VALIDATE_CONNECTION_RESULT_DOWNLOAD_SUCCESS: {
        name: 'embrace-validate-connection-result-download-success',
    },
    EMBRACE_VALIDATE_CONNECTION_RESULT_DOWNLOAD_FAILURE: {
        name: 'embrace-validate-connection-result-download-failure',
    },
    EMBRACE_QUERY_FAILURE: {
        name: 'embrace-query-failure',
        tags: [],
    },
    SEARCH_SUMMARY: { name: 'search-summary', tags: [] },
    SEARCH_DETAIL_TABLE: { name: 'search-detail-table', tags: ['table'] },
    SEARCH_DETAIL_NODE: { name: 'search-detail-node', tags: ['table'] },
    DATABASE_SUMMARY: { name: 'database-summary', tags: [] },
    DATABASE_DETAIL: { name: 'database-detail', tags: [] },
    CLUSTER_SUMMARY: { name: 'cluster-stats-summary', tags: [] },
    CLUSTER_DETAIL_INFO: { name: 'cluster-detail-info', tags: [] },
    CLUSTER_DETAIL_LOG: { name: 'cluster-detail-log', tags: [] },
    CLUSTER_DETAIL_SNAPSHOT: { name: 'cluster-detail-snapshot', tags: [] },
    GET_NAT_IP: { name: 'get-nat-ip', tags: [] },
    ALERT_SUMMARY: { name: 'alert-summary', tags: [] },
    EVENT_SUMMARY: { name: 'event-summary', tags: [] },
    ALERTS_DETAILS_ALERTS: { name: 'alerts-details-alerts', tags: [] },
    ALERTS_DETAILS_EVENTS: { name: 'alerts-details-events', tags: [] },
    VALIDATE_TRANSFORMATION_EXPRESSION: {
        name: 'validate-transformation-expression',
        tags: [],
    },
    DATASOURCE_CONN_OBJS_MISMATCH: {
        name: 'datasource-conn-objs-mismatch',
        tags: [],
    },
    UPDATE_EXPOSED_PREFERENCES: {
        name: 'update-exposed-preferences',
        tags: [],
    },
    UPDATE_RESOURCE_CENTER_PREFERENCES: {
        name: 'update-resource-center-preferences',
        tags: [],
    },
    UPDATE_CUSTOM_STYLE_CONFIG: {
        name: 'update-custom-style-config',
        tags: [],
    },
    CREATE_ENLITE_MAPPING: { name: 'create-enlite-mapping', tags: [] },
    COLLECT_CLUSTER_INFO: { name: 'collect-cluster-info', tags: [] },
    EMBRACE_TABLE_STATS: { name: 'collect-embrace-table-stats', tags: [] },
    CREATE_ASK_EXPERT_REQUEST: { name: 'create-ask-expert-request', tags: [] },
    RESOLVE_ASK_EXPERT_REQUEST: {
        name: 'resolve-ask-expert-request',
        tags: [],
    },
    OPEN_REQUESTED_ANSWER_BY_EMAIL: {
        name: 'open-requested-answer-by-email',
        tags: [],
    },
    OPEN_RESOLVED_ANSWER_BY_EMAIL: {
        name: 'open-resolved-answer-by-email',
        tags: [],
    },
    EMAIL_SENT_SUCCESSFULLY: { name: 'send-email-success', tags: [] },
    EMAIL_SENT_FAILURE: { name: 'send-email-failure', tags: [] },
    RESEND_WELCOME_EMAIL: { name: 'resend-welcome-email', tags: [] },
    ADD_EMAIL: { name: 'add-email', tags: [] },
    UPDATE_EMAIL: { name: 'update-email', tags: [] },
    ENABLE_SEARCHIQ_COLUMNS: { name: 'enable-searchiq-columns', tags: [] },
    PERSONA_SELECTION: { name: 'persona-selection', tags: [] },
    LOAD_PERSONA_SCREEN: { name: 'load-persona-screen', tags: [] },
    ONBOARDING_FAILED: { name: 'onboarding-error', tags: [] },
    ONBOARDING_HOME: { name: 'onboarding-home', tags: [] },
    ONBOARDING_DATASOURCE: { name: 'onboarding-datasource', tags: [] },
    ONBOARDING_PINBOARDS_LIST: { name: 'onboarding-pinboards-list', tags: [] },
    ONBOARDING_EXPLORE_PINBOARD: {
        name: 'onboarding-explore-pinboard',
        tags: [],
    },
    ONBOARDING_EXITED: { name: 'onboarding-exited', tags: [] },
    ONBOARDING_SPOTTER_PAGE_LOADED: {
        name: 'onboarding-spotter-page-loaded',
        tags: [],
    },
    ONBOARDING_SPOTTER_VIDEO_LOADED: {
        name: 'onboarding-spotter-video-loaded',
        tags: [],
    },
    ONBOARDING_SPOTTER_VIDEO_DONE_CLICKED: {
        name: 'onboarding-spotter-video-done-clicked',
        tags: [],
    },
    ONBOARDING_BANNER_BOOK_MEETING_CTA_CLICKED: {
        name: 'banner-book-meeting-cta-clicked',
        tags: [],
    },
    ONBOARDING_EXPLORE_TS_CLICKED: {
        name: 'onboarding-explore-ts-clicked',
        tags: [],
    },
    ONBOARDING_ENDED: {
        name: 'onboarding-ended',
        tags: [],
    },
    ONBOARDING_TRY_OWN_DATA_CLICKED: {
        name: 'onboarding-try-own-data-cta-clicked',
        tags: [],
    },
    DATA_ONBOARDING_PAGE_LOADED: {
        name: 'data-onboarding-page-loaded',
        tags: [],
    },
    DATA_ONBOARDING_SOURCE_SELECTED: {
        name: 'data-onboarding-source-selected',
        tags: [],
    },
    DATA_ONBOARDING_ENDED: {
        name: 'data-onboarding-ended',
        tags: [],
    },
    RESUME_SPOTTER_ONBOARDING_CTA_CLICKED: {
        name: 'resume-spotter-onboarding-cta-clicked',
        tags: [],
    },
    RESTART_ONBOARDING: {
        name: 'restart-onboarding',
        tags: [],
    },
    SAVE_BEFORE_SHARE: { name: 'save-before-share', tags: [] },
    SAVE_FAILED: { name: 'save-failed', tags: [] },
    NO_VIEW_PINBOARD: { name: 'no-view-pinboard', tags: [] },
    NO_VIEW_ANSWER: { name: 'no-view-answer', tags: [] },
    REQUEST_ACCESS_FAILED: { name: 'request-access-failed', tags: [] },
    REQUEST_ACCESS_CLICKED: { name: 'request-access-clicked', tags: [] },
    REQUEST_ACCESS_PAGE_LOAD: { name: 'request-access-page-load', tags: [] },
    CLICK_TO_INITIATE_FILTER_ADDITION: {
        name: 'click-to-initiate-filter-addition',
        tags: [],
    },
    SHOW_ALL_POSSIBLE_VALUES: {
        name: 'show-all-possible-values',
        tags: [],
    },
    ADD_VALUES_IN_BULK: {
        name: 'add-values-in-bulk',
        tags: [],
    },
    ADDED_VALUES_IN_BULK: {
        name: 'added-values-in-bulk',
        tags: [],
    },
    ONBOARDING_TRY_SEARCH_BTN_CLICK: {
        name: 'onboarding-try-search-btn-click',
        tags: [],
        shouldSendEventToExperimentationService: true,
        experimentationProject: ExperimentationProject.GROWTH,
    },
    ADD_FILTER_TO_ANSWER: {
        name: 'add-filter-to-answer',
        tags: [],
    },
    REMOVE_FILTER: {
        name: 'remove-filter',
        tags: [],
    },
    CLICK_FILTER_CHIP: {
        name: 'click-filter-chip',
        tags: [],
    },
    REARRANGE_PINBOARD_CHIP: {
        name: 'rearrange-chip',
        tags: ['pinboard'],
    },
    REARRANGE_ANSWER_CHIP: {
        name: 'rearrange-chip',
        tags: ['answer'],
    },
    OPEN_EMAIL_CLICK: {
        name: 'open-email-click',
    },
    MAGIC_LINK_RESEND_LINK_CLICK: {
        name: 'magiclink-resend-link-click',
    },
    MAGIC_LINK_SIGNIN_WITH_URL_CLICK: {
        name: 'magiclink-signin-with-url-click',
    },
    LOAD_OPEN_EMAIL_SCREEN: {
        name: 'load-open-email-screen',
    },
    LOAD_SELECT_CLUSTER_SCREEN: {
        name: 'load-select-cluster-screen',
    },
    CLICK_SELECT_CLUSTER_SCREEN: {
        name: 'click-select-cluster-screen',
    },
    LOAD_AUTHENTICATION_SCREEN: {
        name: 'load-authentication-screen',
    },
    CLICK_SELECT_CLUSTER_SCREEN_SIGN_IN_WITH_URL: {
        name: 'click-select-cluster-screen-sign-in-with-url',
    },
    HOME_WATCHLIST_EXPANDED: {
        name: 'home-watchlist-expanded',
    },
    HOME_WATCHLIST_CHANGE_ANALYSIS: {
        name: 'home-watchlist-change-analysis',
    },
    LOAD_WATCHLIST: {
        name: 'load-watchlist',
    },
    CLICKED_METRIC: {
        name: 'clicked-metric',
    },
    LOAD_METRIC: {
        name: 'load-metric',
    },
    CLICKED_KPI_CHANGE_ANALYSIS_BUTTON: {
        name: 'clicked-kpi-change-analysis-button',
    },
    LOAD_CONTEXT_CHANGE_RESULTS: {
        name: 'load-context-change-results',
    },
    CLICKED_INSIGHTS: {
        name: 'clicked-insights',
    },
    LOAD_INSIGHTS: {
        name: 'load-insights',
    },
    ADDED_METRIC_TO_WATCHLIST: {
        name: 'added-metric-to-watchlist',
    },
    REMOVED_METRIC_FROM_WATCHLIST: {
        name: 'removed-metric-from-watchlist',
    },
    CLICKED_BOTTOM_NAV: {
        name: 'clicked-bottom-nav',
    },
    GET_STARTED_SAGE: {
        name: 'get-started-sage',
    },
    LOAD_ASK_SAGE: {
        name: 'load-ask-sage',
    },
    LOAD_ASK_SAGE_DS_PROPERTIES: {
        name: 'load-ask-sage-ds-properties',
    },
    CLICK_CHANGE_DS_BUTTON: {
        name: 'click-change-ds-button',
    },
    LOAD_CHANGE_DS_SCREEN: {
        name: 'load-change-ds-screen',
    },
    CHANGE_DS_SCREEN_PROPERTIES: {
        name: 'load-change-ds-properties',
    },
    SEARCH_FIRED_SAGE_DS: {
        name: 'search-fired-sage-ds',
    },
    CLICK_CHANGE_DATA_SOURCE: {
        name: 'click-change-data-source',
    },
    CLICK_PROMPT_QUESTION: {
        name: 'click-prompt-question',
    },
    QUERY_ENTERED_ASK_SAGE: {
        name: 'query-entered-ask-sage',
    },
    LOAD_AI_ANSWER: {
        name: 'load-AI-answer',
    },
    CLICK_AI_ANSWER_DETAIL: {
        name: 'click-AI-answer-detail',
    },
    LOAD_AI_ANSWER_DETAIL: {
        name: 'load-AI-answer-detail',
    },
    CLICK_UNDERLYING_KEYWORD_QUERY: {
        name: 'click-underlying-keyword-query',
    },
    LOAD_UNDERLYING_KEYWORD_QUERY: {
        name: 'load-underlying-keyword-query',
    },
    CLICK_SAVE_AI_ANSWER: {
        name: 'click-save-AI-answer',
    },
    SAVE_AI_ANSWER: {
        name: 'save-AI-answer',
    },
    CLICK_RESET_AI_ANSWER: {
        name: 'click-reset-AI-answer',
    },
    FEEDBACK_AI_ANSWER: {
        name: 'feedback-AI-answer',
    },
    NEGATIVE_FEEDBACK_REPORT_REASON: {
        name: 'negative-feedback-report-reason',
    },
    CLICK_MORE_MENU: {
        name: 'click-3dot-menu',
    },
    CLICK_MORE_MENU_EDIT: {
        name: 'click-3dot-menu-edit',
    },
    CLICK_MORE_MENU_DELETE: {
        name: 'click-3dot-menu-delete',
    },
    EDIT_AXIS: {
        name: 'edit-axis',
        tags: ['chart', 'chart-config'],
        actionParams: {
            source: { CONFIG_PANEL: 'CONFIG_PANEL', AXIS_MENU: 'AXIS_MENU' },
        },
    },
    EDIT_MEASURE: {
        name: 'edit-measure',
        tags: ['chart', 'chart-config'],
        actionParams: {
            source: {
                CONFIG_PANEL: 'CONFIG_PANEL',
                CONTEXT_MENU: 'CONTEXT_MENU',
            },
        },
    },
    GROUP_AXIS: { name: 'group-axis', tags: ['chart', 'chart-config'] },
    UNGROUP_AXIS: { name: 'ungroup-axis', tags: ['chart', 'chart-config'] },
    POSITION_AXIS: {
        name: 'position-axis',
        tags: ['chart', 'chart-config'],
        actionParams: {
            source: { CONFIG_PANEL: 'CONFIG_PANEL', AXIS_MENU: 'AXIS_MENU' },
        },
    },
    CHANGE_AXIS_RANGE: {
        name: 'change-axis-range',
        tags: ['chart', 'chart-config'],
    },
    RENAME_AXIS: {
        name: 'rename-axis',
        tags: ['chart', 'chart-config'],
        actionParams: {
            source: { CONFIG_PANEL: 'CONFIG_PANEL', AXIS_MENU: 'AXIS_MENU' },
        },
    },
    RENAME_AXIS_COMPLETE: {
        name: 'rename-axis-complete',
        tags: ['chart', 'chart-config'],
        actionParams: {
            source: { CONFIG_PANEL: 'CONFIG_PANEL', AXIS_MENU: 'AXIS_MENU' },
        },
    },
    NUMBER_FORMAT: {
        name: 'number-format',
        tags: ['chart', 'chart-config'],
        actionParams: {
            target: { AXIS: 'AXIS', COLUMN: 'COLUMN' },
        },
    },
    CHART_AUTO_SELECT_TOGGLE: {
        name: 'chart-auto-select-toggle',
        tags: ['chart', 'chart-config'],
    },
    AGGREGATION_CHANGE: {
        name: 'aggregation-change',
        tags: ['chart', 'chart-config'],
    },
    SORT: { name: 'sort', tags: ['chart', 'chart-config'] },
    CHIP_REMOVAL: { name: 'chip-removal', tags: ['chart', 'chart-config'] },
    COLOR_CHANGE: {
        name: 'color-change',
        tags: ['chart', 'chart-config'],
        actionParams: {
            source: {
                CONFIG_PANEL: 'CONFIG_PANEL',
                LEGEND_ITEM: 'LEGEND_ITEM',
                ADVANCE_CONFIG_PANEL: 'ADVANCE_CONFIG_PANEL',
            },
        },
    },
    TOGGLE_GRIDLINES: {
        name: 'toggle-gridlines',
        tags: ['chart', 'chart-config'],
        actionParams: {
            axis: { X: 'X', Y: 'Y' },
        },
    },
    TOGGLE_REGRESSION_LINE: {
        name: 'toggle-regression-line',
        tags: ['chart', 'chart-config'],
    },
    TOGGLE_DATA_LABELS: {
        name: 'toggle-data-labels',
        tags: ['chart', 'chart-config'],
    },
    TOGGLE_TOTAL_LABELS: {
        name: 'toggle-total-labels',
        tags: ['chart', 'chart-config'],
    },
    TOGGLE_ALL_DATA_LABELS: {
        name: 'toggle-all-data-labels',
        tags: ['chart', 'chart-config'],
    },
    TOGGLE_Y_AXIS_AS_PERCENT: {
        name: 'toggle-y-axis-as-percent',
        tags: ['chart', 'chart-config'],
    },
    TOGGLE_PIVOT_SUMMARIES: {
        name: 'toggle-pivot-summaries',
        tags: ['chart', 'chart-config', 'pivot'],
    },
    TOGGLE_PIVOT_SUMMARIES_POSITION: {
        name: 'toggle-pivot-summaries-position',
        tags: ['chart', 'chart-config', 'pivot'],
    },
    TOGGLE_PIVOT_COMPACT_LAYOUT: {
        name: 'toggle-pivot-compact-layout',
        tags: ['chart', 'chart-config', 'pivot'],
    },
    PIVOT_MEASURE_LAYOUT: {
        name: 'toggle-pivot-measure-layout',
        tags: ['chart', 'chart-config', 'pivot'],
    },
    PIVOT_CONTEXT_EXPAND_ALL: {
        name: 'pivot-context-expand-all',
        tags: ['chart', 'chart-config', 'pivot'],
    },
    PIVOT_CONTEXT_COLLAPSE_ALL: {
        name: 'pivot-context-collapse-all',
        tags: ['chart', 'chart-config', 'pivot'],
    },
    PIVOT_CONTEXT_SORT: {
        name: 'pivot-context-sort',
        tags: ['chart', 'chart-config', 'pivot'],
    },
    PIVOT_CONTEXT_CLEAR_SORT: {
        name: 'pivot-context-clear-sort',
        tags: ['chart', 'chart-config', 'pivot'],
    },
    TOGGLE_OVERLAY_HEATMAP: {
        name: 'toggle-overlay-heatmap',
        tags: ['chart', 'chart-config', 'pivot'],
    },
    TOGGLE_RESPONSIVE_LAYOUT: {
        name: 'toggle-responsive-layout',
        tags: ['chart', 'chart-config'],
    },
    TOGGLE_MARKERS: { name: 'toggle-markers', tags: ['chart', 'chart-config'] },
    CHANGE_PIVOT_SUMMARY_MODE: {
        name: 'change-pivot-summary-mode',
        tags: ['chart', 'chart-config'],
    },
    CHART_ZOOM: {
        name: 'chart-zoom',
        tags: ['chart', 'chart-config'],
        actionParams: {
            modes: { Zoom: 'ZOOM', PAN: 'PAN', ZOOMOUT: 'ZOOMOUT' },
        },
    },
    CHANGE_GEOMAP_TILE_TYPE: {
        name: 'change-geomap-tile-type',
        tags: ['chart', 'chart-config', 'geomap'],
    },
    MAP_BOX_TILE_LOAD: {
        name: 'mapbox-tile-load',
        tags: ['chart', 'geo-map', 'mapbox'],
    },
    TOGGLE_LEGEND_VISIBILITY: {
        name: 'toggle-legend-visibility',
        tags: ['chart', 'legend'],
    },
    CHANGE_LEGEND_POSITION: {
        name: 'legend-position',
        tags: ['chart', 'legend', 'position'],
    },
    CHANGE_SORT_CONFIG: {
        name: 'sort-config',
        tags: ['chart', 'sort', 'custom', 'default'],
    },
    SAVE_CHART_ADVANCED_SETTINGS: {
        name: 'apply_chart_settings',
        tags: ['save', 'chart', 'advanced', 'settings'],
    },
    SAVE_AXIS_ADVANCED_SETTINGS: {
        name: 'apply_axis_settings',
        tags: ['save', 'axis', 'advanced', 'settings'],
    },
    SAVE_COLUMN_ADVANCED_SETTINGS: {
        name: 'apply_column_settings',
        tags: ['save', 'axis', 'advanced', 'settings'],
    },
    OPEN_CHART_ADVANCED_SETTINGS: {
        name: 'advanced_chart_settings',
        tags: ['open', 'chart', 'advanced', 'settings'],
    },
    OPEN_AXIS_ADVANCED_SETTINGS: {
        name: 'advanced_axis_settings',
        tags: ['open', 'axis', 'advanced', 'settings'],
    },
    OPEN_COLUMN_ADVANCED_SETTINGS: {
        name: 'advanced_column_settings',
        tags: ['open', 'axis', 'advanced', 'settings'],
    },
    CHANGE_HANDLE_MISSING_VALUES: {
        name: 'handle-missing-values',
        tags: ['chart', 'missing-values', 'null-values'],
    },
    CHANGE_EXCLUDE_NULL_VALUES: {
        name: 'exlude-null-values',
        tags: ['chart', 'null-values'],
    },
    PAGE_VIEW: { name: 'page-view', tags: [] },
    LOGIN_CLICK: { name: 'login-click', tags: [] },
    LOGIN_USING_SSO_CLICK: { name: 'login-using-sso-click', tags: [] },
    HOME_PINBOARD_SETUP_CLICK: { name: 'home-pinboard-setup-click', tags: [] },
    VIEW_PROFILE_CLICK: { name: 'view-profile-click', tags: [] },
    LINK_SHARE: { name: 'link-share', tags: [] },
    EMPTY_HOME_VIZ_ADD_CLICK: { name: 'empty-home-viz-add-click', tags: [] },
    FEEDBACK_SEND_CLICK: { name: 'feedback-send-click', tags: [] },
    SEND_NETWORK_LOGS_CLICK: { name: 'send-network-logs-click', tags: [] },
    PRIVACY_POLICY_CLICK: { name: 'privacy-policy-click', tags: [] },
    LOGOUT_CLICK: { name: 'logout-click', tags: [] },
    SEGMENT_CONTROL_CLICK: { name: 'segment-control-click', tags: [] },
    INFO_CLICK: { name: 'info-click', tags: [] },
    PINBOARD_DETAIL_EDIT_CLICK: {
        name: 'pinboard-detail-edit-click',
        tags: [],
    },
    HOME_PINBOARD_CHANGE_CLICK: {
        name: 'home-pinboard-change-click',
        tags: [],
    },
    FILTER_ICON_CLICK: { name: 'filter-icon-click', tags: [] },
    FILTER_ELEMENT_CLICK: { name: 'filter-element-click', tags: [] },
    SHOW_DATA_SOURCE_CLICK: { name: 'show-data-source-click', tags: [] },
    RESET_ALL_CLICK: { name: 'reset-all-click', tags: [] },
    APPLY_CHANGES_CLICK: { name: 'apply-changes-click', tags: [] },
    APPLY_FILTER: { name: 'apply-filter', tags: [] },
    FILTER_CELL_CLICK: { name: 'filter-cell-click', tags: [] },
    ATTRIBUTE_CLICK: { name: 'attribute-click', tags: [] },
    REVIEW_POPUP_SHOWN: { name: 'review-popup-shown', tags: [] },
    REVIEW_POPUP_OPTION_CLICK: { name: 'review-popup-option-click', tags: [] },
    HOME_VIZ_PIN: { name: 'home-viz-pin', tags: [] },
    PINBOARD_EDIT: { name: 'pinboard-edit-menu-item', tags: ['pinboard'] },
    SHOW_PINBOARD_DETAILS: {
        name: 'pinboard-show-pinboard-details-menu-item',
        tags: [],
    },
    PINBOARD_DOWNLOAD: { name: 'pinboard-download-menu-item', tags: [] },
    PINBOARD_SOCIAL_ICON: {
        name: 'pinboard-social-icon-clicked',
        tags: ['pinboard'],
    },
    PINBOARD_ELLIPSIS_MENU: {
        name: 'pinboard-ellipsis-level',
        tags: ['pinboard'],
    },
    SAVE_AS_PINBOARD: { name: 'save-as-pinboard', tags: ['pinboard'] },
    SAVE_PINBOARD: { name: 'pinboard-save', tags: ['pinboard'] },
    PINBOARD_PAGE_LOAD: { name: 'pinboard-page-load', tags: [] },
    ANSWER_VIZ_LOAD: { name: 'answer-viz-load', tags: [] },
    PINBOARD_VIZ_LOAD: { name: 'pinboard-viz-load', tags: [] },
    PINBOARD_VIZ_COPY_LINK: { name: 'viz-copy-link', tags: ['pinboard'] },
    PINBOARD_COMMENTING_CLICK: {
        name: 'comment-icon-clicked',
        tags: ['pinboard'],
    },
    CONTEXTUAL_MENU_ADD_COMMENT_CLICK: {
        name: 'add-comment-from-contextual-menu',
        tags: ['pinboard'],
    },
    PINBOARD_CREATE: { name: 'pinboard-create', tags: [] },
    HOME_PINBOARD_SET: { name: 'home-pinboard-set', tags: [] },
    HOME_PINBOARD_REMOVE: { name: 'home-pinboard-set', tags: [] },
    FAVORITE: { name: 'favorite', tags: [] },
    FAVORITE_CLICKED: { name: 'favorite-clicked', tags: ['pinboard'] },
    OBJECT_SEARCH: { name: 'object-search', tags: [] },
    VIZ_MODE_SWITCH: { name: 'viz-mode-switch', tags: [] },
    HOME_PAGE_LOAD: { name: 'home-page-load', tags: [] },
    GET_SESSION_CONFIG: { name: 'get-session-config', tags: [] },
    FILTER_ATTRIBUTE_LOAD: { name: 'filter-attribute-load', tags: [] },
    FIRST_CHART_RENDER_TIME: { name: 'first-chart-render-time', tags: [] },
    FIRST_VIZ_LOAD_TIME: { name: 'first-viz-load-time', tags: [] },
    SSO_LOGIN_FETCH_PROFILE: { name: 'SSO-login-fetch-profile', tags: [] },
    OPEN_VIA_DEEPLINK: { name: 'open-via-deeplink', tags: [] },
    DEEPLINK_CLICKED: { name: 'deep-link-clicked', tags: [] },
    PINBOARD_TAB_VIA_DEEPLINK: { name: 'pinboard-tab-via-deeplink', tags: [] },
    DRILL_BOTTOM_BUTTON_CLICK: { name: 'drill-bottom-button-click', tags: [] },
    ON_SELECT_DRILL_ITEM: { name: 'on-select-drill-item', tags: [] },
    RESET_DRILL_CLICKED: { name: 'reset-drill-clicked', tags: [] },
    POP_DRILL_CLICKED: { name: 'pop-drill-clicked', tags: [] },
    DRILL_SUCCESS: { name: 'drill-success', tags: [] },
    DRILL_FAILURE: { name: 'drill-failure', tags: [] },
    DRILL_ITEMS_LOAD: { name: 'drill-items-load', tags: [] },
    DRILL_ITEMS_SEARCH: { name: 'drill-items-search', tags: [] },
    CONDITONAL_FORMAT_SAVE: { name: 'conditional-format-save', tags: [] },
    TOOLTIP_CUSTOMIZED: { name: 'tooltip-customized', tags: ['tooltip'] },
    IN_APP_BROWSER_CLOSED: { name: 'in-app-browser-closed', tags: [] },
    LOGIN_USING_EXTERNAL_BROWSER: {
        name: 'login-using-external-browser',
        tags: [],
    },
    LOGIN_USING_EXTERNAL_BROWSER_FAILED: {
        name: 'login-using-external-browser-failed',
        tags: [],
    },
    LOGIN_USING_IN_APP_BROWSER: {
        name: 'login-using-in-app-browser',
        tags: [],
    },
    LOGIN_USING_IN_APP_BROWSER_CANCELLED: {
        name: 'login-using-in-app-browser-cancelled',
        tags: [],
    },
    HANDLE_RESPONSE_IN_APP_BROWSER: {
        name: 'handle-response-in-app-browser',
        tags: [],
    },
    LOGIN_USING_AUTHWEBVIEW: { name: 'login-using-authwebview', tags: [] },
    NO_OBJ_PARAM: { name: 'no-obj-param', tags: [] },
    OBJ_PARAM_ERROR: { name: 'obj-param-error', tags: [] },
    INVALID_OBJ_PARAM: { name: 'invalid-obj-param', tags: [] },
    REFRESH: { name: 'refresh', tags: [] },
    CALLOSUM_API_ERROR: { name: 'callosum-api-error', tags: [] },
    PRISM_API_ERROR: { name: 'prism-api-error', tags: [] },
    TABLE_VIZ_MOUNTED: { name: 'table-viz-mounted', tags: [] },
    CHART_VIEW_V2_MOUNTED: { name: 'chart-view-v2-mounted', tags: [] },
    WEB_VIEW_LOADING_END_FOR_CHART: {
        name: 'web-view-loading-end-for-chart',
        tags: [],
    },
    TABLE_VIEW_LOADING_END: { name: 'table-view-loading-end', tags: [] },
    PINBOARD_LIST_SCREEN_MOUNTED: {
        name: 'pinboard-list-screen-mounted',
        tags: [],
    },
    PINBOARD_LIST_SCREEN_ITEM_PRESSED: {
        name: 'pinboard-list-screen-item-pressed',
        tags: [],
    },
    LOAD_PINBOARD_SESSION_API: { name: 'load-pinboard-session-api', tags: [] },
    PINBOARD_SCREEN_CONTAINER_MOUNTED: {
        name: 'pinboard-screen-container-mounted',
        tags: [],
    },
    LOAD_CONTEXT_BOOK_API: { name: 'load-context-book-api', tags: [] },
    VIZ_CARD_V2_CONTAINER_MOUNTED: {
        name: 'viz-card-v2-container-mounted',
        tags: [],
    },
    FETCH_PINBOARDS_LIST_API_SUCCESS: {
        name: 'fetch-pinboards-list-api-success',
        tags: [],
    },
    FETCH_PINBOARDS_LIST_API_FAILURE: {
        name: 'fetch-pinboards-list-api-failure',
        tags: [],
    },
    VIZ_CARD_V2_PRESSED: { name: 'viz-card-v2-pressed', tags: [] },
    CHART_VIZ_CONATAINER_MOUNTED: {
        name: 'chart-viz-container-mounted',
        tags: [],
    },
    GET_CHART_WITH_DATA_API_SUCCESS: {
        name: 'get-chart-with-data-api-success',
        tags: [],
    },
    GET_CHART_WITH_DATA_API_FAILURE: {
        name: 'get-chart-with-data-api-failure',
        tags: [],
    },
    ANSWER_LIST_SCREEN_ITEM_PRESSED: {
        name: 'answer-list-screen-item-pressed',
        tags: [],
    },
    ANSWER_LIST_SCREEN_MOUNTED: {
        name: 'answer-list-screen-mounted',
        tags: [],
    },
    INSIGHTS_ANSWER_CONTENT_SCREEN_MOUNTED: {
        name: 'insights-answer-content-screen-mounted',
        tags: [],
    },
    TABLE_VIZ_CONTAINER_MOUNTED: {
        name: 'table-viz-container-mounted',
        tags: [],
    },
    GET_TABLE_WITH_DATA_API_SUCCESS: {
        name: 'get-table-with-data-api-success',
        tags: [],
    },
    GET_TABLE_WITH_DATA_API_FAILURE: {
        name: 'get-table-with-data-api-failure',
        tags: [],
    },
    VIZ_DETAIL_SCREEN_CONTAINER_MOUNTED: {
        name: 'viz-detail-screen-container-mounted',
        tags: [],
    },
    FETCH_ANSWERS_LIST_API_SUCCESS: {
        name: 'fetch-answers-list-api-success',
        tags: [],
    },
    FETCH_ANSWERS_LIST_API_FAILURE: {
        name: 'fetch-answers-list-api-failure',
        tags: [],
    },
    JAIL_BROKEN_DEVICE_DETECTED: {
        name: 'jail-broken-device-detected',
        tags: [],
    },
    HANDLE_UNAUTHORIZED_ACCESS: {
        name: 'handle-unauthorized-access',
        tags: [],
    },
    CLICK_ORG_SWITCHER: {
        name: 'click-org-switcher',
        tags: [],
    },
    LOAD_ORG_SWITCHER: {
        name: 'load-org-switcher',
        tags: [],
    },
    CLICK_CHANGE_ORG: {
        name: 'click-change-org',
        tags: [],
    },
    LOAD_ORG_SWITCHER_PROMPT: {
        name: 'load-org-switcher-prompt',
        tags: [],
    },
    CLICK_CHANGE_ORG_CONTINUE: {
        name: 'click-change-org-continue',
        tags: [],
    },
    CLICK_CHANGE_ORG_CANCEL: {
        name: 'click-change-org-cancel',
        tags: [],
    },
    CHANGE_ORG_STATUS: {
        name: 'change-org-status',
        tags: [],
    },
    COOKIE_RENEWAL_TIME_DATA: {
        name: 'cookie-renewal-time-data',
        tags: [],
    },
    SHOULD_REFRESH_SESSION: {
        name: 'should-refresh-session',
        tags: [],
    },
    HANDLE_OPEN_URL_SET_COOKIES: {
        name: 'handle-open-url-set-cookies',
        tags: [],
    },
    CALL_INIT_SERVICES_POST_LOGIN: {
        name: 'call-init-services-post-login',
        tags: [],
    },
    CALL_POST_LOGOUT: {
        name: 'call-post-logout',
        tags: [],
    },
    CALL_LOGOUT_API: {
        name: 'call-logout-api',
        tags: [],
    },
    REQUEST_UNDERLYING_DATASOURCES_VIEW_ACCESS: {
        name: 'request-underlying-datasources-view-access',
        tags: [],
    },
    REQUEST_OBJECT_EDIT_ACCESS: {
        name: 'request-object-edit-access',
        tags: [],
    },
    CLICK_ANSWER_SHOW_UNDERLYING_DATA_MENU_ITEM: {
        name: 'click-answer-show-underlying-data-menu-item',
        tags: [],
    },
    DOWNLOAD_UNDERLYING_DATA: { name: 'download-underlying-data', tags: [] },
    CLICK_ADD_COLUMNS_UNDERLYING_DATA: {
        name: 'click-add-columns-show-underlying-data',
        tags: [],
    },
    ADD_COLUMNS_TO_UNDERLYING_DATA: {
        name: 'add-columns-to-underlying-data',
        tags: [],
    },
    CLICK_DOWNLOAD_MENU_ITEM: {
        name: 'click-download-menu-item',
        tags: [],
    },
    SHARE_VISUALIZATION: { name: 'share-visualization', tags: [] },
    GRANT_DATASOURCE_ACCESS_SHARING: {
        name: 'grant-datasource-access-sharing',
        tags: [],
    },
    HOME_HUB_SEARCH_DEMO_DATA: { name: 'homehub-search-demo-data', tags: [] },
    HOME_HUB_FINISH_SETUP: { name: 'homehub-finish-setup', tags: [] },
    HOME_HUB_LOAD: { name: 'homehub-load', tags: [] },
    HOME_HUB_ADD_CONNECTION: { name: 'homehub-add-connection', tags: [] },
    HOME_HUB_ADD_JOIN: { name: 'homehub-add-join', tags: [] },
    HOME_HUB_ADD_WORKSHEET: { name: 'homehub-add-worksheet', tags: [] },
    HOME_HUB_ADD_PINBOARD: { name: 'homehub-add-pinboard', tags: [] },
    HOME_HUB_ADD_ANSWER: { name: 'homehub-add-answer', tags: [] },
    HOME_HUB_VIEW_CONNECTION: { name: 'homehub-view-connection', tags: [] },
    HOME_HUB_VIEW_JOIN: { name: 'homehub-view-join', tags: [] },
    HOME_HUB_VIEW_WORKSHEET: { name: 'homehub-view-worksheet', tags: [] },
    HOME_HUB_VIEW_PINBOARD: { name: 'homehub-view-pinboard', tags: [] },
    HOME_HUB_VIEW_ANSWER: { name: 'homehub-view-answer', tags: [] },
    HOME_HUB_CONTACT_US: { name: 'homehub-contact-us', tags: [] },
    AO_SPLASH_PAGE_LOAD: { name: 'ao-splash-page-load', tags: [] },
    AO_SPLASH_TRY_SEARCH: {
        name: 'ao-splash-try-search',
        tags: [],
        shouldSendEventToExperimentationService: true,
        experimentationProject: ExperimentationProject.GROWTH,
    },
    AO_SPLASH_EXIT: { name: 'ao-splash-exit', tags: [] },
    BUO_SPLASH_PAGE_LOAD: { name: 'buo-splash-page-load', tags: [] },
    BUO_SPLASH_TRY_SEARCH: {
        name: 'buo-splash-try-search',
        tags: [],
        shouldSendEventToExperimentationService: true,
        experimentationProject: ExperimentationProject.GROWTH,
    },
    BUO_SPLASH_EXIT: { name: 'buo-splash-exit', tags: [] },
    DEMO_GROUPS: { name: 'demo-groups', tags: [] },
    INVITE_OTHERS: {
        name: 'invite-others',
        tags: [],
        shouldSendEventToExperimentationService: true,
        experimentationProject: ExperimentationProject.GROWTH,
    },
    INVITE_SHARE_LOAD: { name: 'invite-share-load', tags: [] },
    DISPLAY_NAME_EDIT: { name: 'display-name-edit', tags: [] },
    DISPLAY_NAME_SAVE: { name: 'display-name-save', tags: [] },
    DISPLAY_NAME_CANCEL: { name: 'display-name-cancel', tags: [] },
    UPDATE_DISPLAY_NAME_LOAD: { name: 'update-display-name-load', tags: [] },
    UPDATE_DISPLAY_NAME_SAVE: { name: 'update-display-name-save', tags: [] },
    UPDATE_DISPLAY_NAME_CANCEL: {
        name: 'update-display-name-cancel',
        tags: [],
    },
    INVITE_TEAMMATES_USER_MENU: {
        name: 'invite-teammates-user-menu',
        tags: [],
        shouldSendEventToExperimentationService: true,
        experimentationProject: ExperimentationProject.GROWTH,
    },
    SETUP_HUB_LOAD: { name: 'setup-hub-load', tags: [] },
    SETUP_HUB_CONNECT_CREATE: { name: 'setup-hub-connect-create', tags: [] },
    SETUP_HUB_CONNECT_CREATE_DROPDOWN: {
        name: 'setup-hub-connect-create-dropdown',
        tags: [],
    },
    SETUP_HUB_CONNECT_SELECT: { name: 'setup-hub-connect-select', tags: [] },
    SETUP_HUB_CONNECT_CSV_UPLOAD: {
        name: 'setup-hub-connect-csv-upload',
        tags: [],
    },
    SETUP_HUB_CONNECT_CSV_VIEW: {
        name: 'setup-hub-connect-csv-view',
        tags: [],
    },
    EXPLORE_DEMO_DATA_CLICK: {
        name: 'setup-demo-data-click',
        tags: [],
    },
    SETUP_HUB_MODEL_CREATE: { name: 'setup-hub-model-create', tags: [] },
    SETUP_HUB_MODEL_VIEW: { name: 'setup-hub-model-view', tags: [] },
    SETUP_HUB_VISUALIZE: {
        name: 'setup-hub-visualize',
        tags: [],
        shouldSendEventToExperimentationService: true,
        experimentationProject: ExperimentationProject.GROWTH,
    },
    SETUP_HUB_COMPLETE: { name: 'setup-hub-complete', tags: [] },
    SETUP_HUB_EXPLORE_THOUGHTSPOT: {
        name: 'setup-hub-explore-thoughtspot',
        tags: [],
    },
    SETUP_HUB_LINK_DOCUMENTATION: {
        name: 'setup-hub-link-documentation',
        tags: [],
    },
    SETUP_HUB_LINK_COMMUNITY: { name: 'setup-hub-link-community', tags: [] },
    SETUP_HUB_LINK_THOUGHTSPOT_U: {
        name: 'setup-hub-link-thoughtspot-u',
        tags: [],
    },
    SETUP_HUB_ENTRY_BANNER: {
        name: 'setup-hub-entry-banner',
        tags: [],
    },
    INVITE_TEAMMATES_CONNECTION_CREDS_PAGE: {
        name: 'invite-teammates-connection-creds-page',
        tags: [],
        shouldSendEventToExperimentationService: true,
        experimentationProject: ExperimentationProject.GROWTH,
    },
    INVITE_TEAMMATES_SETUP_HUB: {
        name: 'invite-teammates-setup-hub',
        tags: [],
        shouldSendEventToExperimentationService: true,
        experimentationProject: ExperimentationProject.GROWTH,
    },
    EMPTY_STATE_LOADED: { name: 'empty-state-loaded', tags: [] },
    SEARCH_ASSIST_DISPLAY: {
        name: 'search-assist-display',
        tags: [],
        shouldSendEventToExperimentationService: true,
        experimentationProject: ExperimentationProject.GROWTH,
    },
    SEARCH_ASSIST_ERROR: { name: 'search-assist-error', tags: [] },
    SEARCH_ASSIST_STEP: { name: 'search-assist-step', tags: [] },
    SEARCH_ASSIST_LESSON_END: {
        name: 'search-assist-lesson-end',
        tags: [],
        shouldSendEventToExperimentationService: true,
        experimentationProject: ExperimentationProject.GROWTH,
    },
    IMPORT_CLICKED: {
        name: 'import-clicked',
        tags: ['scriptability', 'import'],
    },
    IMPORT_STARTED: {
        name: 'import-started',
        tags: ['scriptability', 'import'],
    },
    IMPORT_COMPLETED: {
        name: 'import-completed',
        tags: ['scriptability', 'import'],
    },
    IMPORT_CANCELLED: {
        name: 'import-cancelled',
        tags: ['scriptability', 'import'],
    },
    UPLOAD_AGAIN_CLICKED: {
        name: 'upload-again-clicked',
        tags: ['scriptability', 'import'],
    },
    SHOW_ERRORS: {
        name: 'show-errors-clicked',
        tags: ['scriptability', 'import'],
    },
    TML_EDITOR_OPEN: {
        name: 'tml-editor-opened',
        tags: ['scriptability', 'import'],
    },
    TML_EDITOR_CLOSE: {
        name: 'tml-editor-closed',
        tags: ['scriptability', 'import'],
    },
    TML_EDITOR_SAVE: {
        name: 'tml-editor-saved',
        tags: ['scriptability', 'import'],
    },
    FILTER_BY_ERRORS: {
        name: 'filter-by-errors',
        tags: ['scriptability', 'import'],
    },
    EXPORT_CLICKED: {
        name: 'export-clicked',
        tags: ['scriptability', 'export'],
    },
    EXPORT_COMPLETED: {
        name: 'export-completed',
        tags: ['scriptability', 'export'],
    },
    UPDATE_CLICKED: {
        name: 'update-clicked',
        tags: ['scriptability', 'update'],
    },
    UPDATE_STARTED: {
        name: 'update-started',
        tags: ['scriptability', 'update'],
    },
    CONVERT_TO_MODEL_CLICKED: {
        name: 'convert-to-model-clicked',
        tags: ['worksheet'],
    },
    UPDATE_COMPLETED: {
        name: 'update-completed',
        tags: ['scriptability', 'update'],
    },
    UPDATE_CANCELLED: {
        name: 'update-cancelled',
        tags: ['scriptability', 'update'],
    },
    VISIT_SPOTAPP_CLICKED: {
        name: 'visit-spotapp-clicked',
        tags: ['scriptability', 'spotapp'],
    },
    VISIT_SPOTAPP_EXPORT_CLICKED: {
        name: 'visit-spotapp-export-clicked',
        tags: ['scriptability', 'spotapp-export'],
    },
    SPOTAPP_EXPORT_STARTED: {
        name: 'spotapp-export-started',
        tags: ['scriptability', 'spotapp-export'],
    },
    SPOTAPP_EXPORT_COMPLETED: {
        name: 'spotapp-export-completed',
        tags: ['scriptability', 'spotapp-export'],
    },
    SPOTAPP_EXPORT_FAILED: {
        name: 'spotapp-export-failed',
        tags: ['scriptability', 'spotapp-export'],
    },
    SPOTAPP_EXPORT_CANCELLED: {
        name: 'spotapp-export-cancelled',
        tags: ['scriptability', 'spotapp-export'],
    },
    SPOTAPP_EXPORT_SEARCH: {
        name: 'spotapp-export-search',
        tags: ['scriptability', 'spotapp-export'],
    },
    SPOTAPP_EXPORT_TAGS_CLICKED: {
        name: 'spotapp-export-tags-clicked',
        tags: ['scriptability', 'spotapp-export'],
    },
    SPOTAPP_EXPORT_AUTHORS_CLICKED: {
        name: 'spotapp-export-authors-clicked',
        tags: ['scriptability', 'spotapp-export'],
    },
    SPOTAPP_EXPORT_TOGGLE_BAR_CLICKED: {
        name: 'spotapp-export-toggle-bar-clicked',
        tags: ['scriptability', 'spotapp-export'],
    },
    EDIT_TSL_CLICKED: {
        name: 'edit-tsl-clicked',
        tags: ['scriptability', 'tsl-editor'],
    },
    VALIDATE_CLICKED: {
        name: 'validate-clicked',
        tags: ['scriptability', 'tsl-editor'],
    },
    PUBLISH_CLICKED: {
        name: 'publish-clicked',
        tags: ['scriptability', 'tsl-editor'],
    },
    ERROR_PANEL_CLOSED: {
        name: 'error-panel-closed',
        tags: ['scriptability', 'tsl-editor'],
    },
    TSL_EDITOR_MENU_ITEM_CLICKED: {
        name: 'tsl-editor-menu-item-clicked',
        tags: ['scriptability', 'tsl-editor'],
    },
    EUREKA_CLICK: {
        name: 'eureka-click',
        tags: ['eureka', 'search'],
    },
    EUREKA_CLEAR: {
        name: 'eureka-clear',
        tags: ['eureka', 'search'],
    },
    EUREKA_SELECT_WORKSHEET: {
        name: 'eureka-select-worksheet',
        tags: ['eureka', 'search', 'worksheet'],
    },
    EUREKA_SELECT_RESULT_TYPE: {
        name: 'eureka-select-result-type',
        tags: ['eureka', 'facet', 'result-type'],
    },
    EUREKA_SELECT_TAG: {
        name: 'eureka-select-tag',
        tags: ['eureaka', 'facet', 'tag'],
    },
    EUREKA_SELECT_AUTHOR: {
        name: 'eureka-select-author',
        tags: ['eureaka', 'facet', 'author'],
    },
    EUREKA_SORT: {
        name: 'eureka-sort',
        tags: ['eureka', 'sort'],
    },
    EUREKA_GET_RESULTS: {
        name: 'eureka-get-results',
        tags: ['eureka', 'result'],
    },
    EUREKA_GET_RESULT_DETAILS: {
        name: 'eureka-get-result-details',
        tags: ['eureka', 'result', 'right-panel'],
    },
    EUREKA_OPEN_RESULT: {
        name: 'eureka-open-result',
        tags: ['eureka', 'result'],
    },
    EUREKA_OPEN_PREVIEW: {
        name: 'eureka-open-preview',
        tags: ['eureka', 'result'],
    },
    EUREKA_CLOSE_PREVIEW: {
        name: 'eureka-close-preview',
        tags: ['eureka', 'result'],
    },
    EUREKA_NEXT_PAGE: {
        name: 'eureka-next-page',
        tags: ['eureka', 'navigation'],
    },
    EUREKA_PREVIOUS_PAGE: {
        name: 'eureka-previous-page',
        tags: ['eureka', 'navigation'],
    },
    EUREKA_FIRST_PAGE: {
        name: 'eureka-first-page',
        tags: ['eureka', 'navigation'],
    },
    EUREKA_SHOW_SUGGESTIONS: {
        name: 'eureka-show-suggestions',
        tags: ['eureka', 'typeahead'],
    },
    EUREKA_CHOOSE_SUGGESTION: {
        name: 'eureka-choose-suggestion',
        tags: ['eureka', 'typeahead'],
    },
    SHOW_DISCOVERABILITY: {
        name: 'show-discoverability',
        tags: ['discoverability', 'eureka'],
    },
    AI_QUERY_FEEDBACK_LOADED: {
        name: 'ai-query-feedback-loaded',
        tags: ['ai', 'sage-coach', 'load'],
    },
    AI_FRAGMENT_FEEDBACK_LOADED: {
        name: 'ai-fragment-feedback-loaded',
        tags: ['ai', 'sage-coach', 'load'],
    },
    AI_FRAGMENT_EDIT_BUTTON_CLICK: {
        name: 'ai-fragment-edit-btn-click',
        tags: ['ai', 'sage-coach', 'edit'],
    },
    AI_FRAGMENT_EDITED: {
        name: 'ai-fragment-edited',
        tags: ['ai', 'sage-coach', 'edited'],
    },
    AI_FEEDBACK_FIX_ANSWER: {
        name: 'ai-feedback-fix-answer',
        tags: ['ai', 'sage-coach', 'fix'],
    },
    AI_FEEDBACK_SEARCH_QUERY: {
        name: 'feedback-search-query-fired',
        tags: ['ai', 'sage-coach', 'search'],
    },
    AI_FEEDBACK_FILTER_SELECTED: {
        name: 'feedback-filter-selected',
        tags: ['ai', 'sage-coach', 'filter'],
    },
    AI_FEEDBACK_FIX_EXIT: {
        name: 'exit-fix-feedback-btn',
        tags: ['ai', 'sage-coach', 'fix', 'exit'],
    },
    FEEDBACK_SORT: {
        name: 'feedback-sort',
        tags: ['ai', 'sage-coach', 'sort'],
    },
    AI_FEEDBACK_CHANGE_ACCESS: {
        name: 'ai-feedback-change-access',
        tags: ['ai', 'sage-coach', 'access'],
    },
    AI_FEEDBACK_DELETE: {
        name: 'ai-feedback-delete',
        tags: ['ai', 'sage-coach', 'delete'],
    },
    AI_FEEDBACK_PAGE_FIRST_CLICK: {
        name: 'feedback-first-page-click',
        tags: ['ai', 'sage-coach', 'pagination'],
    },
    AI_FEEDBACK_PAGE_BACK_CLICK: {
        name: 'feedback-page-back-click',
        tags: ['ai', 'sage-coach', 'pagination'],
    },
    AI_FEEDBACK_PAGE_NEXT_CLICK: {
        name: 'feedback-page-next-click',
        tags: ['ai', 'sage-coach', 'pagination'],
    },
    AI_FEEDBACK_MORE_TOKEN_BTN_CLICK: {
        name: 'more-tokens-btn-click',
        tags: ['ai', 'sage-coach', 'pagination'],
    },
    AI_FEEDBACK_CHANGE_ACCESS_BTN_CLICK: {
        name: 'change-access-feedback-btn-Click',
        tags: ['ai', 'sage-coach', 'access'],
    },
    AI_FEEDBACK_DELETE_BTN_CLICK: {
        name: 'del-feedback-btn-Click',
        tags: ['ai', 'sage-coach', 'delete'],
    },
    AI_FEEDBACK_MENU_FIX_BTN_CLICK: {
        name: 'feedback-menu-fix-btn-click',
        tags: ['ai', 'sage-coach', 'fix'],
    },
    AI_FEEDBACK_EXPORT: {
        name: 'coach-spotter-feedback-export',
        tags: ['ai', 'sage-coach', 'export'],
    },
    AI_FEEDBACK_MENU_CHANGE_ACCESS_BTN_CLICK: {
        name: 'feedback-menu-change-access-btn-click',
        tags: ['ai', 'sage-coach', 'access'],
    },
    AI_FEEDBACK_MENU_DELETE_BTN_CLICK: {
        name: 'feedback-menu-del-btn-click',
        tags: ['ai', 'sage-coach', 'delete'],
    },
    KNOWLEDGE_CARD_ON_SHOW: {
        name: 'knowledge-card-on-show',
        tags: ['ai', 'spotter', 'knowledge-card'],
    },
    KNOWLEDGE_CARD_SHOW_MORE_CLICKED: {
        name: 'knowledge-card-show-more-clicked',
        tags: ['ai', 'spotter', 'knowledge-card'],
    },
    AI_FEEDBACK_LINK_CLICK: {
        name: 'click-feedback-link',
        tags: ['ai', 'sage-coach', 'link'],
    },
    AI_FEEDBACK_SELECT_ALL: {
        name: 'feedback-select-all-checkbox',
        tags: ['ai', 'sage-coach', 'link'],
    },
    AI_FEEDBACK_SELECT_ALL_ACROSS: {
        name: 'feedback-select-all-across',
        tags: ['ai', 'sage-coach', 'link'],
    },
    AI_FEEDBACK_DESELECT_ALL_ACROSS: {
        name: 'feedback-deselect-all-across',
        tags: ['ai', 'sage-coach', 'link'],
    },
    AI_FEEDBACK_UPDATE_QUERY_SCREEN_LOADED: {
        name: 'update-feedback-query-screen-loaded',
        tags: ['ai', 'sage-coach', 'link'],
    },
    AI_TRAIN_STARTED: {
        name: 'ai-training-started',
        tags: ['ai', 'train', 'start'],
    },
    AI_TRAIN_SOURCE_SELECTION: {
        name: 'ai-training-source-selection',
        tags: ['ai', 'train'],
    },
    AI_TRAIN_SOURCE_CHANGE: {
        name: 'ai-training-source-changed',
        tags: ['ai', 'train'],
    },
    AI_TRAIN_QUERY_SUBMITTED: {
        name: 'ai-training-query-submitted',
        tags: ['ai', 'train', 'submit'],
    },
    AI_TRAIN_PREVIEW_DATA_BTN_CLICKED: {
        name: 'ai-training-preview-data-btn-clicked',
        tags: ['ai', 'train', 'preview'],
    },
    AI_TRAIN_PREVIEW_DATA_LOADED: {
        name: 'ai-training-preview-data-loaded',
        tags: ['ai', 'train', 'preview'],
    },
    AI_TRAIN_ANSWER_FAILED: {
        name: 'ai-training-answer-failed',
        tags: ['ai', 'train'],
    },
    AI_TRAIN_ANSWER_LOADED: {
        name: 'ai-training-answer-loaded',
        tags: ['ai', 'train'],
    },
    AI_TRAIN_NL_EDITED: {
        name: 'ai-training-nl-edited',
        tags: ['ai', 'train'],
    },
    AI_TRAIN_FRAGMENTS_LOADED: {
        name: 'ai-training-fragments-loaded',
        tags: ['ai', 'train'],
    },
    AI_TRAIN_RESTART: {
        name: 'ai-training-restart',
        tags: ['ai', 'train'],
    },
    AI_TRAIN_CANCELLED: {
        name: 'ai-training-cancelled',
        tags: ['ai', 'train'],
    },
    AI_TRAIN_BACK_BTN_CLICKED: {
        name: 'ai-training-back-btn-clicked',
        tags: ['ai', 'train'],
    },
    AI_TRAIN_DONE: {
        name: 'ai-training-done',
        tags: ['ai', 'train'],
    },
    AI_TRAIN_NL_POSITIVE_FEEDBACK: {
        name: 'ai-train-nl-positive-feedback',
        tags: ['ai', 'train', 'nl'],
    },
    AI_TRAIN_NL_NEGATIVE_FEEDBACK: {
        name: 'ai-train-nl-negative-feedback',
        tags: ['ai', 'train', 'nl'],
    },
    AI_SEARCH_BAR_LOADED: {
        name: 'ai-search-bar-loaded',
        tags: ['eureka', 'ai', 'load'],
    },
    AI_ANSWER_LOADED: {
        name: 'ai-answer-loaded',
        tags: ['eureka', 'ai'],
    },
    AI_ANSWER_TITLE_CLICKED: {
        name: 'ai-answer-title-click',
        tags: ['eureka', 'ai', 'load'],
    },
    AI_ANSWER_EXPLORE_CLICKED: {
        name: 'ai-answer-explore-click',
        tags: ['eureka', 'ai', 'explore'],
    },
    AI_ANSWER_UPVOTE: {
        name: 'ai-answer-upvote',
        tags: ['eureka', 'ai', 'positive'],
    },
    AI_ANSWER_SAVE: {
        name: 'ai-answer-save',
        tags: ['eureka', 'ai', 'save'],
    },
    AI_ANSWER_WARNING: {
        name: 'ai-answer-warning',
        tags: ['eureka', 'ai', 'warning'],
    },
    AI_ANSWER_PIN: {
        name: 'ai-answer-pin',
        tags: ['eureka', 'ai', 'pin'],
    },
    AI_ANSWER_DOWNVOTE: {
        name: 'ai-answer-downvote',
        tags: ['eureka', 'ai', 'negative'],
    },
    AI_ANSWER_INTENT_TO_FIX: {
        name: 'ai-answer-intent-to-fix',
        tags: ['eureka', 'ai', 'fix'],
    },
    AI_ANSWER_SUBMIT_FEEDBACK: {
        name: 'ai-answer-submit-feedback',
        tags: ['eureka', 'ai', 'feedback'],
    },
    AI_ANSWER_SHOW_QUERY: {
        name: 'ai-answer-show-query',
        tags: ['eureka', 'ai', 'query'],
    },
    AI_ANSWER_FEEDBACK_SUBMITTED: {
        name: 'ai-answer-fragment-submitted',
        tags: ['eureka', 'ai', 'feedback', 'fragment'],
    },
    NLS_SHOW_FEEDBACK_LEADERBOARD: {
        name: 'nls-show-feedback-leaderboard',
        tags: ['nls', 'ai', 'feedback', 'leaderboard'],
    },
    WORKSHEET_AI_ANSWER_ENABLED: {
        name: 'worksheet-ai-answer-enabled',
        tags: ['eureka', 'worksheet', 'ai'],
    },
    MODEL_AI_ANSWER_ENABLED: {
        name: 'model-ai-answer-enabled',
        tags: ['eureka', 'model', 'ai'],
    },
    OPEN_DEEPLINK_PAGE: {
        name: 'open-deeplink-page',
        tags: ['deeplink'],
    },
    SA_SETUP_TAB: {
        name: 'sa-setup-tab',
        tags: ['searchAssist', 'AAQ'],
    },
    SA_SETUP_LESSON_PLAN: {
        name: 'sa-setup-lesson-open',
        tags: ['searchAssist', 'AAQ'],
    },
    SA_SETUP_LESSON_CANCEL: {
        name: 'sa-setup-lesson-cancel',
        tags: ['searchAssist', 'AAQ'],
    },
    SA_SETUP_LESSON_SAVE: {
        name: 'sa-setup-lesson-save',
        tags: ['searchAssist', 'AAQ'],
    },
    SA_SETUP_LESSON_TOKEN: {
        name: 'sa-setup-lesson-token',
        tags: ['searchAssist', 'AAQ'],
    },
    SA_SETUP_LESSON_TEXT: {
        name: 'sa-setup-lesson-text',
        tags: ['searchAssist', 'AAQ'],
    },
    SA_SETUP_ERROR: {
        name: 'sa-setup-error',
        tags: ['searchAssist', 'AAQ'],
    },
    SUGGESTED_QUESTIONS_LOADED: {
        name: 'suggested-questions-loaded',
        tags: ['eureka', 'ai', 'suggested-question'],
    },
    SUGGESTED_QUESTION_CLICKED: {
        name: 'suggested-question-clicked',
        tags: ['eureka', 'ai', 'suggested-question', 'spotter'],
    },
    LOAD_HOME_PAGE: {
        name: 'load-home-page',
        tags: [],
    },
    HOME_GET_RESULTS: {
        name: 'home-get-results',
        tags: [],
    },
    HOME_EUREKA_CLICK: {
        name: 'home-eureka-click',
        tags: [],
    },
    HOME_SELECT_RESULT_TYPE: {
        name: 'home-select-result-type',
        tags: [],
    },
    HOME_SELECT_TAG: {
        name: 'home-select-tag',
        tags: [],
    },
    HOME_OPEN_AUTHOR_SELECTOR: {
        name: 'home-open-author-selector',
        tags: [],
    },
    HOME_SELECT_AUTHOR: {
        name: 'home-select-author',
        tags: [],
    },
    HOME_FAVORITE_TOGGLE: {
        name: 'home-favorite-toggle',
        tags: [],
    },
    HOME_SORT_RESULTS: {
        name: 'home-sort-results',
        tags: [],
    },
    HOME_CHECK_OBJECT: {
        name: 'home-check-object',
        tags: [],
    },
    HOME_CHECKED_FAVORITE: {
        name: 'home-checked-favorite',
        tags: [],
    },
    HOME_CHECKED_UNFAVORITE: {
        name: 'home-checked-unfavorite',
        tags: [],
    },
    LOAD_FROM_HOME_RESULTS: {
        name: 'load-from-home-results',
        tags: [],
    },
    LOAD_FROM_SIDE_PANEL: {
        name: 'load-from-home-side-panel',
        tags: [],
    },
    HOME_INLINE_FAVORITE: {
        name: 'home-inline-favorite',
        tags: [],
    },
    HOME_INLINE_UNFAVORITE: {
        name: 'home-inline-unfavorite',
        tags: [],
    },
    HOME_RESULTS_NEXT_PAGE: {
        name: 'home-results-next-page',
        tags: [],
    },
    HOME_RESULTS_PREV_PAGE: {
        name: 'home-results-prev-page',
        tags: [],
    },
    HOME_RESULTS_EMPTY_STATE: {
        name: 'home-results-empty-state',
        tags: [],
    },
    HOME_EMPTY_STATE_CREATE_ANSWER: {
        name: 'home-empty-state-create-answer',
        tags: [],
    },
    HOME_EMPTY_STATE_CREATE_PINBOARD: {
        name: 'home-empty-state-create-pinboard',
        tags: [],
    },
    HOME_SEARCH_RESULT_CLICK: {
        name: 'home-search-result-click',
        tags: [],
    },
    HOME_SEARCH_RESULT_ENTER: {
        name: 'home-search-result-enter',
        tags: [],
    },
    HOME_SELECT_ALL: {
        name: 'home-select-all',
        tags: [],
    },
    HOME_UNSELECT_ALL: {
        name: 'home-unselect-all',
        tags: [],
    },
    HOME_WATCHLIST_SELECT: {
        name: 'home-watchlist-select',
        tags: ['homepage', 'watchlist'],
    },
    HOME_CAROUSEL_LOAD: {
        name: 'home-carousel-load',
        tags: ['homepage', 'carousel'],
    },
    HOME_CAROUSEL_LEFT: {
        name: 'home-carousel-left',
        tags: ['homepage', 'carousel'],
    },
    HOME_CAROUSEL_RIGHT: {
        name: 'home-carousel-right',
        tags: ['homepage', 'carousel'],
    },
    HOME_OPEN_CARD: {
        name: 'home-open-card',
        tags: ['homepage', 'carousel'],
    },
    HOME_DRAG_DROP_CARD: {
        name: 'home-drag-drop-card',
        tags: ['homepage', 'carousel'],
    },
    HOME_MOVE_CARD_LEFT: {
        name: 'home-move-card-left',
        tags: ['homepage', 'carousel'],
    },
    HOME_MOVE_CARD_RIGHT: {
        name: 'home-move-card-right',
        tags: ['homepage', 'carousel'],
    },
    HOME_MOVE_CARD_FIRST: {
        name: 'home-move-card-first',
        tags: ['homepage', 'carousel'],
    },
    HOME_DELETE_CARD_OPEN: {
        name: 'home-delete-card-open',
        tags: ['homepage', 'carousel'],
    },
    HOME_DELETE_CARD_CLOSE_OUTSIDE: {
        name: 'home-delete-card-close-outside',
        tags: ['homepage', 'carousel'],
    },
    HOME_DELETE_CARD_CLOSE_CANCEL: {
        name: 'home-delete-card-close-cancel',
        tags: ['homepage', 'carousel'],
    },
    HOME_DELETE_CARD: {
        name: 'home-delete-card',
        tags: ['homepage', 'carousel'],
    },
    HOME_REPLACE_CARD: {
        name: 'home-replace-card',
        tags: ['homepage', 'carousel'],
    },
    HOME_ADD_CARD_OPEN: {
        name: 'home-add-card-open',
        tags: ['homepage', 'carousel'],
    },
    HOME_ADD_CARD: {
        name: 'home-add-card',
        tags: ['homepage', 'carousel'],
    },
    HOME_ADD_CARD_CLOSE_OUTSIDE: {
        name: 'home-add-card-close-outside',
        tags: ['homepage', 'carousel'],
    },
    HOME_ADD_CARD_CLOSE_CANCEL: {
        name: 'home-add-card-close-cancel',
        tags: ['homepage', 'carousel'],
    },
    HOME_LOAD_CARD: {
        name: 'home-display-card',
        tags: ['homepage', 'carousel'],
    },
    HOME_DISPLAY_CARD: {
        name: 'home-display-card',
        tags: ['homepage', 'carousel'],
    },
    HOME_DELETE_OBJECT: {
        name: 'home-delete-object',
        tags: ['homepage'],
    },
    HOME_APPLY_TAGS: {
        name: 'home-apply-tags-to-object',
        tags: ['homepage'],
    },
    HOME_UNAPPLY_TAGS: {
        name: 'home-unapply-tags-to-object',
        tags: ['homepage'],
    },
    HOME_LB_NAME_CLICK: {
        name: 'home-lb-name-click',
        tags: ['homepage'],
    },
    HOME_KPI_LEFT_RAIL_CLICK: {
        name: 'home-kpi-left-rail-click',
        tags: ['homepage'],
    },
    HOME_COPY_LINK: {
        name: 'home-copy-link',
        tags: ['homepage'],
    },
    HOME_OVERFLOW_MENU: {
        name: 'home-overflow-menu',
        tags: ['homepage'],
    },
    HOME_WATCHLIST_CREATE_ALERT: {
        name: 'home-watchlist-create-alert',
        tags: ['homepage'],
    },
    HOME_WATCHLIST_MANAGE_ALERT: {
        name: 'home-watchlist-manage-alert',
        tags: ['homepage'],
    },
    HOME_TRENDING_LOAD: {
        name: 'home-trending-load',
    },
    HOME_TRENDING_PAGE_CHANGE: {
        name: 'home-trending-page-change',
    },
    HOME_TRENDING_SHARED_CLICKED: {
        name: 'home-trending-shared-clicked',
    },
    HOME_TRENDING_FAV_CLICKED: {
        name: 'home-trending-fav-clicked',
    },
    HOME_FAV_LOAD: {
        name: 'home-fav-load',
    },
    HOME_FAV_CLICKED: {
        name: 'home-fav-clicked',
    },
    HOME_FAV_PAGE_CHANGE: {
        name: 'home-fav-page-change',
    },
    HOME_FAV_SHARED_CLICKED: {
        name: 'home-fav-shared-clicked',
    },
    HOME_CUSTOMIZATION_OPEN: {
        name: 'home-customization-open',
    },
    HOME_CUSTOMIZATION_CANCEL: {
        name: 'home-customization-cancel',
    },
    HOME_CUSTOMIZATION_DONE: {
        name: 'home-customization-done',
    },
    VALIDATE_WORKSHEET_JOINS: {
        name: 'validate-worksheet-joins',
        tags: [],
    },
    ERROR_MESSAGE_SHOWN: {
        name: 'error-message-shown',
        tags: [],
    },
    IMPORT_EDOC: {
        name: 'import-edoc',
        tags: [],
    },
    FETCH_TABLES_LIST: {
        name: 'fetch-tables-list',
        tags: [],
    },
    FETCH_SUGGESTED_RELATIONSHIP: {
        name: 'fetch-suggested-relationships',
        tags: [],
    },
    FETCH_AUTO_WORKSHEET_DATA: {
        name: 'fetch-worksheet-data',
        tags: [],
    },
    AUTOGEN_SUGGESTED_RELATIONSHIPS: {
        name: 'autogen-suggested-relationship',
        tags: [],
    },
    AUTOGEN_FACT_NEXT: {
        name: 'autogen-fact-next',
        tags: [],
    },
    AUTOGEN_DIMENSION_NEXT: {
        name: 'autogen-dimension-next',
        tags: [],
    },
    AUTOGEN_JOINS_EXIST: {
        name: 'autogen-joins-exist',
        tags: [],
    },
    AUTOGEN_VALIDATE_WORKSHEET_JOINS: {
        name: 'autogen-validate-worksheet-joins',
        tags: [],
    },
    AUTOGEN_SAVE: {
        name: 'autogen-save',
        tags: [],
    },
    AUTOANSWER_COL_SELECTION_LOADED: {
        name: 'autoanswer-col-selection-loaded',
        tags: [],
    },
    AUTOANSWER_COL_SELECTION_NEXT: {
        name: 'autoanswer-col-selection-next',
        tags: [],
    },
    AUTOANSWER_LIST_VIEW_LOADED: {
        name: 'autoanswer-list-view-loaded',
        tags: [],
    },
    AUTOANSWER_SELECTED: {
        name: 'autoanswer-selected',
        tags: [],
    },
    AUTOANSWER_SEARCH_PAGE_LOADED: {
        name: 'autoanswer-search-page-loaded',
        tags: [],
    },
    AUTOANSWER_EXIT: {
        name: 'autoanswer-exit',
        tags: [],
    },
    AUTOANSWER_SAVE: {
        name: 'autoanswer-save',
        tags: [],
    },
    AUTOANSWER_BULK_SAVE: {
        name: 'autoanswer-bulk-save',
        tags: [],
    },
    AUTOANSWER_BULK_CANCEL: {
        name: 'autoanswer-bulk-cancel',
        tags: [],
    },
    AUTOANSWER_ERROR: {
        name: 'autoanswer-error',
        tags: [],
    },
    CUSTOM_ACTION_CLICKED: {
        name: 'custom-action-clicked',
        tags: [],
    },
    MONITOR_CHART_CONTEXT_MENU_CLICK: {
        name: 'monitor-chart-context-menu-click',
        tags: [],
    },
    MONITOR_SETUP_VIEW: {
        name: 'monitor-setup-view',
        tags: [],
    },
    MONITOR_CONTINUE_BUTTON_CLICK: {
        name: 'monitor-continue-button-click',
        tags: [],
    },
    MONITOR_SETUP_CLOSE: {
        name: 'monitor-setup-close',
        tags: [],
    },
    MONITOR_SUBSCRIBER_ADDED: {
        name: 'monitor-subscriber-added',
        tags: [],
    },
    MONITOR_SUBSCRIBER_REMOVED: {
        name: 'monitor-subscriber-removed',
        tags: [],
    },
    MONITOR_SETUP_COMPLETE: {
        name: 'monitor-setup-complete',
        tags: [],
    },
    MONITOR_METRIC_CLICK: {
        name: 'monitor-metric-click',
        tags: [],
    },
    MONITOR_LIST_PAGE_LOAD: {
        name: 'monitor-list-page-load',
        tags: [],
    },
    MONITOR_DETAIL_PAGE_LOAD: {
        name: 'monitor-detail-page-load',
        tags: [],
    },
    MONITOR_METRIC_ADD_USERS_CLICK: {
        name: 'monitor-metric-add-users-click',
        tags: [],
    },
    MONITOR_ADD_USERS_MODAL_SAVE: {
        name: 'monitor-add-users-modal-save',
        tags: [],
    },
    MONITOR_SUBSCRIBER_SUGGESTION: {
        name: 'monitor-subscriber-suggestion',
        tags: [],
    },
    MONITOR_METRIC_RENAME_CLICK: {
        name: 'monitor-metric-rename-click',
        tags: [],
    },
    MONITOR_METRIC_STOP_MONITORING_CLICK: {
        name: 'monitor-metric-stop-monitoring-click',
        tags: [],
    },
    MONITOR_METRIC_START_MONITORING_CLICK: {
        name: 'monitor-metric-start-monitoring-click',
        tags: [],
    },
    MONITOR_METRIC_DELETE_CLICK: {
        name: 'monitor-metric-delete-click',
        tags: [],
    },
    MONITOR_METRIC_SHOW_SUBSCRIBERS_CLICK: {
        name: 'monitor-metric-show-subscribers-click',
        tags: [],
    },
    MONITOR_METRIC_SHOW_QUERY_CLICK: {
        name: 'monitor-metric-show-query-clicked',
        tags: [],
    },
    MONITOR_RENAME: {
        name: 'monitor-rename',
        tags: [],
    },
    MONITOR_DELETE: {
        name: 'monitor-delete',
        tags: [],
    },
    MONITOR_STOP_MONITORING: {
        name: 'monitor-stop-monitoring',
        tags: [],
    },
    MONITOR_START_MONITORING: {
        name: 'monitor-start-monitoring',
        tags: [],
    },
    MONITOR_ALERT_BUTTON_CLICK: {
        name: 'monitor-alert-btn-click',
        tags: [],
    },
    MONITOR_MANAGE_ALERT_BUTTON_CLICK: {
        name: 'monitor-manage-alert-btn-click',
        tags: [],
    },
    MONITOR_ALERT_MODAL_VIEW: {
        name: 'monitor-alert-modal-view',
        tags: [],
    },
    MONITOR_ALERT_MODAL_CLOSE: {
        name: 'monitor-alert-modal-close',
        tags: [],
    },
    MONITOR_ALERT_ADD_NEW_CLICK: {
        name: 'monitor-alert-create-btn-click',
        tags: [],
    },
    MONITOR_ALERT_SUBSCRIBE: {
        name: 'monitor-alert-subscribe',
        tags: [],
    },
    MONITOR_ALERT_UNSUBSCRIBE: {
        name: 'monitor-alert-unsubscribe',
        tags: [],
    },
    MONITOR_ALERT_SUBSCRIBER_ADDED: {
        name: 'monitor-alert-subscriber-added',
        tags: [],
    },
    MONITOR_ALERT_SUBSCRIBER_REMOVED: {
        name: 'monitor-alert-subscriber-removed',
        tags: [],
    },
    MONITOR_ALERT_SAVE: {
        name: 'monitor-alert-save',
        tags: [],
    },
    MONITOR_TYPE_SELECT: {
        name: 'monitor-type-select',
        tags: [],
    },
    MONITOR_TYPE_SELECT_NEXT: {
        name: 'monitor-type-select-next',
        tags: [],
    },
    MONITOR_ALERT_TYPE_DISABLED: {
        name: 'monitor-alert-type-disabled',
        tags: [],
    },
    MONITOR_ATTRIBUTE_SELECTED_COUNT: {
        name: 'monitor-attribute-selected-count',
        tags: [],
    },
    MONITOR_ATTRIBUTE_SELECT: {
        name: 'monitor-attribute-select',
        tags: [],
    },
    MONITOR_KPI_QUERY_VIEW: {
        name: 'monitor-kpi-query-view',
        tags: [],
    },
    MONITOR_DEFAULT_ATTRIBUTE_LIST: {
        name: 'monitor-default-attribute-list',
        tags: [],
    },
    MONITOR_ALERT_UPDATE: {
        name: 'monitor-alert-update',
        tags: [],
    },
    MONITOR_ALERT_LIST_PAGE_LOAD: {
        name: 'monitor-tab-load',
        tags: [],
    },
    MONITOR_ALERT_MENU_CLICK: {
        name: 'monitor-alert-menu-btn-click',
        tags: [],
    },
    MONITOR_ALERT_EDIT_CLICK: {
        name: 'monitor-alert-edit-btn-click',
        tags: [],
    },
    MONITOR_ALERT_MANAGE_SUBSCRIBERS_CLICK: {
        name: 'monitor-alert-add-subscribers-btn-click',
        tags: [],
    },
    MONITOR_ALERT_DELETE_CLICK: {
        name: 'monitor-alert-delete-btn-click',
        tags: [],
    },
    MONITOR_ALERT_DELETE: {
        name: 'monitor-alert-delete',
        tags: [],
    },
    INITIAL_PAGE_LOAD_METRICS: {
        name: 'initial-page-load-metrics',
        tags: [],
    },
    APP_INITIALIZED: {
        name: 'app_initialized',
        tags: [],
    },
    DEVELOP_TAB_LOAD_PAGE: {
        name: 'develop-tab-load-page',
        tags: [],
    },
    DEVELOP_TAB_HOMEPAGE_CLICK: {
        name: 'develop-tab-homepage-click',
        tags: [],
    },
    SIGN_UP_FREE_TRIAL_CLICK: {
        name: 'sign-up-free-trial-click',
        tags: [],
    },
    TSE_LICENSE_FREE_TRIAL_CLICK: {
        name: 'tse-license-free-trial-click',
        tags: [],
    },
    TSE_LICENSE_UPGRDE_CLICK: {
        name: 'tse-license-upgrade-click',
        tags: [],
    },
    TSE_SEEKWELL_SEND_NOW: {
        name: 'tse-seekwell-send-now',
        tags: [],
    },
    TSE_SEEKWELL_CREATE_SCHEDULE: {
        name: 'tse-seekwell-create-schedule',
        tags: [],
    },
    TSE_SEEKWELL_DELETE_SCHEDULE: {
        name: 'tse-seekwell-delete-schedule',
        tags: [],
    },
    TSE_SEEKWELL_MANAGE_SCHEDULE: {
        name: 'tse-seekwell-manage-schedule',
        tags: [],
    },
    FREE_TRIAL_GUESS_ETIMATE_PASSWORD_ATTEMPT: {
        name: 'guess_estimate_attempt',
        tags: [],
    },
    ANSWER_EXPERIENCE_SWITCH: {
        name: 'experience-switch',
        tags: ['user-preference', 'answer'],
    },
    PINBOARD_EXPERIENCE_SWITCH: {
        name: 'experience-switch',
        tags: ['user-preference', 'pinboard'],
    },
    EXPERIENCE_SWITCH: {
        name: 'experience-switch',
        tags: ['user-preference', 'pinboard', 'answer'],
    },
    EXPERIENCE: {
        name: 'experience',
        tags: ['user-preference', 'answer'],
    },
    REVISIT_ONBOARDING_EXPERIENCE: {
        name: 'revisit-onboarding-experience',
        tags: [],
    },
    SAVE_PREFERENCES_USER_PROFILE: {
        name: 'save-preferences-user-profile',
        tags: [],
    },
    UPLOAD_CSV_STARTED: {
        name: 'upload-csv-started',
        tags: [],
    },
    SELECT_CSV_BUTTON_CLICKED: {
        name: 'select-csv-button-clicked',
        tags: [],
    },
    CSV_START_SEARCHING: {
        name: 'csv-start-searching',
        tags: [],
        shouldSendEventToExperimentationService: true,
        experimentationProject: ExperimentationProject.GROWTH,
    },
    TOGGLE_CHART_CUSTOM_PROPS: {
        name: 'toogle-chart-custom-props',
        tags: [],
    },
    ANSWER_DETAIL_DELETE_MENU_CLICK: {
        name: 'click-delete-answer-menu-item',
        tags: [],
    },
    CLICK_VIEW_PROFILE: {
        name: 'click-view-profile',
        tags: [],
    },
    OPEN_PATH_ANALYZER: {
        name: 'open-path-analyzer',
        tags: ['cja'],
    },
    RUN_PATH_ANALYSIS: {
        name: 'run-path-analysis',
        tags: ['cja'],
    },
    LOAD_SPOTIQ_LIST_PAGE: {
        name: 'load-spotiq-list-page',
        tags: [],
    },
    CLICK_SPOTIQ_TAB_ALL_YOURS: {
        name: 'click-spotiq-tab-all-yours',
        tags: [],
    },
    SQLVIEW_LOAD: {
        name: 'sqlview-load',
        tags: [],
    },
    SQLVIEW_CONNECTION_SELECTED: {
        name: 'sqlview-connection-selected',
        tags: [],
    },
    SQLVIEW_CLICK_SAVE: {
        name: 'sqlview-click-save',
        tags: [],
    },
    SQLVIEW_SAVE_SUCCESS: {
        name: 'sqlview-save-success',
        tags: [],
    },
    SQLVIEW_SAVE_ERROR: {
        name: 'sqlview-save-error',
        tags: [],
    },
    SQLVIEW_CLICK_SAVEAS: {
        name: 'sqlview-click-saveas',
        tags: [],
    },
    SQLVIEW_SAVEAS_SUCCESS: {
        name: 'sqlview-saveas-success',
        tags: [],
    },
    SQLVIEW_RUN: {
        name: 'sqlview-run',
        tags: [],
    },
    SQLVIEW_RUN_ERROR: {
        name: 'sqlview-run-error',
        tags: [],
    },
    SQLVIEW_REVERT: {
        name: 'sqlview-revert',
        tags: [],
    },
    SQLVIEW_OPEN_VIEW_DETAILS: {
        name: 'sqlview-open-view-details',
        tags: [],
    },
    SQLVIEW_EXIT: {
        name: 'sqlview-exit',
        tags: [],
    },
    SPOTIQ_RESULT_SHARE: {
        name: 'Spotiq-result-share',
        tags: [],
    },
    SPOTIQ_RESULT_DELETE: {
        name: 'spotiq-result-delete',
        tags: [],
    },
    SPOTIQ_LIST_SORT: {
        name: 'spotiq-list-sort',
        tags: [],
    },
    SPOTIQ_LIST_NEXT_PAGE: {
        name: 'spotiq-list-next-page',
        tags: [],
    },
    SPOTIQ_LIST_PREVIOUS_PAGE: {
        name: 'spotiq-list-previous-page',
        tags: [],
    },
    SPOTIQ_DEFAULT_PREFERENCE: {
        name: 'SpotIQ-default-preference',
        tags: [],
    },
    CREATE_WORKSHEET_CLICKED: {
        name: 'create-worksheet-clicked',
        tags: [],
    },
    CREATE_SQLVIEW_CLICKED: {
        name: 'create-sqlview-clicked',
        tags: [],
    },
    UTILITIES_CLICKED: {
        name: 'utilities-clicked',
        tags: [],
    },
    USAGESTATISTICS_CLICKED_V2: {
        name: 'usagestatistics-clicked-v2',
        tags: [],
    },
    IMPORT_CLICKED_V2: {
        name: 'import-clicked-v2',
        tags: [],
    },
    DBT_CLICKED_V2: {
        name: 'dbt-clicked-v2',
        tags: [],
    },
    DBT_CONFIG_OPTION_SELECTED: {
        name: 'dbt-config-option-selected',
        tags: [],
    },
    DBT_CONFIG_ERROR: {
        name: 'dbt-config-error',
        tags: [],
    },
    DBT_FETCH_FOLDERS: {
        name: 'dbt-fetch-foldersed',
        tags: [],
    },
    DBT_SELECTED_FOLDERS: {
        name: 'dbt-selected-folders',
        tags: [],
    },
    DBT_FETCHED_TABLES_ERROR: {
        name: 'dbt-fetched-tables-error',
        tags: [],
    },
    DBT_FETCHED_TABLES: {
        name: 'dbt-fetched-tables',
        tags: [],
    },
    DBT_SELECTED_TABLES: {
        name: 'dbt-selected-tables',
        tags: [],
    },
    DBT_WS_GENERATE_ERROR: {
        name: 'dbt-ws-generate-error',
        tags: [],
    },
    DBT_WS_GENERATE: {
        name: 'dbt-ws-generate',
        tags: [],
    },
    DBT_WS_CLICKED: {
        name: 'dbt-ws-clicked',
        tags: [],
    },
    DBT_EXITED: {
        name: 'dbt-exited',
        tags: [],
    },
    DEST_CLICKED: {
        name: 'sync-clicked',
        tags: [],
    },
    SYNC_DEST_PAGE_VISITED: {
        name: 'sync-dest-page-visited',
        tags: [],
    },
    SYNC_DEST_TYPE_CLICKED: {
        name: 'sync-dest-type-clicked',
        tags: [],
    },
    SYNC_DEST_AUTH_ALLOW: {
        name: 'sync-dest-auth-allow',
        tags: [],
    },
    SYNC_DEST_AUTH_CANCEL: {
        name: 'sync-dest-auth-cancel',
        tags: [],
    },
    SYNC_DEST_APP_AUTH_ERROR: {
        name: 'sync-dest-app-auth-error',
        tags: [],
    },
    SYNC_DEST_CREATE_MODAL_CANCEL: {
        name: 'sync-dest-create-modal-cancel',
        tags: [],
    },
    SYNC_DEST_LIST_PANEL: {
        name: 'sync-dest-list-panel',
        tags: [],
    },
    SYNC_CLICKED: {
        name: 'sync-clicked',
        tags: [],
    },
    DEST_SYNC_ALL_SOURCES: {
        name: 'dest-sync-all-sources',
        tags: [],
    },
    DEST_SYNC_ALL_TARGETS: {
        name: 'dest-sync-all-targets',
        tags: [],
    },
    SYNC_DEST_CREATE_NEW_SYNC: {
        name: 'sync-dest-create-new-sync',
        tags: [],
    },
    SYNC_DEST_CREATE_SYNC_CANCEL: {
        name: 'sync-dest-create-sync-cancel',
        tags: [],
    },
    DEST_SYNC_ACTIVITY_LOG: {
        name: 'dest-sync-activity-log',
        tags: [],
    },
    SYNC_NOW_CLICKED: {
        name: 'sync-now-clicked',
        tags: [],
    },
    SYNC_TO_SHEETS_VIEW: {
        name: 'sync-to-sheets-view',
        tags: [],
    },
    SYNC_TO_OTHER_APPS_VIEW: {
        name: 'sync-to-other-apps-view',
        tags: [],
    },
    SYNC_MANAGE_PIPELINES_VIEW: {
        name: 'sync-manage-pipelines-view',
        tags: [],
    },
    SYNC_NOW_MANAGE_PIPELINE_VIEW: {
        name: 'sync-now-manage-pipelines-view',
        tags: [],
    },
    SYNC_TO_SLACK_PINBOARD: {
        name: 'sync-to-slack-pinboard',
        tags: [],
    },
    SYNC_TO_MSTEAM_PINBOARD: {
        name: 'sync-to-msteam-pinboard',
        tags: [],
    },
    SYNC_TO_SHEETS_ANSWER: {
        name: 'sync-to-sheets-answer',
        tags: [],
    },
    SYNC_TO_OTHER_APPS_ANSWER: {
        name: 'sync-to-other-apps-answer',
        tags: [],
    },
    SYNC_MANAGE_PIPELINES_ANSWER: {
        name: 'sync-manage-pipelines-answer',
        tags: [],
    },
    SYNC_NOW_MANAGE_PIPELINE_ANSWER: {
        name: 'sync-now-manage-pipelines-answer',
        tags: [],
    },
    EXPORT_CLICKED_V2: {
        name: 'export-clicked-v2',
        tags: [],
    },
    SCHEMA_VIEWER_CLICKED_V2: {
        name: 'schema-viewer-clicked-v2',
        tags: [],
    },
    LIVEBOARD_SCHEDULE_CLICKED_V2: {
        name: 'liveboard-schedule-clicked-v2',
        tags: [],
    },
    UPLOAD_SCHEMA_CLICKED_V2: {
        name: 'upload-schema-clicked-v2',
        tags: [],
    },
    CUSTOM_CALENDAR_CLICKED_V2: {
        name: 'custom-calendar-clicked-v2',
        tags: [],
    },
    CUSTOM_CALENDAR_CREATE_NEW_CALENDAR_START: {
        name: 'custom-calendar-create-new-calendar-start',
        tags: [],
    },
    CUSTOM_CALENDAR_CREATE_NEW_CALENDAR_SUBMIT: {
        name: 'custom-calendar-create-new-calendar-submit',
        tags: [],
    },
    CUSTOM_CALENDAR_OPEN_EXISTING_CALENDAR: {
        name: 'custom-calendar-open-existing-calendar',
        tags: [],
    },
    CUSTOM_CALENDAR_DOWNLOAD_EXISTING_CALENDAR: {
        name: 'custom-calendar-download-existing-calendar',
        tags: [],
    },
    CUSTOM_CALENDAR_CREATE_NEW_CALENDAR_SUCCESS: {
        name: 'custom-calendar-create-new-calendar-success',
        tags: [],
    },
    CUSTOM_CALENDAR_CREATE_NEW_CALENDAR_FAILURE: {
        name: 'custom-calendar-create-new-calendar-failure',
        tags: [],
    },
    BUSINESS_DATA_MODEL_CLICKED_V2: {
        name: 'business-data-model-clicked-v2',
        tags: [],
    },
    DATAFLOW_CLICKED_V2: {
        name: 'dataflow-clicked-v2',
        tags: [],
    },
    AUTO_SELECT_DATASOURCE_SUCCESS: {
        name: 'auto-select-datasource-success',
        tags: [],
    },
    SEARCH_CACHE_VIEW_DETAIL: {
        name: 'view-cache-detail',
        tags: [],
    },
    SEARCH_CACHE_MANUAL_REFRESH: {
        name: 'view-cache-manual-refresh',
        tags: [],
    },
    SEARCH_CACHE_STATUS_REFRESH: {
        name: 'view-cache-refresh-status',
        tags: [],
    },
    SEARCH_CACHE_VIEW_HISTORY: {
        name: 'view-cache-history',
        tags: [],
    },
    SEARCH_CACHE_SAVE: {
        name: 'view-cache-save',
        tags: [],
    },
    SPOTAPPS_CLICKED: {
        name: 'spotapps-visit-homepage',
        tags: [],
    },
    SPOTAPPS_ANALYTICS_BLOCK_PAGE: {
        name: 'spotapps-analytic-block-page',
        tags: [],
    },
    SPOTAPPS_SCHEMA_PAGE: {
        name: 'spotapps-schema-page',
        tags: [],
    },
    SPOTAPPS_APP_INFO_PAGE: {
        name: 'spotapps-app-info-page',
        tags: [],
    },
    SPOTAPPS_CONNECTOR_BLOCK_PAGE: {
        name: 'spotapps-connector-block-page',
        tags: [],
    },
    SPOTAPPS_CONFIGURE_CLICKED: {
        name: 'spotapps-configure-clicked',
        tags: [],
    },
    SPOTAPPS_CONNECTION_TYPE: {
        name: 'spotapps-connection-type',
        tags: [],
    },
    SPOTAPPS_CONNECTION_CREATED: {
        name: 'spotapps-connection-created',
        tags: [],
    },
    SPOTAPPS_MAPPED_TABLES: {
        name: 'spotapps-mapped-tables',
        tags: [],
    },
    SPOTAPPS_MAPPED_COLUMNS: {
        name: 'spotapps-mapped-columns',
        tags: [],
    },
    SPOTAPPS_CONFIGURED: {
        name: 'spotapps-configured',
        tags: [],
    },
    SPOTAPPS_RESET_CLICKED: {
        name: 'spotapps-reset-clicked',
        tags: [],
    },
    SPOTAPPS_DOWNLOAD_APP_CLICKED: {
        name: 'spotapps-download-app-clicked',
        tags: [],
    },
    SPOTAPPS_DOWNLOAD_CSV_CLICKED: {
        name: 'spotapps-download-csv-clicked',
        tags: [],
    },
    SPOTAPPS_SUBMIT_BUTTON_CLICKED: {
        name: 'spotapps-submit-button-clicked',
        tags: [],
    },
    SPOTAPPS_SUBMISSION_IMAGE_UPLOAD_ERROR: {
        name: 'spotapps-submission-image-upload-error',
        tags: [],
    },
    SPOTAPPS_SUBMISSION_NEW_APP_DETAILS: {
        name: 'spotapps-submission-new-app-details',
        tags: [],
    },
    SPOTAPPS_SUBMISSION_DOWNLOAD_ERROR_LOG: {
        name: 'spotapps-submission-download-error-log',
        tags: [],
    },
    SPOTAPPS_SUBMISSION_VIEW_ERROR_BUTTON_CLICKED: {
        name: 'spotapps-submission-view-error-button-clicked',
        tags: [],
    },
    SPOTAPPS_SUBMISSION_ZIP_VALIDATION_SUCCESSFUL: {
        name: 'spotapps-submission-zip-validation-successful',
        tags: [],
    },
    SPOTAPPS_SUBMISSION_SELECT_TABLES: {
        name: 'spotapps-submission-select-tables',
        tags: [],
    },
    SPOTAPPS_SUBMISSION_SUCCESS: {
        name: 'spotapps-submission-success',
        tags: [],
    },
    SPOTAPPS_SUBMISSION_EXIT_BUTTON_CLICKED: {
        name: 'spotapps-submission-exit-button-clicked',
        tags: [],
    },
    SPOTAPPS_ADMIN_CLICKED: {
        name: 'spotapps-admin-visit-homepage',
        tags: [],
    },
    SPOTAPPS_ADMIN_INSTALL_CLICKED: {
        name: 'spotapps-admin-install-clicked',
        tags: [],
    },
    SPOTAPPS_ADMIN_REJECT_CLICKED: {
        name: 'spotapps-admin-reject-clicked',
        tags: [],
    },
    SPOTAPPS_ADMIN_APPROVE_CLICKED: {
        name: 'spotapps-admin-approve-clicked',
        tags: [],
    },
    SPOTAPPS_ADMIN_DELETE_CLICKED: {
        name: 'spotapps-admin-delete-clicked',
        tags: [],
    },
    SPOTAPPS_ADMIN_REJECT_CONFIRMED: {
        name: 'spotapps-admin-reject-confirmed',
        tags: [],
    },
    SPOTAPPS_ADMIN_REJECT_CANCELLED: {
        name: 'spotapps-admin-reject-cancelled',
        tags: [],
    },
    SPOTAPPS_ADMIN_APPROVE_CONFIRMED: {
        name: 'spotapps-admin-approve-confirmed',
        tags: [],
    },
    SPOTAPPS_ADMIN_APPROVE_CANCELLED: {
        name: 'spotapps-admin-approve-cancelled',
        tags: [],
    },
    SPOTAPPS_ADMIN_DELETE_CONFIRMED: {
        name: 'spotapps-admin-delete-confirmed',
        tags: [],
    },
    SPOTAPPS_ADMIN_DELETE_CANCELLED: {
        name: 'spotapps-admin-delete-cancelled',
        tags: [],
    },
    CONNECT_TO_SLACK: {
        name: 'connect-to-slack',
        tags: [],
    },
    SLACK_CONNECTED: {
        name: 'slack-connected',
        tags: [],
    },
    SLACK_DISCONNECTED: {
        name: 'slack-disconnected',
        tags: [],
    },
    CONNECT_TO_MSTEAMS: {
        name: 'connect-to-msteams',
        tags: [],
    },
    MSTEAMS_CONNECTED: {
        name: 'msteams-connected',
        tags: [],
    },
    MSTEAMS_DISCONNECTED: {
        name: 'msteams-disconnected',
        tags: [],
    },
    CSV_UPLOAD_FALCON_WORKFLOW_STARTED: {
        name: 'csv-upload-falcon-workflow-started',
        tags: [],
    },
    CSV_UPLOAD_EMBRACE_WORKFLOW_STARTED: {
        name: 'csv-upload-embrace-workflow-started',
        tags: [],
    },
    CSV_UPLOAD_EMBRACE_CLICKED: {
        name: 'csv-upload-embrace-clicked',
        tags: [],
    },
    CSV_UPLOAD_FALCON_CLICKED: {
        name: 'csv-upload-falcon-clicked',
        tags: [],
    },
    CSV_UPLOAD_EMBRACE_CONFIGURED_FROM_ADMIN_PORTAL: {
        name: 'csv-upload-embrace-configured-from-admin-portal',
        tags: [],
    },
    CSV_UPLOAD_SUCCESSFUL: {
        name: 'csv-upload-successful',
        tags: ['embrace', 'import'],
    },
    CSV_UPLOAD_FAILED: {
        name: 'csv-upload-failed',
        tags: ['embrace', 'import'],
    },
    CSV_UPLOAD_NEXT_BUTTON_CLICKED: {
        name: 'csv-upload-next-button-clicked',
        tags: ['embrace', 'import'],
    },
    CSV_UPLOAD_BACK_BUTTON_CLICKED: {
        name: 'csv-upload-back-button-clicked',
        tags: ['embrace', 'import'],
    },
    CSV_UPLOAD_CACHE_CLEARED: {
        name: 'csv-upload-cache-cleared',
        tags: ['embrace', 'import', 'navigation-away'],
    },
    CSV_UPLOAD_LOADDATA_FAILED: {
        name: 'csv-upload-loaddata-failed',
        tags: ['embrace', 'loaddata'],
    },
    CSV_UPLOAD_FILE_UPLOAD_FAILED: {
        name: 'csv-upload-file-upload-failed',
        tags: ['embrace', 'import'],
    },
    CSV_UPLOAD_MAX_FILE_SIZE_EXCEEDED: {
        name: 'csv-upload-max-file-size-exceeded',
        tags: ['embrace', 'import'],
    },
    CONFIGURE_DATA_UPLOAD_START: {
        name: 'configure-data-upload-start',
        tags: [],
    },
    FETCH_DATA_UPLOAD_DETAILS_FAILURE: {
        name: 'fetch-data-upload-details-failure',
        tags: [],
    },
    CONFIGURE_DATA_UPLOAD_SUCCESS: {
        name: 'configure-data-upload-success',
        tags: [],
    },
    CONFIGURE_DATA_UPLOAD_FAILURE: {
        name: 'configure-data-upload-failure',
        tags: [],
    },
    DEFAULT_CONNECTION_CONFIGURED_FOR_CSV_UPLOAD: {
        name: 'default-connection-configured-for-csv-upload',
        tags: [],
    },
    CSV_UPLOAD_LIMIT_REACHED: {
        name: 'csv-upload-limit-reached',
        tags: [],
    },
    CLUSTER_EXPERIENCE_SWITCH: {
        name: 'cluster-experience-switch',
        tags: [],
    },
    EARLY_ACCESS_FEATURE_UPDATE: {
        name: 'early-access-feature-update',
        tags: [],
    },
    DATA_MODELLING_FEATURE_UPDATE: {
        name: 'data-modelling-feature-update',
        tags: [],
    },
    DATA_MODELLING_FEATURE_FLAG: {
        name: 'data-modeling-feature-flag',
        tags: [],
    },
    SET_LEGAL_DISCLAIMER_FOOTER_TEXT: {
        name: 'set-legal-disclaimer-footer-text',
        tags: [],
    },
    NEW_INTENT_SCREEN: {
        name: 'new-intent-screen-loaded',
        tags: ['onboarding'],
    },
    NEW_INTENT_SELECTION: {
        name: 'new-intent-selection',
        tags: ['onboarding'],
    },
    LOAD_DEMO_SCREEN: { name: 'load-demo-screen', tags: ['onboarding'] },
    DEMO_USER_CLICK: { name: 'load-demo-screen', tags: ['onboarding'] },
    DEMO_LIVEBOARD_TAB_CLICK: {
        name: 'demo-liveboard-tab-click',
        tags: ['onboarding', 'demo'],
    },
    DEMO_SEARCH_TAB_CLICK: {
        name: 'demo-search-tab-click',
        tags: ['onboarding', 'demo'],
    },
    CUSTOM_TILE_DRAG_N_DROP: {
        name: 'custom-size-selected',
        tags: [],
    },
    CREATED_TAB: {
        name: 'created-tab',
        tags: ['pinboard', 'tabs'],
    },
    REMOVED_TAB: {
        name: 'removed-tab',
        tags: ['pinboard', 'tabs'],
    },
    RENAMED_TAB: {
        name: 'renamed-tab',
        tags: ['pinboard', 'tabs'],
    },
    DELETED_TAB: {
        name: 'deleted-tab',
        tags: ['pinboard', 'tabs'],
    },
    MOVE_VIZ: {
        name: 'move-viz',
        tags: ['pinboard', 'tabs'],
    },
    MOVED_VIZ: {
        name: 'moved-viz',
        tags: ['pinboard', 'tabs'],
    },
    LOAD_TAB: {
        name: 'load-tab',
        tags: ['pinboard', 'tabs'],
    },
    SWITCH_ORG: { name: 'switch-org-clicked', tags: [] },
    SWITCH_ORG_FAILURE: { name: 'switch-org-failure', tags: [] },
    ORG_TAB: { name: 'org-tab-clicked', tags: [] },
    ORG_ADD: { name: 'add-org-clicked', tags: [] },
    ORG_ADD_SUCCESS: { name: 'add-org-success', tags: [] },
    ORG_ADD_FAILURE: { name: 'add-org-failure', tags: [] },
    ORG_UPDATE: { name: 'update-org-clicked', tags: [] },
    ORG_UPDATE_SUCCESS: { name: 'update-org-success', tags: [] },
    ORG_UPDATE_FAILURE: { name: 'update-org-failure', tags: [] },
    ORG_DELETE: { name: 'delete-org-clicked', tags: [] },
    ORG_DELETE_SUCCESS: { name: 'delete-org-success', tags: [] },
    ORG_DELETE_FAILURE: { name: 'delete-org-failure', tags: [] },
    ADD_USERS_TO_ORG: { name: 'add-users-to-org-clicked', tags: [] },
    CONFIGURE_SAML_IAM_V1: { name: 'configure-saml', tags: [] },
    REMOVE_SAML_IAM_V1: { name: 'remove-saml', tags: [] },
    CONFIGURE_LDAP_AD_IAM_V1: { name: 'configure-activedirectory', tags: [] },
    REMOVE_LDAP_AD_IAM_V1: { name: 'remove-activedirectory', tags: [] },
    CONFIGURE_INTERNAL_AUTH_IAM_V1: {
        name: 'configure-internalauth',
        tags: [],
    },
    ADD_MAP: { name: 'add-map', tags: ['admin', 'custom-map'] },
    EDIT_MAP: { name: 'edit-map', tags: ['admin', 'custom-map'] },
    DELETE_MAP: { name: 'delete-map', tags: ['admin', 'custom-map'] },
    ADD_CUSTOM_CHART: {
        name: 'add-custom-chart',
        tags: ['admin', 'custom-chart'],
    },
    DELETE_CUSTOM_CHART: {
        name: 'delete-custom-chart',
        tags: ['admin', 'custom-chart'],
    },
    UPDATE_CUSTOM_CHART: {
        name: 'update-custom-chart',
        tags: ['admin', 'custom-chart'],
    },
    CANCEL_DELETE_MAP: {
        name: 'cancel-delete-map',
        tags: ['admin', 'custom-map'],
    },
    MAP_ADDED_OR_EDITED: {
        name: 'map-added-or-edited',
        tags: ['admin', 'custom-map'],
    },
    ADDED_NEW_MAP: {
        name: 'added-new-map',
        tags: ['admin', 'custom-map'],
    },
    EDITED_EXISTING_MAP: {
        name: 'edited-existing-map',
        tags: ['admin', 'custom-map'],
    },
    MAP_DELETED: {
        name: 'map-deleted',
        tags: ['admin', 'custom-map'],
    },
    CLICK_CUSTOM_MAP_DEP_VIEW_ALL_WHILE_EDIT: {
        name: 'click-on-view-all-link-when-editing',
        tags: ['admin', 'custom-map'],
    },
    WORKSHEET_GEO_CONFIG: {
        name: 'worksheet-geo-config',
        tags: ['data', 'geo-config'],
    },
    ADMIN_GEO_MAPS: {
        name: 'admin-geo-maps',
        tags: ['admin', 'chart-customization', 'custom-maps'],
    },
    ADMIN_CUSTOM_CHARTS: {
        name: 'admin-custom-charts',
        tags: ['admin', 'chart-customization', 'custom-charts'],
    },
    DATA_SOURCE_OVERVIEW_CARD_DISPLAYED: {
        name: 'data-source-overviewcard-displayed',
        tags: [],
    },
    COLUMN_OVERVIEW_CARD_DISPLAYED: {
        name: 'column-overviewcard-displayed',
        tags: [],
    },
    VIEWED_TOP_LIVEBOARDS: {
        name: 'viewed-top-liveboards',
        tags: [],
    },
    VIEWED_TOP_ANSWERS: {
        name: 'viewed-top-answers',
        tags: [],
    },
    CHART_CONFIG_MODAL: {
        name: 'chart-config-modal',
        tags: ['chart', 'chart-config'],
    },
    APPLY_CONFIG_CHANGE: {
        name: 'apply-config-change',
        tags: ['chart', 'chart-config'],
    },
    RESET_CONFIG_CHANGE: {
        name: 'reset-config-change',
        tags: ['chart', 'chart-config'],
    },
    APPLY_CONFIG_THROUGH_MODAL: {
        name: 'apply-config-through-modal',
        tags: ['chart', 'chart-config'],
    },
    RESET_CONFIG_THROUGH_MODAL: {
        name: 'reset-config-through-modal',
        tags: ['chart', 'chart-config'],
    },
    CANCEL_ACTION_MODAL: {
        name: 'cancel-action-modal',
        tags: ['chart', 'chart-config'],
    },
    TEAM_DATA_USAGE_CLICK: {
        name: 'team-data-usage-click',
        tags: ['TEAM_EDITION'],
    },
    TEAM_DATA_USAGE_PAGE: {
        name: 'team-data-usage-page',
        tags: ['TEAM_EDITION'],
    },
    TEAM_DATA_USAGE_UPGRADE: {
        name: 'team-data-usage-upgrade',
        tags: ['TEAM_EDITION'],
    },
    TEAM_USAGE_BANNER_SEEN: {
        name: 'team-usage-banner-seen',
        tags: ['TEAM_EDITION'],
    },
    TEAM_USER_AND_ROW_USAGE_BANNER_SEEN: {
        name: 'user-and-row-limit-banner-seen',
        tags: ['TEAM_EDITION'],
    },
    TEAM_USER_USAGE_BANNER_SEEN: {
        name: 'user-limit-banner-seen',
        tags: ['TEAM_EDITION'],
    },
    TEAM_USAGE_BANNER_REDUCE: {
        name: 'team-usage-banner-reduce',
        tags: ['TEAM_EDITION'],
    },
    TEAM_USAGE_BANNER_UPGRADE: {
        name: 'team-usage-banner-upgrade',
        tags: ['TEAM_EDITION'],
    },
    TEAM_USER_LIMIT_BANNER_UPGRADE: {
        name: 'User Limit - contact support clicked”',
        tags: ['TEAM_EDITION'],
    },
    TEAM_USER_AND_DATA_LIMIT_BANNER_UPGRADE: {
        name: 'User and row limit - contact support clicked”',
        tags: ['TEAM_EDITION'],
    },
    TEAM_PRICING_PAGE: {
        name: 'team-pricing-page',
        tags: ['TEAM_EDITION'],
        shouldSendEventToExperimentationService: true,
        experimentationProject: ExperimentationProject.GROWTH,
    },
    PROMOTE_SHARE_BUTTON: {
        name: 'promote-share-button',
        tags: ['pinboard', 'PROMOTE_SHARE_BUTTON'],
        shouldSendEventToExperimentationService: true,
        experimentationProject: ExperimentationProject.GROWTH,
    },
    LIVEBOARD_V2_GUIDE_CLICK: {
        name: 'liveboard-v2-guide-click',
        tags: ['pinboard'],
        shouldSendEventToExperimentationService: true,
        experimentationProject: ExperimentationProject.GROWTH,
    },
    GUIDE_CLOSE_CLICKED: {
        name: 'guide-close-clicked',
        tags: ['experiment', 'pinboard'],
    },
    GUIDE_NEXT_CLICKED: {
        name: 'guide-next-clicked',
        tags: ['experiment', 'pinboard'],
    },
    GUIDE_BACK_CLICKED: {
        name: 'guide-back-clicked',
        tags: ['experiment', 'pinboard'],
    },
    GUIDE_GOTIT_CLICKED: {
        name: 'guide-gotit-clicked',
        tags: ['experiment', 'pinboard'],
    },
    GUIDE_LEARN_MORE_CLICKED: {
        name: 'guide-learn-more-clicked',
        tags: ['experiment', 'pinboard'],
    },
    TRACK_EDIT_BUTTON: {
        name: 'track-edit-button',
        tags: ['pinboard', 'PROMOTE_SHARE_BUTTON'],
        shouldSendEventToExperimentationService: true,
        experimentationProject: ExperimentationProject.GROWTH,
    },
    DISCOUNT_EXPERIMENTATION: {
        name: 'tracking-discount-events',
        tags: ['free-trial'],
    },
    HOME_LEFTNAVBAR_CREATE_NEW: {
        name: 'home-leftnav-create-new-click',
        tags: ['home-leftNavbar'],
    },
    HOME_LEFTNAVBAR_CREATE_NEW_ANSWER: {
        name: 'home-leftnav-create-new-answer-click',
        tags: ['home-leftNavbar'],
    },
    HOME_LEFTNAVBAR_CREATE_NEW_LIVEBOARD: {
        name: 'home-leftnav-create-new-liveboard-click',
        tags: ['home-leftNavbar'],
    },
    HOME_LEFTNAVBAR_CLICK: {
        name: 'left-nav-home-click',
        tags: ['home-leftNavbar'],
    },
    HOME_LEFTNAVBAR_FAVORITES: {
        name: 'home-leftnav-favorites-click',
        tags: ['home-leftNavbar'],
    },
    HOME_LEFTNAVBAR_CREATE_BY_ME: {
        name: 'home-leftnav-created-by-me-click',
        tags: ['home-leftNavbar'],
    },
    HOME_LEFTNAVBAR_SPOTIQ: {
        name: 'left-nav-spotiq-click',
        tags: ['home-leftNavbar'],
    },
    HOME_LEFTNAVBAR_MONITOR: {
        name: 'left-nav-monitor-click',
        tags: ['home-leftNavbar'],
    },
    HOME_LEFTNAVBAR_TUTORIALS: {
        name: 'left-nav-tutorials-click',
        tags: ['home-leftNavbar'],
    },
    HOME_LEFTNAVBAR_DOCUMENTATION: {
        name: 'left-nav-documentation-click',
        tags: ['home-leftNavbar'],
    },
    HOME_LEFTNAVBAR_COMMUNITY: {
        name: 'left-nav-community-click',
        tags: ['home-leftNavbar'],
    },
    HOME_LEFTNAVBAR_LIVEBOARD: {
        name: 'left-nav-liveboard-click',
    },
    HOME_LEFTNAVBAR_ANSWER: {
        name: 'left-nav-answer-click',
    },
    HOME_LEFTNAVBAR_MY_LIBRARY: {
        name: 'left-nav-my-library-click',
    },
    HOME_LEFT_NAV_OPEN_QUERY_BUILDER_CLICK: {
        name: 'left-nav-open-query-builder-click',
    },
    HOME_LEARNING_PLAY_VIDEO: {
        name: 'home-learning-play-video',
        tags: ['home-video'],
    },
    HOME_LEARNING_PAUSE_VIDEO: {
        name: 'home-learning-pause-video',
        tags: ['home-video'],
    },
    HOME_FILTER_MODAL_OPEN: {
        name: 'home-filter-modal-open',
        tags: ['home-filter'],
    },
    HOME_FILTER_APPLY: {
        name: 'home-filter-apply',
        tags: ['home-filter'],
    },
    HOME_OBJECT_TABLE_SHARE_CLICK: {
        name: 'home-object-table-share-click',
        tags: ['home-object-table'],
    },
    HOME_OBJECT_TABLE_LIVEBOARD_LIST_CLICK: {
        name: 'home-object-table-liveboard-list-click',
        tags: ['home-object-table'],
    },
    HOME_OBJECT_TABLE_ANSWER_LIST_CLICK: {
        name: 'home-object-table-answer-list-click',
        tags: ['home-object-table'],
    },
    NAVIGATION_QUICK_LINK_CLICKED: {
        name: 'navigation-quick-link-clicked',
        tags: ['navigation', 'quick-link'],
    },
    NAVIGATION_TAB_CHANGED: {
        name: 'navigation-tab-changed',
        tags: ['navigation', 'tab'],
    },
    LANDED_EMPTY_SEARCH_PAGE: {
        name: 'landed-empty-search-page',
        tags: ['search'],
    },
    SEED_QUESTIONS_LOADED: {
        name: 'seed-questions-loaded',
        tags: ['search', 'seed-question'],
    },
    SEED_QUESTION_TRY_SEARCH_CLICKED: {
        name: 'seed-questions-try-search-clicked',
        tags: ['search', 'seed-question'],
    },
    SEED_QUESTION_ANSWR_LOADED: {
        name: 'seed-question-answer-loaded',
        tags: ['search', 'seed-question'],
    },
    SEED_QUESTION_CLEARED: {
        name: 'seed-question-cleared',
        tags: ['search', 'seed-question'],
    },
    SEED_QUESTION_FEEDBACK_INITIATED: {
        name: 'seed-question-feedback-initiated',
        tags: ['search', 'seed-question'],
    },
    SEED_QUESTION_FEEDBACK_SUBMITTED: {
        name: 'seed-question-feedback-submitted',
        tags: ['search', 'seed-question'],
    },
    HIGHLIGHTS_GENERATED: {
        name: 'highlights-generated',
        tags: ['liveboard-highlights', 'ai'],
    },
    HIGHLIGHTS_LOADED: {
        name: 'highlights-loaded',
        tags: ['liveboard-highlights', 'ai'],
    },
    HIGHLIGHTS_VIEWED: {
        name: 'highlights-viewed',
        tags: ['liveboard-highlights', 'ai'],
    },
    HIGHLIGHTS_DEEPDIVE: {
        name: 'highlights-deepdive',
        tags: ['liveboard-highlights', 'ai'],
    },
    HIGHLIGHTS_FEEDBACK: {
        name: 'highlights-feedback',
        tags: ['liveboard-highlights', 'ai'],
    },
    CUSTOMIZE_ATTRIBUTE_CLICK: {
        name: 'customize-attribute-click',
        tags: [],
    },
    CUSTOMIZE_ATTRIBUTE_APPLY: {
        name: 'customize-attribute-apply',
        tags: [],
    },
    CONTEXT_CHANGE_RESULTS_LOADED: {
        name: 'context-change-results-loaded',
        tags: [],
    },
    CUSTOMIZE_ATTRIBUTE_APPLY_FOR_ALL: {
        name: 'customise-attribute-apply-for-all',
        tags: [],
    },
    CUSTOMIZE_ATTRIBUTE_RESET: {
        name: 'customise-attribute-reset',
        tags: [],
    },
    APPLY_DATE_FILTER: {
        name: 'apply-date-filter',
        tags: [],
    },
    ADD_CROSS_FILTER: {
        name: 'add-cross-filter',
        tags: [],
    },
    REMOVE_CROSS_FILTER: {
        name: 'remove-cross-filter',
        tags: [],
    },
    CLEAR_CROSS_FILTER: {
        name: 'clear-cross-filter',
        tags: [],
    },
    ADD_IMAGE_TO_NOTE: {
        name: 'add-image-to-note',
        tags: [],
    },
    ADD_IFRAME_TO_NOTE: {
        name: 'add-iframe-to-note',
        tags: [],
    },
    CREATE_NOTE: {
        name: 'create-note',
        tags: [],
    },
    DELETE_NOTE: {
        name: 'delete-note',
        tags: [],
    },
    ITERATIVE_CCA_ATTRIBUTE_CLICK: {
        name: 'analyse-attribute-click',
        tags: ['iterative-cca'],
    },
    ITERATIVE_CCA_FILTER_REMOVED: {
        name: 'iterative-cca-filter-removed',
        tags: ['iterative-cca'],
    },
    CHANGE_ANALYSIS_REDO: {
        name: 'change-analysis-redo',
        tags: ['change-analysis-redo'],
    },
    CHANGE_ANALYSIS_RESET: {
        name: 'change-analysis-reset',
        tags: ['change-analysis-reset'],
    },
    CONTEXTUAL_MENU: {
        name: 'contextual-menu',
        tags: [],
    },
    CCA_SUMMARY_VIEW_DETAILS: {
        name: 'view-details-click',
        tags: ['change-analysis-summary-tab'],
    },
    HOME_VIDEO_TOGGLE: {
        name: 'home-video-toggle',
    },
    HOME_LEARNING_SELECT_VIDEO: {
        name: 'home-learning-select-video',
    },
    LOAD_CHOOSE_SOURCE_PAGE_V2: {
        name: 'load-choose-source-page-v2',
        tags: [],
    },
    ADD_SEARCH_DATA_SOURCE_V2: {
        name: 'add-search-data-source-v2',
        tags: [],
    },
    USER_SELECTED_A_SOURCE_V2: {
        name: 'user-selected-a-source-v2',
        tags: [],
    },
    USER_UNSELECTED_A_SOURCE_V2: {
        name: 'user-unselected-a-source-v2',
        tags: [],
    },
    DATA_GOVERNANCE_CLICKED: {
        name: 'data-governance-visit-page',
        tags: [],
    },
    CATALOG_CONNECT_CLICKED: {
        name: 'catalog-connect-clicked',
        tags: [],
    },
    CATALOG_CREDS_NEXT_CLICKED: {
        name: 'catalog-creds-next-clicked',
        tags: [],
    },
    CATALOG_SCHEDULE_NEXT_CLICKED: {
        name: 'catalog-schedule-next-clicked',
        tags: [],
    },
    CATALOG_SAVE_AND_SYNC_CLICKED: {
        name: 'catalog-save-and-sync-clicked',
        tags: [],
    },
    CATALOG_SAVE_NOW_CLICKED: {
        name: 'catalog-sync-now-clicked',
        tags: [],
    },
    CATALOG_EDIT_SYNC_SCHEDULE_CLICKED: {
        name: 'catalog-edit-sync-schedule-clicked',
        tags: [],
    },
    CATALOG_EDIT_METADATA_CLICKED: {
        name: 'catalog-edit-metadata-clicked',
        tags: [],
    },
    CATALOG_DISCONNECT_CLICKED: {
        name: 'catalog-disconnect-clicked',
        tags: [],
    },
    CATALOG_MANAGE_DATA_SOURCES_CLICKED: {
        name: 'catalog-manage-data-sources-clicked',
        tags: [],
    },
    CATALOG_MANAGE_COLUMNS_CLICKED: {
        name: 'catalog-Manage-columns-clicked',
        tags: [],
    },
    CATALOG_COLUMNS_OR_SOURCES_UPDATE_CLICKED: {
        name: 'catalog-metadata-update-clicked',
        tags: [],
    },
    LB_VERIFIED: {
        name: 'liveboard-verify-cta-clicked',
        tags: ['verification'],
    },
    VERIFIED_LB_VIEW: {
        name: 'verified-liveboard-view',
        tags: ['verification'],
    },
    NON_VERIFIED_LB_VIEW: {
        name: 'non-verified-liveboard-view',
        tags: ['verification'],
    },
    LB_REQUEST_VERIFICATION: {
        name: 'liveboard-request-verification',
        tags: ['verification'],
    },
    LB_REJECT_VERIFICATION: {
        name: 'liveboard-reject-verification',
        tags: ['verification'],
    },
    VERIFIED_LB_EDIT: {
        name: 'verified-liveboard-edit',
        tags: ['verification'],
    },
    WITHDRAW_LB_VERIFICATION: {
        name: 'withdraw-liveboard-verification',
        tags: ['verification'],
    },
    COMS_IN_APP_NOTIFICATION_SHOWN: {
        name: 'coms_in_app_notification_shown',
        tags: ['coms', 'in-app notifications'],
    },
    COMS_IN_APP_USER_PROFILE_CLICKED: {
        name: 'coms_in_app_user_profile_clicked',
        tags: ['coms', 'in-app notifications'],
    },
    COMS_IN_APP_NOTIFICATION_BATCH_LOADED: {
        name: 'coms_in_app_notification_batch_loaded',
        tags: ['coms', 'in-app notifications'],
    },
    COMS_IN_APP_NOTIFICATION_CTA_CLICKED: {
        name: 'coms_in_app_notification_cta_clicked',
        tags: ['coms', 'in-app notifications'],
    },
    WEBHOOK_PAGE_VIEW: {
        name: 'webhook-page-view',
        tags: [],
    },
    WEBHOOK_UPDATE: {
        name: 'webhook-updated',
        tags: [],
    },
    WEBHOOK_DELETE: {
        name: 'webhook-deleted',
        tags: [],
    },
    WEBHOOK_CREATE: {
        name: 'webhook-created',
        tags: [],
    },
    WORKSHEET_GENERATE_AI_SYNONYMS: {
        name: 'worksheet-generate-ai-synonyms',
        tags: ['worksheet', 'ai', 'synonyms'],
    },
    WORKSHEET_DELETE_AI_SYNONYMS: {
        name: 'worksheet-delete-ai-synonyms',
        tags: ['worksheet', 'ai', 'synonyms'],
    },
    WORKSHEET_EDIT_AI_SYNONYM_MANUAL: {
        name: 'worksheet-edit-ai-synonym-manual',
        tags: ['worksheet', 'delete', 'ai', 'synonym', 'manual'],
    },
    WORKSHEET_DELETE_AI_SYNONYM_MANUAL: {
        name: 'worksheet-delete-ai-synonym-manual',
        tags: ['worksheet', 'edit', 'ai', 'synonym', 'manual'],
    },
    WORKSHEET_ADD_SYNONYM_MANUAL: {
        name: 'worksheet-add-synonym-manual',
        tags: ['worksheet', 'add', 'synonym', 'manual'],
    },
    TOGGLE_LIVEBOARD_EDIT_CLICK: {
        name: 'toggle-liveboard-edit-clicked',
        tags: ['pinboard'],
    },
    TOGGLE_LIVEBOARD_EDIT_CANCELLED: {
        name: 'toggle-liveboard-edit-cancelled',
        tags: ['pinboard'],
    },
    TOGGLE_LIVEBOARD_EDIT_SAVE: {
        name: 'toggle-liveboard-edit-save',
        tags: ['pinboard'],
    },
    LOAD_TOP_NAV: {
        name: 'load-top-nav',
        tags: [],
    },
    TOP_NAV_LOGO_CLICK: {
        name: 'top-nav-logo-click',
        tags: [],
    },
    TOP_NAV_INFO_CENTER_CLICK: {
        name: 'top-nav-inf-center-click',
        tags: [],
    },
    TOP_NAV_APPLICATION_SWITCHER: {
        name: 'top-nav-application-switched',
        tags: [],
    },
    ERROR_DETAILS_OPEN: {
        name: 'error-details-open',
        tags: [],
    },
    ERROR_DETAILS_REPORT_EVENT: {
        name: 'error-details-report-event',
        tags: [],
    },
    ERROR_DETAILS_COPY: {
        name: 'error-details-copy',
        tags: [],
    },
    ERROR_DETAILS_CANCEL: {
        name: 'error-details-cancel',
        tags: [],
    },
    SPOTTER_INTRODUCTION_VIEW: {
        name: 'spotter-introduction-view',
        tags: ['ask-sage', 'spotter', 'conv-assist'],
    },
    SPOTTER_INITIATED: {
        name: 'spotter-initiated',
        tags: ['ask-sage', 'spotter', 'conv-assist'],
    },
    SPOTTER_LOADED: {
        name: 'spotter-loaded',
        tags: ['ask-sage', 'spotter', 'conv-assist'],
    },
    SPOTTER_USER_MSG_RECEIVED: {
        name: 'spotter-user-msg-received',
        tags: ['ask-sage', 'spotter', 'conv-assist'],
    },
    SPOTTER_AI_ANSWER_LOADED: {
        name: 'spotter-ai-answer-loaded',
        tags: ['ask-sage', 'spotter', 'conv-assist'],
    },
    SPOTTER_AI_ANSWER_THUMBS_UP: {
        name: 'spotter-ai-answer-thumbs-up',
        tags: ['ask-sage', 'spotter', 'conv-assist'],
    },
    SPOTTER_AI_ANSWER_THUMBS_DOWN: {
        name: 'spotter-ai-answer-thumbs-down',
        tags: ['ask-sage', 'spotter', 'conv-assist'],
    },
    SPOTTER_USER_MSG_UPDATE: {
        name: 'spotter-user-msg-update',
        tags: ['ask-sage', 'spotter', 'conv-assist'],
    },
    SPOTTER_USER_MSG_DELETE: {
        name: 'spotter-user-msg-delete',
        tags: ['ask-sage', 'spotter', 'conv-assist'],
    },
    SPOTTER_AI_ANSWER_SHOW_QUERY: {
        name: 'spotter-ai-answer-show-query',
        tags: ['ask-sage', 'spotter', 'conv-assist'],
    },
    SPOTTER_AI_TABLE_CHART_SWITCH: {
        name: 'spotter-ai-table-chart-switch',
        tags: ['ask-sage', 'spotter', 'conv-assist'],
    },
    SPOTTER_AI_ANSWER_FAILED: {
        name: 'spotter-ai-answer-failed',
        tags: ['ask-sage', 'spotter', 'conv-assist'],
    },
    SPOTTER_CLICKED: {
        name: 'spotter-clicked',
        tags: ['ask-sage', 'spotter', 'conv-assist'],
    },
    SPOTTER_AI_ANSWER_EDIT_INITIATED: {
        name: 'spotter-ai-answer-edit-initiated',
        tags: ['ask-sage', 'spotter', 'conv-assist'],
    },
    SPOTTER_AI_ANSWER_EDIT_DONE_EDITING: {
        name: 'spotter-ai-answer-edit-done-editing',
        tags: ['ask-sage', 'spotter', 'conv-assist'],
    },
    SPOTTER_AI_ANSWER_EDIT_DISCARD_CHANGES: {
        name: 'spotter-ai-answer-edit-discard-changes',
        tags: ['ask-sage', 'spotter', 'conv-assist'],
    },
    SPOTTER_PIN_BUTTON: {
        name: 'spotter-pin-button',
        tags: ['ask-sage', 'spotter', 'conv-assist'],
    },
    SPOTTER_SAVE_BUTTON: {
        name: 'spotter-save-button',
        tags: ['ask-sage', 'spotter', 'conv-assist'],
    },
    SPOTTER_DOWNLOAD_BUTTON: {
        name: 'spotter-download-button',
        tags: ['ask-sage', 'spotter', 'conv-assist'],
    },
    SPOTTER_VIEW_KNOWN_LIMITATON: {
        name: 'spotter-view-known-limitation',
        tags: ['ask-sage', 'spotter', 'conv-assist'],
    },
    SPOTTER_CLOSE_KNOWN_LIMITATON: {
        name: 'spotter-close-known-limitation',
        tags: ['ask-sage', 'spotter', 'conv-assist'],
    },
    SPOTTER_PREVIEW_DATA: {
        name: 'spotter-preview-data',
        tags: ['ask-sage', 'spotter', 'conv-assist'],
    },
    SPOTTER_RESET_CHAT_INITIATED: {
        name: 'spotter-reset-chat-initiated',
        tags: ['ask-sage', 'spotter', 'conv-assist'],
    },
    SPOTTER_RESET_CHAT_COMPLETED: {
        name: 'spotter-reset-chat-completed',
        tags: ['ask-sage', 'spotter', 'conv-assist'],
    },
    SPOTTER_NLS_ANSWER_FAILED: {
        name: 'spotter-nls-answer-failed',
        tags: ['ask-sage', 'spotter', 'conv-assist'],
    },
    SPOTTER_SHORTCUT_MENU_OPEN: {
        name: 'spotter-shortcut-menu-open',
        tags: ['ask-sage', 'spotter', 'conv-assist'],
    },
    SPOTTER_SHORTCUT_MENU_ITEM_CLICKED: {
        name: 'spotter-shortcut-menu-item-clicked',
        tags: ['ask-sage', 'spotter', 'conv-assist'],
    },
    CREATE_NEW_CTA_CLICKED: {
        name: 'create-new-cta-clicked',
        tags: [],
    },
    CLONE_MODEL: {
        name: 'model-clone',
        tags: [],
    },
    MODEL_CREATE_NEW: {
        name: 'model-create-new',
        tags: [],
    },
    CHOOSE_DM_MODEL: {
        name: 'model-choose-dm-manual',
        tags: [],
    },
    CHOOSE_DM_TML: {
        name: 'model-choose-tml',
        tags: [],
    },
    CHOOSE_DM_DBT: {
        name: 'model-choose-dbt',
        tags: [],
    },
    CHOOSE_DM_ANALYST_STUDIO: {
        name: 'model-choose-analyst-studio',
        tags: [],
    },
    CHOOSE_DM_SPOTAPPS: {
        name: 'choose-dm-spotapps',
        tags: [],
    },
    MODEL_CHOOSE_CONNECTION: {
        name: 'model-choose-connection',
        tags: [],
    },
    MODEL_CREATE_CONNECTION_START: {
        name: 'model-create-connection-start',
        tags: [],
    },
    MODEL_CREATE_CONNECTION_COMPLETE: {
        name: 'model-create-connection-complete',
        tags: [],
    },
    MODEL_LOAD_TABLES: {
        name: 'model-load-tables',
        tags: [],
    },
    MODEL_LOAD_COLUMNS: {
        name: 'model-load-columns',
        tags: [],
    },
    MODEL_COLUMN_PROPERTY_EDIT: {
        name: 'model-column-property-edit',
        tags: [],
    },
    MODEL_BULK_EDIT: {
        name: 'model-column-property-bulk-edit',
        tags: [],
    },
    MODEL_SAVE: {
        name: 'model-save',
        tags: [],
    },
    MODEL_DELETE: {
        name: 'model-delete',
        tags: [],
    },
    MODEL_EXPORT: {
        name: 'tml-export',
        tags: [],
    },
    FEEDBACK_EXPORT_STARTED: {
        name: 'feedback-export-started',
        tags: [],
    },
    FEEDBACK_EXPORT_COMPLETED: {
        name: 'feedback-export-completed',
    },
    MODEL_TML_EDIT: {
        name: 'tml-edit',
        tags: [],
    },
    TML_PUBLISH: {
        name: 'tml-publish',
        tags: [],
    },
    MODEL_TML_IMPORT: {
        name: 'tml-import',
        tags: [],
    },
    MODEL_CSV_EXPORT: {
        name: 'model-csv-export',
        tags: [],
    },
    MODEL_CSV_IMPORT_START: {
        name: 'model-csv-import-start',
        tags: [],
    },
    MODEL_CSV_IMPORT_END: {
        name: ' model-csv-import-complete',
        tags: [],
    },
    MODEL_TABLE_KNOWLEDGE_CARD_OPEN: {
        name: 'model-table-knowledge-card-open',
        tags: [],
    },
    MODEL_COLUMN_KNOWLEDGE_CARD_OPEN: {
        name: 'model-table-knowledge-card-open',
        tags: [],
    },
    MODEL_CREATE_FORMULA_START: {
        name: 'model-create-formula-start',
        tags: [],
    },
    MODEL_CREATE_FORMULA_COMPLETE: {
        name: 'model-create-formula-complete',
        tags: [],
    },
    MODEL_CREATE_FILTER_START: {
        name: 'model-create-filter-start',
        tags: [],
    },
    MODEL_CREATE_FILTER_COMPLETE: {
        name: 'model-create-filter-complete',
        tags: [],
    },
    MODEL_CREATE_PARAMETER_START: {
        name: 'model-create-parameter-start',
        tags: [],
    },
    MODEL_CREATE_PARAMETER_COMPLETE: {
        name: 'model-create-parameter-complete',
        tags: [],
    },
    MODEL_DELETE_JOIN: {
        name: 'model-delete-join',
        tags: [],
    },
    MODEL_EDIT_JOIN: {
        name: 'model-edit-join',
        tags: [],
    },
    MODEL_SAVE_JOIN: {
        name: 'model-edit-join-save',
        tags: [],
    },
    MODEL_CANCEL_EDIT_JOIN: {
        name: 'model-edit-join-cancel',
        tags: [],
    },
    MODEL_ACCEPT_REC_JOIN: {
        name: 'model-join-rec-accept',
        tags: [],
    },
    MODEL_EDIT_REC_JOIN: {
        name: 'model-join-rec-edit',
        tags: [],
    },
    MODEL_DELETE_REC_JOIN: {
        name: 'model-join-rec-delete',
        tags: [],
    },
    ACCEPT_ALL_RECOMMENDATION: {
        name: 'model-join-rec-accept-all',
        tags: [],
    },
    CLEAR_ALL_RECOMMENDATION: {
        name: 'model-join-rec-clear-all',
        tags: [],
    },
    TURN_OFF_RECOMMENDATION: {
        name: 'model-join-rec-off',
        tags: [],
    },
    TURN_ON_RECOMMENDATION: {
        name: 'model-join-rec-on',
        tags: [],
    },
    MODEL_FIND_TABLE: {
        name: 'model-schema-find',
        tags: [],
    },
    MODEL_ERROR_MESSAGE: {
        name: 'model-error-message',
        tags: [],
    },
    MODEL_TABLE_DUPLICATE: {
        name: 'model-table-duplicate',
        tags: [],
    },
    MODEL_PROGRESSIVE_JOIN_SETTING_UPDATE: {
        name: 'model-progressive-join-setting-update',
        tags: [],
    },
    MODEL_RLS_RULE_SETTING_UPDATE: {
        name: 'model-rls-rule-setting-update',
        tags: [],
    },
    MODEL_THREE_DOT_MENU: {
        name: 'model-three-dot-menu',
        tags: [],
    },
    MANAGE_TAG_CLICKED: {
        name: 'manage-tag-clicked',
        tags: [],
    },
    MANAGE_TAG_LOADED: {
        name: 'manage-tag-loaded',
        tags: [],
    },
    CREATE_NEW_TAG: {
        name: 'create-new-tag',
        tags: [],
    },
    MANAGE_TAG_EDITED: {
        name: 'manage-tag-edited',
        tags: [],
    },
    MANAGE_TAG_DELETED: {
        name: 'manage-tag-deleted',
        tags: [],
    },
    MANAGE_TAG_CLOSE_CLICKED: {
        name: 'manage-tag-close-clicked',
        tags: [],
    },
    SPOTTER_PREVIEW_DATA_CLICKED: {
        name: 'spotter-preview-data-clicked',
        tags: ['spotter'],
    },
    SPOTTER_NEW_CHAT_CLICKED: {
        name: 'spotter-new-chat-clicked',
        tags: ['spotter'],
    },
    SPOTTER_SAVE_CHAT_CLICKED: {
        name: 'spotter-save-chat-clicked',
        tags: ['spotter'],
    },
    SPOTTER_CHAT_SAVED: {
        name: 'spotter-chat-saved',
        tags: ['spotter'],
    },
    SPOTTER_VIEW_SQL_CLICKED: {
        name: 'spotter-view-SQL-clicked',
        tags: ['spotter'],
    },
    SPOTTER_SAVED_CHAT_OPENED: {
        name: 'spotter-saved-chat-opened',
        tags: ['spotter'],
    },
    SPOTTER_SAVED_CHAT_AI_USERMESSAGE_RECEIVED: {
        name: 'spotter-saved-chat-ai-userMessage-received',
        tags: ['spotter'],
    },
    SPOTTER_SAVED_CHAT_AI_ANSWER_LOADED: {
        name: 'spotter-saved-chat-ai-answer-loaded',
        tags: ['spotter'],
    },
    SPOTTER_MANAGE_DATA_CLICKED: {
        name: 'spotter-manage-data-clicked',
        tags: ['spotter'],
    },
    SPOTTER_DATA_SOURCE_CLICKED: {
        name: 'spotter-data-source-clicked',
        tags: ['spotter'],
    },
    SPOTTER_ADD_DATA_SOURCE_CLICKED: {
        name: 'spotter-add-data-source-clicked',
        tags: ['spotter'],
    },
    VERSION_CONTROL_CLICK: {
        name: 'git-version-control-click',
        tags: ['version-control', 'admin'],
    },
    VERSION_CONTROL_CONFIGURE_SUCCESS: {
        name: 'git-version-control-configure-success',
        tags: ['version-control', 'admin'],
    },
    VERSION_CONTROL_CONFIGURE_FAILS: {
        name: 'git-version-control-configure-fails',
        tags: ['version-control', 'admin'],
    },
    VERSION_CONTROL_BRANCH_SUCCESS: {
        name: 'git-version-control-branch-success',
        tags: ['version-control', 'admin'],
    },
    VERSION_CONTROL_BRANCH_FAILS: {
        name: 'git-version-control-branch-fails',
        tags: ['version-control', 'admin'],
    },
    VERSION_CONTROL_SAVE_HISTORY: {
        name: 'git-version-control-save-history',
        tags: ['version-control', 'admin'],
    },
    VERSION_CONTROL_CONFIGURE_EDIT: {
        name: 'git-version-control-configure-edit',
        tags: ['version-control', 'admin'],
    },
    VERSION_CONTROL_CONFIGURE_RESET: {
        name: 'git-version-control-configure-reset',
        tags: ['version-control', 'admin'],
    },
    OPTIMIZE_MODEL_BTN_CLICKED: {
        name: 'optimize-model-btn-clicked',
    },
    INDEXING_CHECKLIST_LOADED: {
        name: 'indexing-checklist-loaded',
    },
    INDEXING_OPTIMIZE_RESULT: {
        name: 'indexing-optimize-result',
    },
    INDEXING_CHECKLIST_CLEARALL: {
        name: 'indexing-checklist-clearAll',
    },
    INDEXING_CHECKLIST_SELECTALL: {
        name: 'indexing-checklist-selectAll',
    },
    INDEXING_OPTIMIZE_CANCELLED: {
        name: 'indexing-optimize-cancelled',
    },
    INDEXING_OPTIMIZE_BTN_CLICKED: {
        name: 'indexing-optimize-btn-clicked',
    },
    LLM_CONFIGURATION_OPEN: {
        name: 'llm-configuration-open',
        tags: ['llm'],
    },
    LLM_CONFIGURATION_SAVED: {
        name: 'llm-configuration-saved',
        tags: ['llm'],
    },
    LLM_CONFIGURATION_CANCELED: {
        name: 'llm-configuration-canceled',
        tags: ['llm'],
    },
    LIVEBOARD_PV_CLICK_VIEWLIST: {
        name: 'click-viewlist',
        tags: ['liveboard-personalized-views'],
    },
    LIVEBOARD_PV_VIEW_CLICKED: {
        name: 'view-clicked',
        tags: ['liveboard-personalized-views'],
    },
    LIVEBOARD_PV_DELETE_VIEW: {
        name: 'delete-view',
        tags: ['liveboard-personalized-views'],
    },
    LIVEBOARD_PV_UPDATE_VIEW_PRIVACY: {
        name: 'update-view-privacy',
        tags: ['liveboard-personalized-views'],
    },
    LIVEBOARD_PV_CLOSE_MANAGEVIEW_MODAL: {
        name: 'close-manageview-modal',
        tags: ['liveboard-personalized-views'],
    },
    ENABLE_VERSION_CONTROL: {
        name: 'git-enable-version-control',
        tags: [],
    },
    DISABLE_VERSION_CONTROL: {
        name: 'git-disable-version-control',
        tags: [],
    },
    SHOW_VERSION_HISTORY: {
        name: 'git-show-version-history',
        tags: [],
    },
    ALL_VERSIONS_MODAL_OPEN_BUTTON: {
        name: 'git-all-versions',
        tags: [],
    },
    SHOW_MY_VERSIONS_TOGGLE: {
        name: 'git-show-my-versions',
        tags: [],
    },
    ALL_VERSIONS_SEARCH: {
        name: 'git-search-all-versions',
        tags: [],
    },
    PREVIEW_BUTTON_CLICK: {
        name: 'git-preview-version',
        tags: [],
    },
    CLOSE_ALL_VERSIONS_MODAL: {
        name: 'git-close-all-versions-modal',
        tags: [],
    },
    CLOSE_VERSION_HISTORY: {
        name: 'git-close-version-history',
        tags: [],
    },
    RESTORE_VERSION: {
        name: 'git-restore-version',
        tags: [],
    },
    PREVIEW_VERSION_TAB_ITEM_CLICKED: {
        name: 'git-preview-main-modal',
        tags: [],
    },
    PREVIEW_STATUS: {
        name: 'git-preview-status',
        tags: [],
    },
    RESTORE_STATUS: {
        name: 'git-restore-version-status',
        tags: [],
    },
    VERSIONING_STATUS: {
        name: 'git-version-control-availability-status',
        tags: [],
    },
    MFE_LOADED: {
        name: 'mfe-running-on-browser',
        tags: [],
    },
    KPI_COMPARISON_TYPE: {
        name: 'kpi-comparison-type',
        tags: [],
    },
    NOTETILE_TOOLBAR_CLICKED: {
        name: 'user-click-toolbar',
        tags: [],
    },
    NOTETILE_DIVIDER_ADDED: {
        name: 'add-horizontal-divider-to-note',
        tags: [],
    },
    NOTETILE_TEXT_STYLE_SELECTED: {
        name: 'text-style-selected',
        tags: [],
    },
    FEATURE_SERVICE_FLAGS_INIT: {
        name: 'feature-service-flags-init',
        tags: ['fe-bootstrap'],
    },
    MIXPANEL_CLS: {
        name: 'mixpanel-CLS',
        tags: [],
    },
    MIXPANEL_FID: {
        name: 'mixpanel-FID',
        tags: [],
    },
    MIXPANEL_FCP: {
        name: 'mixpanel-FCP',
        tags: [],
    },
    MIXPANEL_LCP: {
        name: 'mixpanel-LCP',
        tags: [],
    },
    MIXPANEL_TTFB: {
        name: 'mixpanel-TTFB',
        tags: [],
    },
    TOGGLE_BLOCK_NON_EMBED_ACCESS: {
        name: 'toggle-block-non-embed-access',
        tags: ['selective-user-access'],
    },
    ADVANCED_SETTINGS_MODAL_OPEN_SECURITY_SETTINGS: {
        name: 'advanced-settings-modal-open-security-settings',
        tags: ['selective-user-access'],
    },
    ADVANCED_SETTINGS_MODAL_SAVE_SECURITY_SETTINGS: {
        name: 'advanced-settings-modal-save-security-settings',
        tags: ['selective-user-access'],
    },
    ADVANCED_SETTINGS_MODAL_CANCEL_SECURITY_SETTINGS: {
        name: 'advanced-settings-modal-cancel-security-settings',
        tags: ['selective-user-access'],
    },
    CUSTOM_CHART_ADDED: {
        name: 'custom-chart-added',
        tags: [],
    },
    ADD_CHART_BUTTON: {
        name: 'add-chart-button',
        tags: [],
    },
    EDIT_CHART_BUTTON: {
        name: 'edit-chart-button',
        tags: [],
    },
    DELETE_CHART_BUTTON: {
        name: 'delete-chart-button',
        tags: [],
    },
    TOGGLE_EMBED_CUSTOMER_GUIDE: {
        name: 'toggle-embed-customer-guide',
        tags: ['embed-customer-guide'],
    },
};
export class UserAction {
    constructor(userActionType, params) {
        this.name = userActionTypes[userActionType].name;
        this.tags = userActionTypes[userActionType].tags;
        this.type = userActionType;
        this.shouldSendEventToExperimentationService =
            userActionTypes[userActionType].shouldSendEventToExperimentationService;
        this.experimentationProject =
            userActionTypes[userActionType].experimentationProject;
        if (params) {
            this.messageParams = params.messageParams;
            this.tags = _.union([this.tags, params.messageParams]);
        }
    }
}
const userActionTypeEnum = {};
Object.keys(userActionTypes).forEach(function (key) {
    UserAction[key] = key;
    userActionTypeEnum[key] = key;
});
export { userActionTypeEnum, userActionTypes };
//# sourceMappingURL=user-action.js.map